
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4654"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4654"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aTfbO", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7edad2c4d6f82464$export$ffb0004e005737fa, (v) => $7edad2c4d6f82464$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7edad2c4d6f82464$export$34b9dba7ce09269b, (v) => $7edad2c4d6f82464$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7edad2c4d6f82464$export$25062201e9e25d76, (v) => $7edad2c4d6f82464$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7edad2c4d6f82464$export$ffb0004e005737fa;
var $7edad2c4d6f82464$export$34b9dba7ce09269b;
var $7edad2c4d6f82464$export$25062201e9e25d76;
'use strict';
parcelRequire("hGkkX");

var $boE4X = parcelRequire("boE4X");
var $7edad2c4d6f82464$var$g = 60103;
$7edad2c4d6f82464$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $7edad2c4d6f82464$var$h = Symbol.for;
    $7edad2c4d6f82464$var$g = $7edad2c4d6f82464$var$h("react.element");
    $7edad2c4d6f82464$export$ffb0004e005737fa = $7edad2c4d6f82464$var$h("react.fragment");
}
var $7edad2c4d6f82464$var$m = $boE4X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7edad2c4d6f82464$var$n = Object.prototype.hasOwnProperty, $7edad2c4d6f82464$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7edad2c4d6f82464$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$7edad2c4d6f82464$var$n.call(a, b) && !$7edad2c4d6f82464$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7edad2c4d6f82464$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $7edad2c4d6f82464$var$m.current
    };
}
$7edad2c4d6f82464$export$34b9dba7ce09269b = $7edad2c4d6f82464$var$q;
$7edad2c4d6f82464$export$25062201e9e25d76 = $7edad2c4d6f82464$var$q;

});
parcelRegister("hGkkX", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $cdf622664be6710e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $cdf622664be6710e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cdf622664be6710e$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $cdf622664be6710e$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $cdf622664be6710e$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $cdf622664be6710e$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $cdf622664be6710e$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($cdf622664be6710e$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($cdf622664be6710e$var$getOwnPropertySymbols) {
            symbols = $cdf622664be6710e$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($cdf622664be6710e$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("boE4X", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8HsEU"));

});
parcelRegister("8HsEU", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $655891e8e4b7e512$export$ffb0004e005737fa, (v) => $655891e8e4b7e512$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $655891e8e4b7e512$export$5f8d39834fd61797, (v) => $655891e8e4b7e512$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $655891e8e4b7e512$export$e2c29f18771995cb, (v) => $655891e8e4b7e512$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $655891e8e4b7e512$export$74bf444e3cd11ea5, (v) => $655891e8e4b7e512$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $655891e8e4b7e512$export$dca3b0875bd9a954, (v) => $655891e8e4b7e512$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $655891e8e4b7e512$export$16fa2f45be04daa8, (v) => $655891e8e4b7e512$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $655891e8e4b7e512$export$221d75b3f55bb0bd, (v) => $655891e8e4b7e512$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $655891e8e4b7e512$export$ae55be85d98224ed, (v) => $655891e8e4b7e512$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $655891e8e4b7e512$export$e530037191fcd5d7, (v) => $655891e8e4b7e512$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $655891e8e4b7e512$export$fd42f52fd3ae1109, (v) => $655891e8e4b7e512$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $655891e8e4b7e512$export$c8a8987d4410bf2d, (v) => $655891e8e4b7e512$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $655891e8e4b7e512$export$d38cd72104c1f0e9, (v) => $655891e8e4b7e512$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $655891e8e4b7e512$export$7d1e3a5e95ceca43, (v) => $655891e8e4b7e512$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $655891e8e4b7e512$export$257a8862b851cb5b, (v) => $655891e8e4b7e512$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $655891e8e4b7e512$export$a8257692ac88316c, (v) => $655891e8e4b7e512$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $655891e8e4b7e512$export$488013bae63b21da, (v) => $655891e8e4b7e512$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $655891e8e4b7e512$export$7c73462e0d25e514, (v) => $655891e8e4b7e512$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $655891e8e4b7e512$export$35808ee640e87ca7, (v) => $655891e8e4b7e512$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $655891e8e4b7e512$export$fae74005e78b1a27, (v) => $655891e8e4b7e512$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $655891e8e4b7e512$export$dc8fbce3eb94dc1e, (v) => $655891e8e4b7e512$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $655891e8e4b7e512$export$6d9c69b0de29b591, (v) => $655891e8e4b7e512$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $655891e8e4b7e512$export$d5a552a76deda3c2, (v) => $655891e8e4b7e512$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $655891e8e4b7e512$export$e5c5a5f917a5871c, (v) => $655891e8e4b7e512$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $655891e8e4b7e512$export$1538c33de8887b59, (v) => $655891e8e4b7e512$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $655891e8e4b7e512$export$13e3392192263954, (v) => $655891e8e4b7e512$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $655891e8e4b7e512$export$b8f5890fc79d6aca, (v) => $655891e8e4b7e512$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $655891e8e4b7e512$export$60241385465d0a34, (v) => $655891e8e4b7e512$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $655891e8e4b7e512$export$83d89fbfd8236492, (v) => $655891e8e4b7e512$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $655891e8e4b7e512$export$ffb0004e005737fa;
var $655891e8e4b7e512$export$5f8d39834fd61797;
var $655891e8e4b7e512$export$e2c29f18771995cb;
var $655891e8e4b7e512$export$74bf444e3cd11ea5;
var $655891e8e4b7e512$export$dca3b0875bd9a954;
var $655891e8e4b7e512$export$16fa2f45be04daa8;
var $655891e8e4b7e512$export$221d75b3f55bb0bd;
var $655891e8e4b7e512$export$ae55be85d98224ed;
var $655891e8e4b7e512$export$e530037191fcd5d7;
var $655891e8e4b7e512$export$fd42f52fd3ae1109;
var $655891e8e4b7e512$export$c8a8987d4410bf2d;
var $655891e8e4b7e512$export$d38cd72104c1f0e9;
var $655891e8e4b7e512$export$7d1e3a5e95ceca43;
var $655891e8e4b7e512$export$257a8862b851cb5b;
var $655891e8e4b7e512$export$a8257692ac88316c;
var $655891e8e4b7e512$export$488013bae63b21da;
var $655891e8e4b7e512$export$7c73462e0d25e514;
var $655891e8e4b7e512$export$35808ee640e87ca7;
var $655891e8e4b7e512$export$fae74005e78b1a27;
var $655891e8e4b7e512$export$dc8fbce3eb94dc1e;
var $655891e8e4b7e512$export$6d9c69b0de29b591;
var $655891e8e4b7e512$export$d5a552a76deda3c2;
var $655891e8e4b7e512$export$e5c5a5f917a5871c;
var $655891e8e4b7e512$export$1538c33de8887b59;
var $655891e8e4b7e512$export$13e3392192263954;
var $655891e8e4b7e512$export$b8f5890fc79d6aca;
var $655891e8e4b7e512$export$60241385465d0a34;
var $655891e8e4b7e512$export$83d89fbfd8236492;
'use strict';

var $hGkkX = parcelRequire("hGkkX");
var $655891e8e4b7e512$var$n = 60103, $655891e8e4b7e512$var$p = 60106;
$655891e8e4b7e512$export$ffb0004e005737fa = 60107;
$655891e8e4b7e512$export$5f8d39834fd61797 = 60108;
$655891e8e4b7e512$export$e2c29f18771995cb = 60114;
var $655891e8e4b7e512$var$q = 60109, $655891e8e4b7e512$var$r = 60110, $655891e8e4b7e512$var$t = 60112;
$655891e8e4b7e512$export$74bf444e3cd11ea5 = 60113;
var $655891e8e4b7e512$var$u = 60115, $655891e8e4b7e512$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $655891e8e4b7e512$var$w = Symbol.for;
    $655891e8e4b7e512$var$n = $655891e8e4b7e512$var$w("react.element");
    $655891e8e4b7e512$var$p = $655891e8e4b7e512$var$w("react.portal");
    $655891e8e4b7e512$export$ffb0004e005737fa = $655891e8e4b7e512$var$w("react.fragment");
    $655891e8e4b7e512$export$5f8d39834fd61797 = $655891e8e4b7e512$var$w("react.strict_mode");
    $655891e8e4b7e512$export$e2c29f18771995cb = $655891e8e4b7e512$var$w("react.profiler");
    $655891e8e4b7e512$var$q = $655891e8e4b7e512$var$w("react.provider");
    $655891e8e4b7e512$var$r = $655891e8e4b7e512$var$w("react.context");
    $655891e8e4b7e512$var$t = $655891e8e4b7e512$var$w("react.forward_ref");
    $655891e8e4b7e512$export$74bf444e3cd11ea5 = $655891e8e4b7e512$var$w("react.suspense");
    $655891e8e4b7e512$var$u = $655891e8e4b7e512$var$w("react.memo");
    $655891e8e4b7e512$var$v = $655891e8e4b7e512$var$w("react.lazy");
}
var $655891e8e4b7e512$var$x = "function" === typeof Symbol && Symbol.iterator;
function $655891e8e4b7e512$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $655891e8e4b7e512$var$x && a[$655891e8e4b7e512$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $655891e8e4b7e512$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $655891e8e4b7e512$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $655891e8e4b7e512$var$B = {};
function $655891e8e4b7e512$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $655891e8e4b7e512$var$B;
    this.updater = c || $655891e8e4b7e512$var$A;
}
$655891e8e4b7e512$var$C.prototype.isReactComponent = {};
$655891e8e4b7e512$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($655891e8e4b7e512$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$655891e8e4b7e512$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $655891e8e4b7e512$var$D() {}
$655891e8e4b7e512$var$D.prototype = $655891e8e4b7e512$var$C.prototype;
function $655891e8e4b7e512$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $655891e8e4b7e512$var$B;
    this.updater = c || $655891e8e4b7e512$var$A;
}
var $655891e8e4b7e512$var$F = $655891e8e4b7e512$var$E.prototype = new $655891e8e4b7e512$var$D;
$655891e8e4b7e512$var$F.constructor = $655891e8e4b7e512$var$E;
$hGkkX($655891e8e4b7e512$var$F, $655891e8e4b7e512$var$C.prototype);
$655891e8e4b7e512$var$F.isPureReactComponent = !0;
var $655891e8e4b7e512$var$G = {
    current: null
}, $655891e8e4b7e512$var$H = Object.prototype.hasOwnProperty, $655891e8e4b7e512$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $655891e8e4b7e512$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$655891e8e4b7e512$var$H.call(b, e) && !$655891e8e4b7e512$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $655891e8e4b7e512$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $655891e8e4b7e512$var$G.current
    };
}
function $655891e8e4b7e512$var$K(a, b) {
    return {
        $$typeof: $655891e8e4b7e512$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $655891e8e4b7e512$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $655891e8e4b7e512$var$n;
}
function $655891e8e4b7e512$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $655891e8e4b7e512$var$M = /\/+/g;
function $655891e8e4b7e512$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $655891e8e4b7e512$var$escape("" + a.key) : b.toString(36);
}
function $655891e8e4b7e512$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $655891e8e4b7e512$var$n:
                case $655891e8e4b7e512$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $655891e8e4b7e512$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($655891e8e4b7e512$var$M, "$&/") + "/"), $655891e8e4b7e512$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($655891e8e4b7e512$var$L(d) && (d = $655891e8e4b7e512$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($655891e8e4b7e512$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $655891e8e4b7e512$var$N(k, g);
        h += $655891e8e4b7e512$var$O(k, b, c, f, d);
    }
    else if (f = $655891e8e4b7e512$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $655891e8e4b7e512$var$N(k, g++), h += $655891e8e4b7e512$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($655891e8e4b7e512$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $655891e8e4b7e512$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $655891e8e4b7e512$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $655891e8e4b7e512$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $655891e8e4b7e512$var$R = {
    current: null
};
function $655891e8e4b7e512$var$S() {
    var a = $655891e8e4b7e512$var$R.current;
    if (null === a) throw Error($655891e8e4b7e512$var$z(321));
    return a;
}
var $655891e8e4b7e512$var$T = {
    ReactCurrentDispatcher: $655891e8e4b7e512$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $655891e8e4b7e512$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $hGkkX
};
$655891e8e4b7e512$export$dca3b0875bd9a954 = {
    map: $655891e8e4b7e512$var$P,
    forEach: function(a, b, c) {
        $655891e8e4b7e512$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $655891e8e4b7e512$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $655891e8e4b7e512$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$655891e8e4b7e512$var$L(a)) throw Error($655891e8e4b7e512$var$z(143));
        return a;
    }
};
$655891e8e4b7e512$export$16fa2f45be04daa8 = $655891e8e4b7e512$var$C;
$655891e8e4b7e512$export$221d75b3f55bb0bd = $655891e8e4b7e512$var$E;
$655891e8e4b7e512$export$ae55be85d98224ed = $655891e8e4b7e512$var$T;
$655891e8e4b7e512$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($655891e8e4b7e512$var$z(267, a));
    var e = $hGkkX({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $655891e8e4b7e512$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$655891e8e4b7e512$var$H.call(b, f) && !$655891e8e4b7e512$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $655891e8e4b7e512$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$655891e8e4b7e512$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $655891e8e4b7e512$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $655891e8e4b7e512$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$655891e8e4b7e512$export$c8a8987d4410bf2d = $655891e8e4b7e512$var$J;
$655891e8e4b7e512$export$d38cd72104c1f0e9 = function(a) {
    var b = $655891e8e4b7e512$var$J.bind(null, a);
    b.type = a;
    return b;
};
$655891e8e4b7e512$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$655891e8e4b7e512$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $655891e8e4b7e512$var$t,
        render: a
    };
};
$655891e8e4b7e512$export$a8257692ac88316c = $655891e8e4b7e512$var$L;
$655891e8e4b7e512$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $655891e8e4b7e512$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $655891e8e4b7e512$var$Q
    };
};
$655891e8e4b7e512$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $655891e8e4b7e512$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$655891e8e4b7e512$export$35808ee640e87ca7 = function(a, b) {
    return $655891e8e4b7e512$var$S().useCallback(a, b);
};
$655891e8e4b7e512$export$fae74005e78b1a27 = function(a, b) {
    return $655891e8e4b7e512$var$S().useContext(a, b);
};
$655891e8e4b7e512$export$dc8fbce3eb94dc1e = function() {};
$655891e8e4b7e512$export$6d9c69b0de29b591 = function(a, b) {
    return $655891e8e4b7e512$var$S().useEffect(a, b);
};
$655891e8e4b7e512$export$d5a552a76deda3c2 = function(a, b, c) {
    return $655891e8e4b7e512$var$S().useImperativeHandle(a, b, c);
};
$655891e8e4b7e512$export$e5c5a5f917a5871c = function(a, b) {
    return $655891e8e4b7e512$var$S().useLayoutEffect(a, b);
};
$655891e8e4b7e512$export$1538c33de8887b59 = function(a, b) {
    return $655891e8e4b7e512$var$S().useMemo(a, b);
};
$655891e8e4b7e512$export$13e3392192263954 = function(a, b, c) {
    return $655891e8e4b7e512$var$S().useReducer(a, b, c);
};
$655891e8e4b7e512$export$b8f5890fc79d6aca = function(a) {
    return $655891e8e4b7e512$var$S().useRef(a);
};
$655891e8e4b7e512$export$60241385465d0a34 = function(a) {
    return $655891e8e4b7e512$var$S().useState(a);
};
$655891e8e4b7e512$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("eGsbu", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $boE4X = parcelRequire("boE4X");

var $hGkkX = parcelRequire("hGkkX");

var $8fPC4 = parcelRequire("8fPC4");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$boE4X) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $boE4X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $hGkkX({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $boE4X.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $hGkkX({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $hGkkX({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $hGkkX({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $8fPC4.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $8fPC4.unstable_scheduleCallback($8fPC4.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $8fPC4.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $8fPC4.unstable_UserBlockingPriority, ed = $8fPC4.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $hGkkX(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $hGkkX({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $hGkkX({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $hGkkX({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $hGkkX({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $hGkkX({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $hGkkX({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $hGkkX({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $hGkkX({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $hGkkX({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $hGkkX({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $hGkkX({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $hGkkX({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $hGkkX({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $8fPC4.unstable_runWithPriority, Of = $8fPC4.unstable_scheduleCallback, Pf = $8fPC4.unstable_cancelCallback, Qf = $8fPC4.unstable_shouldYield, Rf = $8fPC4.unstable_requestPaint, Sf = $8fPC4.unstable_now, Tf = $8fPC4.unstable_getCurrentPriorityLevel, Uf = $8fPC4.unstable_ImmediatePriority, Vf = $8fPC4.unstable_UserBlockingPriority, Wf = $8fPC4.unstable_NormalPriority, Xf = $8fPC4.unstable_LowPriority, Yf = $8fPC4.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $hGkkX({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $hGkkX({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $boE4X.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $hGkkX({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $hGkkX({}, e, {
                    value: void 0
                });
                d = $hGkkX({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $hGkkX({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("8fPC4", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iui2b"));

});
parcelRegister("iui2b", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $d7590492a6677745$export$c4744153514ff05d, (v) => $d7590492a6677745$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $d7590492a6677745$export$b5836b71941fa3ed, (v) => $d7590492a6677745$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $d7590492a6677745$export$d66a1c1c77bd778b, (v) => $d7590492a6677745$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $d7590492a6677745$export$3e506c1ccc9cc1a7, (v) => $d7590492a6677745$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $d7590492a6677745$export$e26fe2ed2fa76875, (v) => $d7590492a6677745$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $d7590492a6677745$export$502329bbf4b505b1, (v) => $d7590492a6677745$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $d7590492a6677745$export$6e3807111c4874c4, (v) => $d7590492a6677745$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $d7590492a6677745$export$c27134553091fb3a, (v) => $d7590492a6677745$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $d7590492a6677745$export$33ee1acdc04fd2a2, (v) => $d7590492a6677745$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $d7590492a6677745$export$b00a404bbd5edef2, (v) => $d7590492a6677745$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $d7590492a6677745$export$8352ce38b91d0c62, (v) => $d7590492a6677745$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $d7590492a6677745$export$d3dfb8e4810cb555, (v) => $d7590492a6677745$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $d7590492a6677745$export$839f9183b0465a69, (v) => $d7590492a6677745$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $d7590492a6677745$export$72fdf0e06517287b, (v) => $d7590492a6677745$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $d7590492a6677745$export$4b844e58a3e414b4, (v) => $d7590492a6677745$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $d7590492a6677745$export$816d2913ae6b83b1, (v) => $d7590492a6677745$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $d7590492a6677745$export$61bcfe829111a1d0, (v) => $d7590492a6677745$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $d7590492a6677745$export$7ee8c9beb337bc3f, (v) => $d7590492a6677745$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $d7590492a6677745$export$cf845f2c119da08a, (v) => $d7590492a6677745$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7590492a6677745$export$c4744153514ff05d;
var $d7590492a6677745$export$b5836b71941fa3ed;
var $d7590492a6677745$export$d66a1c1c77bd778b;
var $d7590492a6677745$export$3e506c1ccc9cc1a7;
var $d7590492a6677745$export$e26fe2ed2fa76875;
var $d7590492a6677745$export$502329bbf4b505b1;
var $d7590492a6677745$export$6e3807111c4874c4;
var $d7590492a6677745$export$c27134553091fb3a;
var $d7590492a6677745$export$33ee1acdc04fd2a2;
var $d7590492a6677745$export$b00a404bbd5edef2;
var $d7590492a6677745$export$8352ce38b91d0c62;
var $d7590492a6677745$export$d3dfb8e4810cb555;
var $d7590492a6677745$export$839f9183b0465a69;
var $d7590492a6677745$export$72fdf0e06517287b;
var $d7590492a6677745$export$4b844e58a3e414b4;
var $d7590492a6677745$export$816d2913ae6b83b1;
var $d7590492a6677745$export$61bcfe829111a1d0;
var $d7590492a6677745$export$7ee8c9beb337bc3f;
var $d7590492a6677745$export$cf845f2c119da08a;
'use strict';
var $d7590492a6677745$var$f, $d7590492a6677745$var$g, $d7590492a6677745$var$h, $d7590492a6677745$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d7590492a6677745$var$l = performance;
    $d7590492a6677745$export$c4744153514ff05d = function() {
        return $d7590492a6677745$var$l.now();
    };
} else {
    var $d7590492a6677745$var$p = Date, $d7590492a6677745$var$q = $d7590492a6677745$var$p.now();
    $d7590492a6677745$export$c4744153514ff05d = function() {
        return $d7590492a6677745$var$p.now() - $d7590492a6677745$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $d7590492a6677745$var$t = null, $d7590492a6677745$var$u = null, $d7590492a6677745$var$w = function() {
        if (null !== $d7590492a6677745$var$t) try {
            var a = $d7590492a6677745$export$c4744153514ff05d();
            $d7590492a6677745$var$t(!0, a);
            $d7590492a6677745$var$t = null;
        } catch (b) {
            throw setTimeout($d7590492a6677745$var$w, 0), b;
        }
    };
    $d7590492a6677745$var$f = function(a) {
        null !== $d7590492a6677745$var$t ? setTimeout($d7590492a6677745$var$f, 0, a) : ($d7590492a6677745$var$t = a, setTimeout($d7590492a6677745$var$w, 0));
    };
    $d7590492a6677745$var$g = function(a, b) {
        $d7590492a6677745$var$u = setTimeout(a, b);
    };
    $d7590492a6677745$var$h = function() {
        clearTimeout($d7590492a6677745$var$u);
    };
    $d7590492a6677745$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $d7590492a6677745$var$k = $d7590492a6677745$export$d66a1c1c77bd778b = function() {};
} else {
    var $d7590492a6677745$var$x = window.setTimeout, $d7590492a6677745$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $d7590492a6677745$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $d7590492a6677745$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $d7590492a6677745$var$A = !1, $d7590492a6677745$var$B = null, $d7590492a6677745$var$C = -1, $d7590492a6677745$var$D = 5, $d7590492a6677745$var$E = 0;
    $d7590492a6677745$export$b5836b71941fa3ed = function() {
        return $d7590492a6677745$export$c4744153514ff05d() >= $d7590492a6677745$var$E;
    };
    $d7590492a6677745$var$k = function() {};
    $d7590492a6677745$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d7590492a6677745$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $d7590492a6677745$var$F = new MessageChannel, $d7590492a6677745$var$G = $d7590492a6677745$var$F.port2;
    $d7590492a6677745$var$F.port1.onmessage = function() {
        if (null !== $d7590492a6677745$var$B) {
            var a = $d7590492a6677745$export$c4744153514ff05d();
            $d7590492a6677745$var$E = a + $d7590492a6677745$var$D;
            try {
                $d7590492a6677745$var$B(!0, a) ? $d7590492a6677745$var$G.postMessage(null) : ($d7590492a6677745$var$A = !1, $d7590492a6677745$var$B = null);
            } catch (b) {
                throw $d7590492a6677745$var$G.postMessage(null), b;
            }
        } else $d7590492a6677745$var$A = !1;
    };
    $d7590492a6677745$var$f = function(a) {
        $d7590492a6677745$var$B = a;
        $d7590492a6677745$var$A || ($d7590492a6677745$var$A = !0, $d7590492a6677745$var$G.postMessage(null));
    };
    $d7590492a6677745$var$g = function(a, b) {
        $d7590492a6677745$var$C = $d7590492a6677745$var$x(function() {
            a($d7590492a6677745$export$c4744153514ff05d());
        }, b);
    };
    $d7590492a6677745$var$h = function() {
        $d7590492a6677745$var$y($d7590492a6677745$var$C);
        $d7590492a6677745$var$C = -1;
    };
}
function $d7590492a6677745$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $d7590492a6677745$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d7590492a6677745$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $d7590492a6677745$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $d7590492a6677745$var$I(n, c)) void 0 !== r && 0 > $d7590492a6677745$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $d7590492a6677745$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $d7590492a6677745$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $d7590492a6677745$var$L = [], $d7590492a6677745$var$M = [], $d7590492a6677745$var$N = 1, $d7590492a6677745$var$O = null, $d7590492a6677745$var$P = 3, $d7590492a6677745$var$Q = !1, $d7590492a6677745$var$R = !1, $d7590492a6677745$var$S = !1;
function $d7590492a6677745$var$T(a) {
    for(var b = $d7590492a6677745$var$J($d7590492a6677745$var$M); null !== b;){
        if (null === b.callback) $d7590492a6677745$var$K($d7590492a6677745$var$M);
        else if (b.startTime <= a) $d7590492a6677745$var$K($d7590492a6677745$var$M), b.sortIndex = b.expirationTime, $d7590492a6677745$var$H($d7590492a6677745$var$L, b);
        else break;
        b = $d7590492a6677745$var$J($d7590492a6677745$var$M);
    }
}
function $d7590492a6677745$var$U(a) {
    $d7590492a6677745$var$S = !1;
    $d7590492a6677745$var$T(a);
    if (!$d7590492a6677745$var$R) {
        if (null !== $d7590492a6677745$var$J($d7590492a6677745$var$L)) $d7590492a6677745$var$R = !0, $d7590492a6677745$var$f($d7590492a6677745$var$V);
        else {
            var b = $d7590492a6677745$var$J($d7590492a6677745$var$M);
            null !== b && $d7590492a6677745$var$g($d7590492a6677745$var$U, b.startTime - a);
        }
    }
}
function $d7590492a6677745$var$V(a, b) {
    $d7590492a6677745$var$R = !1;
    $d7590492a6677745$var$S && ($d7590492a6677745$var$S = !1, $d7590492a6677745$var$h());
    $d7590492a6677745$var$Q = !0;
    var c = $d7590492a6677745$var$P;
    try {
        $d7590492a6677745$var$T(b);
        for($d7590492a6677745$var$O = $d7590492a6677745$var$J($d7590492a6677745$var$L); null !== $d7590492a6677745$var$O && (!($d7590492a6677745$var$O.expirationTime > b) || a && !$d7590492a6677745$export$b5836b71941fa3ed());){
            var d = $d7590492a6677745$var$O.callback;
            if ("function" === typeof d) {
                $d7590492a6677745$var$O.callback = null;
                $d7590492a6677745$var$P = $d7590492a6677745$var$O.priorityLevel;
                var e = d($d7590492a6677745$var$O.expirationTime <= b);
                b = $d7590492a6677745$export$c4744153514ff05d();
                "function" === typeof e ? $d7590492a6677745$var$O.callback = e : $d7590492a6677745$var$O === $d7590492a6677745$var$J($d7590492a6677745$var$L) && $d7590492a6677745$var$K($d7590492a6677745$var$L);
                $d7590492a6677745$var$T(b);
            } else $d7590492a6677745$var$K($d7590492a6677745$var$L);
            $d7590492a6677745$var$O = $d7590492a6677745$var$J($d7590492a6677745$var$L);
        }
        if (null !== $d7590492a6677745$var$O) var m = !0;
        else {
            var n = $d7590492a6677745$var$J($d7590492a6677745$var$M);
            null !== n && $d7590492a6677745$var$g($d7590492a6677745$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $d7590492a6677745$var$O = null, $d7590492a6677745$var$P = c, $d7590492a6677745$var$Q = !1;
    }
}
var $d7590492a6677745$var$W = $d7590492a6677745$var$k;
$d7590492a6677745$export$3e506c1ccc9cc1a7 = 5;
$d7590492a6677745$export$e26fe2ed2fa76875 = 1;
$d7590492a6677745$export$502329bbf4b505b1 = 4;
$d7590492a6677745$export$6e3807111c4874c4 = 3;
$d7590492a6677745$export$c27134553091fb3a = null;
$d7590492a6677745$export$33ee1acdc04fd2a2 = 2;
$d7590492a6677745$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d7590492a6677745$export$8352ce38b91d0c62 = function() {
    $d7590492a6677745$var$R || $d7590492a6677745$var$Q || ($d7590492a6677745$var$R = !0, $d7590492a6677745$var$f($d7590492a6677745$var$V));
};
$d7590492a6677745$export$d3dfb8e4810cb555 = function() {
    return $d7590492a6677745$var$P;
};
$d7590492a6677745$export$839f9183b0465a69 = function() {
    return $d7590492a6677745$var$J($d7590492a6677745$var$L);
};
$d7590492a6677745$export$72fdf0e06517287b = function(a) {
    switch($d7590492a6677745$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d7590492a6677745$var$P;
    }
    var c = $d7590492a6677745$var$P;
    $d7590492a6677745$var$P = b;
    try {
        return a();
    } finally{
        $d7590492a6677745$var$P = c;
    }
};
$d7590492a6677745$export$4b844e58a3e414b4 = function() {};
$d7590492a6677745$export$816d2913ae6b83b1 = $d7590492a6677745$var$W;
$d7590492a6677745$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d7590492a6677745$var$P;
    $d7590492a6677745$var$P = a;
    try {
        return b();
    } finally{
        $d7590492a6677745$var$P = c;
    }
};
$d7590492a6677745$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d7590492a6677745$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d7590492a6677745$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d7590492a6677745$var$H($d7590492a6677745$var$M, a), null === $d7590492a6677745$var$J($d7590492a6677745$var$L) && a === $d7590492a6677745$var$J($d7590492a6677745$var$M) && ($d7590492a6677745$var$S ? $d7590492a6677745$var$h() : $d7590492a6677745$var$S = !0, $d7590492a6677745$var$g($d7590492a6677745$var$U, c - d))) : (a.sortIndex = e, $d7590492a6677745$var$H($d7590492a6677745$var$L, a), $d7590492a6677745$var$R || $d7590492a6677745$var$Q || ($d7590492a6677745$var$R = !0, $d7590492a6677745$var$f($d7590492a6677745$var$V)));
    return a;
};
$d7590492a6677745$export$cf845f2c119da08a = function(a) {
    var b = $d7590492a6677745$var$P;
    return function() {
        var c = $d7590492a6677745$var$P;
        $d7590492a6677745$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d7590492a6677745$var$P = c;
        }
    };
};

});



var $2b9e21b4a13fb787$exports = {};
'use strict';

$2b9e21b4a13fb787$exports = (parcelRequire("aTfbO"));


parcelRequire("boE4X");
var $49f04caac7e99876$exports = {};
'use strict';
function $49f04caac7e99876$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($49f04caac7e99876$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$49f04caac7e99876$var$checkDCE();

$49f04caac7e99876$exports = (parcelRequire("eGsbu"));




var $boE4X = parcelRequire("boE4X");

var $boE4X = parcelRequire("boE4X");
//#region src/utils/createId.ts
/**
* Creates a unique id to distinguish parallax elements.
*/ let $3e4beb9e5f6bb1f4$var$id = 0;
function $3e4beb9e5f6bb1f4$var$createId() {
    ++$3e4beb9e5f6bb1f4$var$id;
    return $3e4beb9e5f6bb1f4$var$id;
}
//#endregion
//#region src/helpers/measureRect.ts
function $3e4beb9e5f6bb1f4$var$getScrollOffset(view) {
    const container = view.scrollContainer;
    if (container) return {
        y: container.scrollTop,
        x: container.scrollLeft
    };
    if (typeof window !== "undefined") {
        const doc = document.documentElement;
        return {
            y: window.scrollY ?? doc.scrollTop,
            x: window.scrollX ?? doc.scrollLeft
        };
    }
    return {
        y: 0,
        x: 0
    };
}
/**
* Pure DOM measurement: viewport-relative bounds adjusted for a scroll container,
* plus offset metrics from layout.
*/ function $3e4beb9e5f6bb1f4$var$measureRect(el, view) {
    let rect = el.getBoundingClientRect();
    if (view.scrollContainer) {
        const scrollRect = view.scrollContainer.getBoundingClientRect();
        rect = {
            ...rect,
            top: rect.top - scrollRect.top,
            right: rect.right - scrollRect.left,
            bottom: rect.bottom - scrollRect.top,
            left: rect.left - scrollRect.left
        };
    }
    const offsetHeight = el.offsetHeight;
    const offsetWidth = el.offsetWidth;
    const offsetTop = el.offsetTop;
    const offsetLeft = el.offsetLeft;
    const offsetBottom = offsetHeight + offsetTop;
    const offsetRight = offsetWidth + offsetLeft;
    const scroll = $3e4beb9e5f6bb1f4$var$getScrollOffset(view);
    const contentTop = scroll.y + rect.top;
    const contentLeft = scroll.x + rect.left;
    const contentBottom = scroll.y + rect.bottom;
    const contentRight = scroll.x + rect.right;
    return {
        height: offsetHeight,
        width: offsetWidth,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
        offsetTop: offsetTop,
        offsetLeft: offsetLeft,
        offsetBottom: offsetBottom,
        offsetRight: offsetRight,
        contentTop: contentTop,
        contentLeft: contentLeft,
        contentBottom: contentBottom,
        contentRight: contentRight
    };
}
//#endregion
//#region src/classes/View.ts
var $3e4beb9e5f6bb1f4$var$View = class {
    scrollContainer;
    width;
    height;
    scrollHeight;
    scrollWidth;
    constructor(config){
        this.scrollContainer = config.scrollContainer;
        this.width = config.width;
        this.height = config.height;
        this.scrollHeight = config.scrollHeight;
        this.scrollWidth = config.scrollWidth;
    }
    hasChanged(params) {
        if (params.width !== this.width || params.height !== this.height || params.scrollWidth !== this.scrollWidth || params.scrollHeight !== this.scrollHeight) return true;
        return false;
    }
    setSize(params) {
        this.width = params.width;
        this.height = params.height;
        this.scrollHeight = params.scrollHeight;
        this.scrollWidth = params.scrollWidth;
        return this;
    }
};
//#endregion
//#region src/types.ts
let $3e4beb9e5f6bb1f4$export$dd3b792fda2f69f8 = /* @__PURE__ */ function(Units) {
    Units["px"] = "px";
    Units["%"] = "%";
    Units["vw"] = "vw";
    Units["vh"] = "vh";
    return Units;
}({});
let $3e4beb9e5f6bb1f4$export$8cb8b2cea11e53d2 = /* @__PURE__ */ function(ScrollAxis) {
    ScrollAxis["vertical"] = "vertical";
    ScrollAxis["horizontal"] = "horizontal";
    return ScrollAxis;
}({});
//#endregion
//#region src/utils/parseValueAndUnit.ts
const $3e4beb9e5f6bb1f4$var$VALID_UNITS = [
    "px",
    "%"
];
/**
* Determines the unit of a string and parses the value
*/ function $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc(str, defaultUnit = "%") {
    let out = {
        value: 0,
        unit: defaultUnit
    };
    if (typeof str === "undefined") return out;
    if (!(typeof str === "number" || typeof str === "string")) throw new Error("Invalid value provided. Must provide a value as a string or number");
    str = String(str);
    out.value = parseFloat(str);
    out.unit = str.match(/[\d.\-+]*\s*(.*)/)[1] || defaultUnit;
    if (!$3e4beb9e5f6bb1f4$var$VALID_UNITS.includes(out.unit)) throw new Error("Invalid unit provided.");
    return out;
}
//#endregion
//#region src/utils/validateParallaxEasing.ts
const $3e4beb9e5f6bb1f4$var$CSS_EASING_KEYWORDS = new Set([
    "linear",
    "ease",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
]);
const $3e4beb9e5f6bb1f4$var$CUBIC_BEZIER_RE = /^cubic-bezier\(\s*(-?\d*\.?\d+(?:e[-+]?\d+)?)\s*,\s*(-?\d*\.?\d+(?:e[-+]?\d+)?)\s*,\s*(-?\d*\.?\d+(?:e[-+]?\d+)?)\s*,\s*(-?\d*\.?\d+(?:e[-+]?\d+)?)\s*\)$/i;
/** Whether `value` is a supported CSS easing keyword or `cubic-bezier(...)` curve. */ function $3e4beb9e5f6bb1f4$var$isValidParallaxEasing(value) {
    const trimmed = value.trim();
    if ($3e4beb9e5f6bb1f4$var$CSS_EASING_KEYWORDS.has(trimmed)) return true;
    return $3e4beb9e5f6bb1f4$var$CUBIC_BEZIER_RE.test(trimmed);
}
/**
* Validates a parallax easing string (CSS keyword or `cubic-bezier(...)`).
* @throws when invalid
*/ function $3e4beb9e5f6bb1f4$var$assertValidParallaxEasing(value, context) {
    const trimmed = value.trim();
    if (!$3e4beb9e5f6bb1f4$var$isValidParallaxEasing(trimmed)) throw new Error(`${context}: easing must be a CSS timing keyword (e.g. "ease-in-out") or cubic-bezier(x1, y1, x2, y2). Received "${value}".`);
    return trimmed;
}
//#endregion
//#region src/utils/parseTupleEasing.ts
/** Optional easing from the 3rd tuple entry; validates when present. */ function $3e4beb9e5f6bb1f4$var$parseTupleEasing(effect, context) {
    if (!effect || effect.length < 3) return;
    const raw = effect[2];
    if (raw == null || raw === "") return;
    if (typeof raw !== "string") throw new Error(`${context}: the 3rd tuple value must be a CSS easing string when provided.`);
    return $3e4beb9e5f6bb1f4$var$assertValidParallaxEasing(raw, context);
}
//#endregion
//#region src/helpers/parseElementTransitionEffects.ts
const $3e4beb9e5f6bb1f4$var$TRANSLATION_EFFECTS = [
    "translateX",
    "translateY"
];
const $3e4beb9e5f6bb1f4$var$MAP_EFFECT_TO_DEFAULT_UNIT = {
    translateX: "%",
    translateY: "%"
};
/**
* Takes a parallax element effects and parses only the translation properties to get the start and end values and units.
* Only returns parsed translation effects.
*/ function $3e4beb9e5f6bb1f4$var$parseTranslationProps(props, scrollAxis) {
    const parsedTranslations = {};
    if (typeof props?.speed === "number") {
        const value = props.speed;
        const startSpeed = `${(value || 0) * 10}px`;
        const endSpeed = `${(value || 0) * -10}px`;
        const startParsed = $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc(startSpeed);
        const endParsed = $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc(endSpeed);
        const speedConfig = {
            start: startParsed.value,
            end: endParsed.value,
            unit: startParsed.unit
        };
        if (scrollAxis === "vertical") parsedTranslations.translateY = speedConfig;
        if (scrollAxis === "horizontal") parsedTranslations.translateX = speedConfig;
    }
    $3e4beb9e5f6bb1f4$var$TRANSLATION_EFFECTS.forEach((key)=>{
        const defaultValue = $3e4beb9e5f6bb1f4$var$MAP_EFFECT_TO_DEFAULT_UNIT[key];
        if (Array.isArray(props?.[key])) {
            const value = props?.[key];
            if (typeof value[0] !== "undefined" && typeof value[1] !== "undefined") {
                const startParsed = $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc(value?.[0], defaultValue);
                const endParsed = $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc(value?.[1], defaultValue);
                const easing = $3e4beb9e5f6bb1f4$var$parseTupleEasing(value, `translate${key === "translateX" ? "X" : "Y"}`);
                parsedTranslations[key] = {
                    start: startParsed.value,
                    end: endParsed.value,
                    unit: startParsed.unit,
                    ...easing ? {
                        easing: easing
                    } : {}
                };
                if (startParsed.unit !== endParsed.unit) throw new Error("Must provide matching units for the min and max offset values of each axis.");
            }
        }
    });
    return parsedTranslations;
}
//#endregion
//#region src/helpers/getTranslateScalar.ts
function $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslatePx, endTranslatePx, totalDist) {
    const slow = endTranslatePx > startTranslatePx;
    const totalDistTrue = totalDist + (Math.abs(startTranslatePx) + Math.abs(endTranslatePx)) * (slow ? -1 : 1);
    return Math.max(totalDist / totalDistTrue, 1);
}
//#endregion
//#region src/helpers/getStartEndValueInPx.ts
/**
* Return the start and end pixel values for an elements translations
*/ function $3e4beb9e5f6bb1f4$var$getStartEndValueInPx(translate, elementSize) {
    let { start: start, end: end, unit: unit } = translate;
    if (unit === "%") {
        const scale = elementSize / 100;
        start = start * scale;
        end = end * scale;
    }
    if (unit === "vw") {
        const startScale = start / 100;
        const endScale = end / 100;
        start = window.innerWidth * startScale;
        end = window.innerWidth * endScale;
    }
    if (unit === "vh") {
        const startScale = start / 100;
        const endScale = end / 100;
        start = window.innerHeight * startScale;
        end = window.innerHeight * endScale;
    }
    return {
        start: start,
        end: end
    };
}
//#endregion
//#region src/helpers/parallaxLayoutAdjustments.ts
const $3e4beb9e5f6bb1f4$var$DEFAULT_VALUE = {
    start: 0,
    end: 0,
    unit: "px"
};
function $3e4beb9e5f6bb1f4$var$timingStateToTranslateSpanScale(s) {
    return {
        x: {
            start: s.startMultiplierX,
            end: s.endMultiplierX
        },
        y: {
            start: s.startMultiplierY,
            end: s.endMultiplierY
        }
    };
}
function $3e4beb9e5f6bb1f4$var$defaultScrollWindow(rect, view) {
    return {
        startY: rect.contentTop - view.height,
        startX: rect.contentLeft - view.width,
        endY: rect.contentBottom,
        endX: rect.contentRight,
        startMultiplierY: 1,
        endMultiplierY: 1,
        startMultiplierX: 1,
        endMultiplierX: 1
    };
}
function $3e4beb9e5f6bb1f4$var$applyTranslateScalarsForActiveAxis(s, rect, view, scrollAxis, startTranslateXPx, endTranslateXPx, startTranslateYPx, endTranslateYPx) {
    if (scrollAxis === "vertical") {
        s.startMultiplierY = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, view.height + rect.height);
        s.endMultiplierY = s.startMultiplierY;
    }
    if (scrollAxis === "horizontal") {
        s.startMultiplierX = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, view.width + rect.width);
        s.endMultiplierX = s.startMultiplierX;
    }
}
function $3e4beb9e5f6bb1f4$var$applyTranslateEdgePadding(s, startTranslateXPx, endTranslateXPx, startTranslateYPx, endTranslateYPx) {
    if (startTranslateYPx < 0) s.startY = s.startY + startTranslateYPx * s.startMultiplierY;
    if (endTranslateYPx > 0) s.endY = s.endY + endTranslateYPx * s.endMultiplierY;
    if (startTranslateXPx < 0) s.startX = s.startX + startTranslateXPx * s.startMultiplierX;
    if (endTranslateXPx > 0) s.endX = s.endX + endTranslateXPx * s.endMultiplierX;
}
function $3e4beb9e5f6bb1f4$var$applyAlwaysCompleteVertical(s, rect, view, startTranslateYPx, endTranslateYPx) {
    const topBeginsInView = rect.contentTop < view.height;
    const bottomEndsInView = rect.contentBottom > view.scrollHeight - view.height;
    if (topBeginsInView && bottomEndsInView) {
        s.startMultiplierY = 1;
        s.endMultiplierY = 1;
        s.startY = 0;
        s.endY = view.scrollHeight - view.height;
    }
    if (!topBeginsInView && bottomEndsInView) {
        s.startY = rect.contentTop - view.height;
        s.endY = view.scrollHeight - view.height;
        s.startMultiplierY = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, s.endY - s.startY);
        s.endMultiplierY = 1;
        if (startTranslateYPx < 0) s.startY = s.startY + startTranslateYPx * s.startMultiplierY;
    }
    if (topBeginsInView && !bottomEndsInView) {
        s.startY = 0;
        s.endY = rect.contentBottom;
        const totalDist = s.endY - s.startY;
        s.startMultiplierY = 1;
        s.endMultiplierY = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, totalDist);
        if (endTranslateYPx > 0) s.endY = s.endY + endTranslateYPx * s.endMultiplierY;
    }
}
function $3e4beb9e5f6bb1f4$var$applyAlwaysCompleteHorizontal(s, rect, view, startTranslateXPx, endTranslateXPx) {
    const leftBeginsInView = rect.contentLeft < view.width;
    const rightEndsInView = rect.contentRight > view.scrollWidth - view.width;
    if (leftBeginsInView && rightEndsInView) {
        s.startMultiplierX = 1;
        s.endMultiplierX = 1;
        s.startX = 0;
        s.endX = view.scrollWidth - view.width;
    }
    if (!leftBeginsInView && rightEndsInView) {
        s.startX = rect.contentLeft - view.width;
        s.endX = view.scrollWidth - view.width;
        s.startMultiplierX = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, s.endX - s.startX);
        s.endMultiplierX = 1;
        if (startTranslateXPx < 0) s.startX = s.startX + startTranslateXPx * s.startMultiplierX;
    }
    if (leftBeginsInView && !rightEndsInView) {
        s.startX = 0;
        s.endX = rect.contentRight;
        const totalDist = s.endX - s.startX;
        s.startMultiplierX = 1;
        s.endMultiplierX = $3e4beb9e5f6bb1f4$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, totalDist);
        if (endTranslateXPx > 0) s.endX = s.endX + endTranslateXPx * s.endMultiplierX;
    }
}
function $3e4beb9e5f6bb1f4$var$buildTimingState(rect, view, effects, scrollAxis, shouldAlwaysCompleteAnimation) {
    const translateX = effects.translateX || $3e4beb9e5f6bb1f4$var$DEFAULT_VALUE;
    const translateY = effects.translateY || $3e4beb9e5f6bb1f4$var$DEFAULT_VALUE;
    const { start: startTranslateXPx, end: endTranslateXPx } = $3e4beb9e5f6bb1f4$var$getStartEndValueInPx(translateX, rect.width);
    const { start: startTranslateYPx, end: endTranslateYPx } = $3e4beb9e5f6bb1f4$var$getStartEndValueInPx(translateY, rect.height);
    const s = $3e4beb9e5f6bb1f4$var$defaultScrollWindow(rect, view);
    $3e4beb9e5f6bb1f4$var$applyTranslateScalarsForActiveAxis(s, rect, view, scrollAxis, startTranslateXPx, endTranslateXPx, startTranslateYPx, endTranslateYPx);
    $3e4beb9e5f6bb1f4$var$applyTranslateEdgePadding(s, startTranslateXPx, endTranslateXPx, startTranslateYPx, endTranslateYPx);
    if (shouldAlwaysCompleteAnimation) {
        $3e4beb9e5f6bb1f4$var$applyAlwaysCompleteVertical(s, rect, view, startTranslateYPx, endTranslateYPx);
        $3e4beb9e5f6bb1f4$var$applyAlwaysCompleteHorizontal(s, rect, view, startTranslateXPx, endTranslateXPx);
    }
    return {
        ...s
    };
}
function $3e4beb9e5f6bb1f4$var$computeAlwaysCompleteViewCoverOffsetPx(baseline, final, scrollAxis) {
    if (scrollAxis === "vertical") return {
        start: baseline.startY - final.startY,
        end: final.endY - baseline.endY
    };
    return {
        start: baseline.startX - final.startX,
        end: final.endX - baseline.endX
    };
}
/**
* From one layout snapshot: scale factors for translate keyframes, and (when enabled)
* pixel offsets to widen/narrow the view timeline’s `cover` range for always-complete.
*/ function $3e4beb9e5f6bb1f4$var$computeParallaxLayoutAdjustments(rect, view, effects, scrollAxis, shouldAlwaysCompleteAnimation) {
    const baseline = $3e4beb9e5f6bb1f4$var$buildTimingState(rect, view, effects, scrollAxis, false);
    if (!shouldAlwaysCompleteAnimation) return {
        translateSpanScale: $3e4beb9e5f6bb1f4$var$timingStateToTranslateSpanScale(baseline),
        alwaysCompleteViewCoverOffsetPx: {
            start: 0,
            end: 0
        }
    };
    const final = $3e4beb9e5f6bb1f4$var$buildTimingState(rect, view, effects, scrollAxis, true);
    return {
        translateSpanScale: $3e4beb9e5f6bb1f4$var$timingStateToTranslateSpanScale(final),
        alwaysCompleteViewCoverOffsetPx: $3e4beb9e5f6bb1f4$var$computeAlwaysCompleteViewCoverOffsetPx(baseline, final, scrollAxis)
    };
}
//#endregion
//#region src/helpers/scaleTranslateEffectsForSlowerScroll.ts
function $3e4beb9e5f6bb1f4$var$scaleTranslateEffectsForSlowerScroll(effects, translateSpanScale) {
    const effectsCopy = {
        ...effects
    };
    if (effectsCopy.translateX) effectsCopy.translateX = {
        ...effects.translateX,
        start: effectsCopy.translateX.start * translateSpanScale.x.start,
        end: effectsCopy.translateX.end * translateSpanScale.x.end
    };
    if (effectsCopy.translateY) effectsCopy.translateY = {
        ...effects.translateY,
        start: effectsCopy.translateY.start * translateSpanScale.y.start,
        end: effectsCopy.translateY.end * translateSpanScale.y.end
    };
    return effectsCopy;
}
//#endregion
//#region src/helpers/getShouldScaleTranslateEffects.ts
function $3e4beb9e5f6bb1f4$var$getShouldScaleTranslateEffects(props, effects, scrollAxis) {
    if (props.targetElement || props.shouldDisableScalingTranslations) return false;
    if (!!effects.translateX && scrollAxis === "horizontal" || !!effects.translateY && scrollAxis === "vertical") return true;
    return false;
}
//#endregion
//#region src/waapi/support.ts
/** Resolve `ScrollTimeline` without assuming it exists on `globalThis` (SSR / old browsers). */ function $3e4beb9e5f6bb1f4$var$getScrollTimelineCtor() {
    return globalThis.ScrollTimeline;
}
function $3e4beb9e5f6bb1f4$var$getViewTimelineCtor() {
    return globalThis.ViewTimeline;
}
/** True when the browser can run scroll-linked WAAPI (`ViewTimeline` + `ScrollTimeline` + `animate`). */ function $3e4beb9e5f6bb1f4$var$supportsScrollDrivenAnimations() {
    return typeof $3e4beb9e5f6bb1f4$var$getScrollTimelineCtor() === "function" && typeof $3e4beb9e5f6bb1f4$var$getViewTimelineCtor() === "function" && typeof HTMLElement.prototype.animate === "function";
}
/** WAAPI timeline `axis`: vertical scroll uses `y`, horizontal uses `x` (physical axes, not writing-mode-relative). */ function $3e4beb9e5f6bb1f4$var$timelineAxis(scrollAxis) {
    return scrollAxis === "horizontal" ? "x" : "y";
}
//#endregion
//#region src/waapi/timelines.ts
function $3e4beb9e5f6bb1f4$var$buildScrollTimeline(ScrollTimeline, options) {
    if (!ScrollTimeline) return null;
    return new ScrollTimeline({
        source: options.source,
        axis: options.axis,
        scrollOffsets: [
            CSS.px(options.startScroll),
            CSS.px(options.endScroll)
        ]
    });
}
function $3e4beb9e5f6bb1f4$var$buildViewTimeline(ViewTimeline, options) {
    if (!ViewTimeline) return null;
    return new ViewTimeline({
        subject: options.subject,
        axis: options.axis
    });
}
//#endregion
//#region src/waapi/viewTimelineRange.ts
/** Stable short px strings for CSS `calc(...)` inside `animation-range` (avoids noisy floats). */ function $3e4beb9e5f6bb1f4$var$formatPxForAnimationRange(px) {
    const rounded = Math.round((Number.isFinite(px) ? px : 0) * 100) / 100;
    if (Math.abs(rounded - Math.round(rounded)) < 1e-6) return `${Math.round(rounded)}px`;
    return `${rounded}px`;
}
/**
* Converts an abstract translate “outset” magnitude into px for `animation-range`, using
* the same unit rules as keyframes (`%` is relative to element size on the active axis).
*/ function $3e4beb9e5f6bb1f4$var$translateOutsetToRangeOffsetPx(magnitude, unit, scrollAxis, rect) {
    const elementAxisSize = scrollAxis === "horizontal" ? rect.width : rect.height;
    const { start: start } = $3e4beb9e5f6bb1f4$var$getStartEndValueInPx({
        start: magnitude,
        end: 0,
        unit: unit
    }, elementAxisSize);
    return start;
}
/**
* Maps scaled translate on the **active scroll axis** into extra length (px) to prepend /
* append to the view timeline’s `cover` phase via `animation-range`.
*/ function $3e4beb9e5f6bb1f4$var$getTranslateScalingCoverOffsetsPx(args) {
    const { scrollAxis: scrollAxis, shouldScaleTranslateEffects: shouldScaleTranslateEffects, scaledEffects: scaledEffects, rect: rect } = args;
    if (!shouldScaleTranslateEffects) return {
        start: 0,
        end: 0
    };
    const toPx = (magnitude, unit)=>$3e4beb9e5f6bb1f4$var$translateOutsetToRangeOffsetPx(magnitude, unit, scrollAxis, rect);
    if (scrollAxis === "vertical" && scaledEffects.translateY) {
        const ty = scaledEffects.translateY;
        const startOutset = Math.max(ty.end ?? 0, 0);
        const endOutset = -Math.min(ty.start ?? 0, 0);
        if (startOutset === 0 && endOutset === 0) return {
            start: 0,
            end: 0
        };
        return {
            start: startOutset > 0 ? toPx(startOutset, ty.unit) : 0,
            end: endOutset > 0 ? toPx(endOutset, ty.unit) : 0
        };
    }
    if (scrollAxis === "horizontal" && scaledEffects.translateX) {
        const tx = scaledEffects.translateX;
        const startOutset = Math.max(tx.end ?? 0, 0);
        const endOutset = -Math.min(tx.start ?? 0, 0);
        if (startOutset === 0 && endOutset === 0) return {
            start: 0,
            end: 0
        };
        return {
            start: startOutset > 0 ? toPx(startOutset, tx.unit) : 0,
            end: endOutset > 0 ? toPx(endOutset, tx.unit) : 0
        };
    }
    return {
        start: 0,
        end: 0
    };
}
/**
* Converts signed pixel offsets into `cover` range strings for the view timeline.
*/ function $3e4beb9e5f6bb1f4$var$coverRangeOffsetStrings(startOffsetPx, endOffsetPx) {
    return {
        rangeStart: startOffsetPx === 0 ? "cover 0%" : startOffsetPx > 0 ? `cover calc(0% - ${$3e4beb9e5f6bb1f4$var$formatPxForAnimationRange(startOffsetPx)})` : `cover calc(0% + ${$3e4beb9e5f6bb1f4$var$formatPxForAnimationRange(-startOffsetPx)})`,
        rangeEnd: endOffsetPx === 0 ? "cover 100%" : endOffsetPx > 0 ? `cover calc(100% + ${$3e4beb9e5f6bb1f4$var$formatPxForAnimationRange(endOffsetPx)})` : `cover calc(100% - ${$3e4beb9e5f6bb1f4$var$formatPxForAnimationRange(-endOffsetPx)})`
    };
}
/**
* `rangeStart` / `rangeEnd` for `element.animate(...)` with a `ViewTimeline`.
* Combines translate-scaling and always-complete corrections.
*/ function $3e4beb9e5f6bb1f4$var$getViewTimelineAnimationRange(args) {
    const trans = $3e4beb9e5f6bb1f4$var$getTranslateScalingCoverOffsetsPx(args);
    const alwaysComplete = args.shouldAlwaysCompleteAnimation ? args.alwaysCompleteViewCoverOffsetPx : {
        start: 0,
        end: 0
    };
    const startPx = trans.start + alwaysComplete.start;
    const endPx = trans.end + alwaysComplete.end;
    if (startPx === 0 && endPx === 0) return {
        rangeStart: "entry 0%",
        rangeEnd: "exit 100%"
    };
    return $3e4beb9e5f6bb1f4$var$coverRangeOffsetStrings(startPx, endPx);
}
//#endregion
//#region src/waapi/parallaxAnimateOptions.ts
/**
* Options for `el.animate(keyframes, { timeline, rangeStart?, rangeEnd?, fill, easing })`.
* Explicit `startScroll` / `endScroll` → `ScrollTimeline` (no range). Otherwise `ViewTimeline`
* with `entry`/`exit` or expanded `cover` when translate scaling and/or always-complete apply.
*/ function $3e4beb9e5f6bb1f4$var$buildParallaxAnimateOptions(args) {
    const fill = "both";
    const easing = args.props.easing || "linear";
    const axis = $3e4beb9e5f6bb1f4$var$timelineAxis(args.scrollAxis);
    const explicitStartScroll = args.props.startScroll;
    const explicitEndScroll = args.props.endScroll;
    if (typeof explicitStartScroll === "number" && typeof explicitEndScroll === "number") {
        const timeline = $3e4beb9e5f6bb1f4$var$buildScrollTimeline($3e4beb9e5f6bb1f4$var$getScrollTimelineCtor(), {
            source: args.scrollSource,
            axis: axis,
            startScroll: explicitStartScroll,
            endScroll: explicitEndScroll
        });
        return timeline ? {
            timeline: timeline,
            fill: fill,
            easing: easing
        } : null;
    }
    const timeline = $3e4beb9e5f6bb1f4$var$buildViewTimeline($3e4beb9e5f6bb1f4$var$getViewTimelineCtor(), {
        subject: args.viewSubject,
        axis: axis
    });
    if (!timeline) return null;
    const { rangeStart: rangeStart, rangeEnd: rangeEnd } = $3e4beb9e5f6bb1f4$var$getViewTimelineAnimationRange({
        scrollAxis: args.scrollAxis,
        shouldScaleTranslateEffects: args.shouldScaleTranslateEffects,
        scaledEffects: args.scaledEffects,
        rect: args.rect,
        shouldAlwaysCompleteAnimation: args.shouldAlwaysCompleteAnimation,
        alwaysCompleteViewCoverOffsetPx: args.alwaysCompleteViewCoverOffsetPx
    });
    return {
        timeline: timeline,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
        fill: fill,
        easing: easing
    };
}
//#endregion
//#region src/waapi/createParallaxAnimation.ts
function $3e4beb9e5f6bb1f4$var$toAnimationOptions(spec, easing) {
    const opts = {
        timeline: spec.timeline,
        fill: spec.fill,
        easing: easing
    };
    if (spec.rangeStart != null) opts.rangeStart = spec.rangeStart;
    if (spec.rangeEnd != null) opts.rangeEnd = spec.rangeEnd;
    return opts;
}
/**
* Attach scroll-driven animation(s) to `el`. Uses a single `animate()` call when one
* layer suffices; otherwise composes layers with `GroupEffect` + `KeyframeEffect`.
*/ function $3e4beb9e5f6bb1f4$var$createParallaxAnimation(el, layers, spec) {
    if (layers.length === 0) return null;
    if (layers.length === 1) return el.animate(layers[0].keyframes, $3e4beb9e5f6bb1f4$var$toAnimationOptions(spec, layers[0].easing));
    const GroupEffectCtor = globalThis.GroupEffect;
    const KeyframeEffectCtor = globalThis.KeyframeEffect;
    const AnimationCtor = globalThis.Animation;
    if (!GroupEffectCtor || !KeyframeEffectCtor || !AnimationCtor) return el.animate(layers[0].keyframes, $3e4beb9e5f6bb1f4$var$toAnimationOptions(spec, layers[0].easing));
    const children = layers.map((layer, index)=>{
        const options = {
            fill: "both",
            easing: layer.easing
        };
        if (layer.composite) options.composite = layer.composite;
        else if (index > 0 && layer.keyframes[0]?.transform != null) options.composite = "add";
        return new KeyframeEffectCtor(el, layer.keyframes, options);
    });
    const animationOptions = $3e4beb9e5f6bb1f4$var$toAnimationOptions(spec, layers[0].easing);
    delete animationOptions.easing;
    return new AnimationCtor(new GroupEffectCtor(children), animationOptions);
}
//#endregion
//#region src/utils/resolveParallaxEasing.ts
const $3e4beb9e5f6bb1f4$var$DEFAULT_EASING = "linear";
/** Resolves tuple → global → default easing for one effect property. */ function $3e4beb9e5f6bb1f4$var$resolveParallaxEasing(args) {
    const fromTuple = $3e4beb9e5f6bb1f4$var$parseTupleEasing(args.effect, args.context);
    if (fromTuple) return fromTuple;
    if (args.globalEasing != null && args.globalEasing !== "") return $3e4beb9e5f6bb1f4$var$assertValidParallaxEasing(args.globalEasing, args.context);
    return $3e4beb9e5f6bb1f4$var$DEFAULT_EASING;
}
//#endregion
//#region src/waapi/parallaxKeyframes.ts
/** `rotate()` keyframe value: numbers get `deg`; strings keep explicit units if present. */ function $3e4beb9e5f6bb1f4$var$toRotateCss(value) {
    if (typeof value === "number") return `${value}deg`;
    const s = String(value);
    if (/deg|rad|turn|grad$/i.test(s.trim())) return s;
    return `${s}deg`;
}
function $3e4beb9e5f6bb1f4$var$parseNumericEffect(effect) {
    if (!effect || effect.length < 2) return;
    const start = typeof effect[0] === "number" ? effect[0] : Number.parseFloat(String(effect[0]));
    const end = typeof effect[1] === "number" ? effect[1] : Number.parseFloat(String(effect[1]));
    if (!Number.isFinite(start) || !Number.isFinite(end)) return;
    return {
        start: start,
        end: end
    };
}
function $3e4beb9e5f6bb1f4$var$resolveScaleAxis(uniform, axis, which, fallback = 1) {
    if (axis) return axis[which];
    if (uniform) return uniform[which];
    return fallback;
}
function $3e4beb9e5f6bb1f4$var$buildScaleCss(scale, scaleX, scaleY, scaleZ, which) {
    const sx = $3e4beb9e5f6bb1f4$var$resolveScaleAxis(scale, scaleX, which);
    const sy = $3e4beb9e5f6bb1f4$var$resolveScaleAxis(scale, scaleY, which);
    const sz = $3e4beb9e5f6bb1f4$var$resolveScaleAxis(void 0, scaleZ, which);
    const hasNonUniformZ = scaleZ != null;
    if (sx === 1 && sy === 1 && sz === 1 && !hasNonUniformZ && !scale && !scaleX && !scaleY) return null;
    if (hasNonUniformZ || sz !== 1) return `scale3d(${sx}, ${sy}, ${sz})`;
    return `scale(${sx}, ${sy})`;
}
function $3e4beb9e5f6bb1f4$var$hasRotationProps(effects) {
    return !!(effects.rotate || effects.rotateX || effects.rotateY || effects.rotateZ);
}
function $3e4beb9e5f6bb1f4$var$getTranslateAxis(scrollAxis, translations, scaledEffects, shouldScaleTranslateEffects, axis) {
    return ((axis === "translateX" && scrollAxis === "horizontal" || axis === "translateY" && scrollAxis === "vertical") && shouldScaleTranslateEffects ? scaledEffects : translations)[axis];
}
function $3e4beb9e5f6bb1f4$var$resolveTranslationAxisEasing(axis, parsed, prop, globalEasing) {
    if (!parsed && !prop) return;
    if (parsed?.easing) return parsed.easing;
    if (prop) return $3e4beb9e5f6bb1f4$var$resolveParallaxEasing({
        effect: prop,
        globalEasing: globalEasing,
        context: axis
    });
    if (globalEasing != null && globalEasing !== "") return $3e4beb9e5f6bb1f4$var$assertValidParallaxEasing(globalEasing, axis);
}
function $3e4beb9e5f6bb1f4$var$addTransformLayer(layers, buildTransform, easing) {
    const hasPriorTransform = layers.some((layer)=>layer.keyframes[0]?.transform != null);
    layers.push({
        keyframes: [
            {
                transform: buildTransform("start")
            },
            {
                transform: buildTransform("end")
            }
        ],
        easing: easing,
        composite: hasPriorTransform ? "add" : void 0
    });
}
function $3e4beb9e5f6bb1f4$var$addTranslateLayers(layers, args) {
    const { scrollAxis: scrollAxis, translations: translations, scaledEffects: scaledEffects, shouldScaleTranslateEffects: shouldScaleTranslateEffects, translateX: translateX, translateY: translateY, globalEasing: globalEasing } = args;
    const tx = $3e4beb9e5f6bb1f4$var$getTranslateAxis(scrollAxis, translations, scaledEffects, shouldScaleTranslateEffects, "translateX");
    const ty = $3e4beb9e5f6bb1f4$var$getTranslateAxis(scrollAxis, translations, scaledEffects, shouldScaleTranslateEffects, "translateY");
    const txEasing = $3e4beb9e5f6bb1f4$var$resolveTranslationAxisEasing("translateX", tx, translateX, globalEasing);
    const tyEasing = $3e4beb9e5f6bb1f4$var$resolveTranslationAxisEasing("translateY", ty, translateY, globalEasing);
    const x = (which)=>tx ? `${tx[which]}${tx.unit}` : "0px";
    const y = (which)=>ty ? `${ty[which]}${ty.unit}` : "0px";
    const hasTx = !!tx;
    const hasTy = !!ty;
    if (!hasTx && !hasTy) return;
    const combinedEasing = txEasing ?? tyEasing ?? "linear";
    if (!hasTx || !hasTy || txEasing === tyEasing) {
        $3e4beb9e5f6bb1f4$var$addTransformLayer(layers, (which)=>`translate(${x(which)}, ${y(which)})`, combinedEasing);
        return;
    }
    $3e4beb9e5f6bb1f4$var$addTransformLayer(layers, (which)=>`translate(${x(which)}, 0)`, txEasing ?? "linear");
    $3e4beb9e5f6bb1f4$var$addTransformLayer(layers, (which)=>`translate(0, ${y(which)})`, tyEasing ?? "linear");
}
function $3e4beb9e5f6bb1f4$var$collectRotationContributions(effects, globalEasing) {
    if (!$3e4beb9e5f6bb1f4$var$hasRotationProps(effects)) return [];
    const rotateZ = effects.rotateZ ?? effects.rotate;
    const entries = [
        {
            prop: "rotateX",
            effect: effects.rotateX,
            parsed: $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.rotateX),
            build: (which, parsed)=>`rotateX(${parsed ? $3e4beb9e5f6bb1f4$var$toRotateCss(parsed[which]) : "0deg"})`
        },
        {
            prop: "rotateY",
            effect: effects.rotateY,
            parsed: $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.rotateY),
            build: (which, parsed)=>`rotateY(${parsed ? $3e4beb9e5f6bb1f4$var$toRotateCss(parsed[which]) : "0deg"})`
        },
        {
            prop: "rotateZ",
            effect: rotateZ,
            parsed: $3e4beb9e5f6bb1f4$var$parseNumericEffect(rotateZ),
            build: (which, parsed)=>`rotateZ(${parsed ? $3e4beb9e5f6bb1f4$var$toRotateCss(parsed[which]) : "0deg"})`
        }
    ];
    const contributions = [];
    for (const entry of entries){
        if (!entry.effect && !entry.parsed) continue;
        const easing = $3e4beb9e5f6bb1f4$var$resolveParallaxEasing({
            effect: entry.effect,
            globalEasing: globalEasing,
            context: entry.prop
        });
        contributions.push({
            easing: easing,
            css: (which)=>entry.build(which, entry.parsed)
        });
    }
    return contributions;
}
function $3e4beb9e5f6bb1f4$var$addRotationLayers(layers, effects, globalEasing) {
    const contributions = $3e4beb9e5f6bb1f4$var$collectRotationContributions(effects, globalEasing);
    if (contributions.length === 0) return;
    const byEasing = /* @__PURE__ */ new Map();
    for (const contribution of contributions){
        const group = byEasing.get(contribution.easing) ?? [];
        group.push(contribution);
        byEasing.set(contribution.easing, group);
    }
    for (const [easing, group] of byEasing)$3e4beb9e5f6bb1f4$var$addTransformLayer(layers, (which)=>group.map((c)=>c.css(which)).join(" "), easing);
}
function $3e4beb9e5f6bb1f4$var$addScaleLayer(layers, effects, globalEasing) {
    const scale = $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.scale);
    const scaleX = $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.scaleX);
    const scaleY = $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.scaleY);
    const scaleZ = $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.scaleZ);
    const startCss = $3e4beb9e5f6bb1f4$var$buildScaleCss(scale, scaleX, scaleY, scaleZ, "start");
    const endCss = $3e4beb9e5f6bb1f4$var$buildScaleCss(scale, scaleX, scaleY, scaleZ, "end");
    if (!startCss || !endCss) return;
    $3e4beb9e5f6bb1f4$var$addTransformLayer(layers, (which)=>$3e4beb9e5f6bb1f4$var$buildScaleCss(scale, scaleX, scaleY, scaleZ, which), $3e4beb9e5f6bb1f4$var$resolveParallaxEasing({
        effect: effects.scale ?? effects.scaleX ?? effects.scaleY ?? effects.scaleZ,
        globalEasing: globalEasing,
        context: "scale"
    }));
}
function $3e4beb9e5f6bb1f4$var$addOpacityLayer(layers, effects, globalEasing) {
    const opacity = $3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.opacity);
    if (!opacity) return;
    const easing = $3e4beb9e5f6bb1f4$var$resolveParallaxEasing({
        effect: effects.opacity,
        globalEasing: globalEasing,
        context: "opacity"
    });
    layers.push({
        keyframes: [
            {
                opacity: opacity.start
            },
            {
                opacity: opacity.end
            }
        ],
        easing: easing
    });
}
/**
* Build one or more scroll-driven keyframe layers. Multiple layers are returned when
* effects resolve to different easing curves (composed with `GroupEffect`).
*/ function $3e4beb9e5f6bb1f4$var$buildParallaxKeyframeLayers(args) {
    const shouldScaleTranslateEffects = args.shouldScaleTranslateEffects ?? true;
    const layers = [];
    $3e4beb9e5f6bb1f4$var$addTranslateLayers(layers, {
        scrollAxis: args.scrollAxis,
        translations: args.translations,
        scaledEffects: args.scaledEffects,
        shouldScaleTranslateEffects: shouldScaleTranslateEffects,
        translateX: args.translateX,
        translateY: args.translateY,
        globalEasing: args.globalEasing
    });
    $3e4beb9e5f6bb1f4$var$addRotationLayers(layers, args.effects, args.globalEasing);
    $3e4beb9e5f6bb1f4$var$addScaleLayer(layers, args.effects, args.globalEasing);
    $3e4beb9e5f6bb1f4$var$addOpacityLayer(layers, args.effects, args.globalEasing);
    if (layers.length <= 1) return layers;
    if (new Set(layers.map((layer)=>layer.easing)).size === 1) return [
        {
            keyframes: $3e4beb9e5f6bb1f4$var$mergeLayersToKeyframes(layers),
            easing: layers[0].easing
        }
    ];
    return layers;
}
function $3e4beb9e5f6bb1f4$var$mergeLayersToKeyframes(layers) {
    if (layers.length === 0) return [
        {
            transform: "translate(0px, 0px)"
        },
        {
            transform: "translate(0px, 0px)"
        }
    ];
    if (layers.length === 1) return layers[0].keyframes;
    const start = {};
    const end = {};
    const startTransforms = [];
    const endTransforms = [];
    for (const layer of layers){
        const from = layer.keyframes[0];
        const to = layer.keyframes[1];
        if (from?.transform) startTransforms.push(String(from.transform));
        if (to?.transform) endTransforms.push(String(to.transform));
        if (from?.opacity != null) start.opacity = from.opacity;
        if (to?.opacity != null) end.opacity = to.opacity;
    }
    if (startTransforms.length) start.transform = startTransforms.join(" ");
    if (endTransforms.length) end.transform = endTransforms.join(" ");
    return [
        start,
        end
    ];
}
/** CSS properties animated by scroll-driven keyframes (for teardown). */ function $3e4beb9e5f6bb1f4$var$getParallaxAnimatedPropertyNames(effects) {
    const names = [
        "transform"
    ];
    if ($3e4beb9e5f6bb1f4$var$parseNumericEffect(effects.opacity)) names.push("opacity");
    return names;
}
//#endregion
//#region src/helpers/readAnimationSampleProgress.ts
/**
* Reads normalized progress from {@link https://developer.mozilla.org/en-US/docs/Web/API/Animation/overallProgress Animation.overallProgress}
* when available, otherwise from `effect.getComputedTiming().progress`. When both are
* unavailable, returns `null` and callers should skip progress callbacks for that sample.
*/ /** Minimum delta in normalized progress before firing `onProgressChange` / `onChange`. */ const $3e4beb9e5f6bb1f4$var$PROGRESS_SAMPLE_EPSILON = 1e-4;
function $3e4beb9e5f6bb1f4$var$clamp01(value) {
    if (!Number.isFinite(value)) return 0;
    if (value <= 0) return 0;
    if (value >= 1) return 1;
    return value;
}
function $3e4beb9e5f6bb1f4$var$readAnimationSampleProgress(animation) {
    if (!animation) return null;
    const overall = animation.overallProgress;
    if (overall != null && typeof overall === "number" && Number.isFinite(overall)) return $3e4beb9e5f6bb1f4$var$clamp01(overall);
    const effect = animation.effect;
    if (effect && typeof effect.getComputedTiming === "function") {
        const { progress: progress } = effect.getComputedTiming();
        if (progress != null && typeof progress === "number" && Number.isFinite(progress)) return $3e4beb9e5f6bb1f4$var$clamp01(progress);
    }
    return null;
}
//#endregion
//#region src/classes/Element.ts
/** One parallax DOM node: measured rect, layout-derived WAAPI adjustments, scroll-driven animation on `el`. */ var $3e4beb9e5f6bb1f4$export$db77ccec0bb4ccac = class {
    el;
    props;
    scrollAxis;
    disabled;
    id;
    translations;
    view;
    rect;
    /** Per-axis factors applied to translate start/end before keyframes (slower-scroll compensation). */ translateSpanScale;
    scaledEffects;
    shouldScaleTranslateEffects;
    alwaysCompleteViewCoverOffsetPx = {
        start: 0,
        end: 0
    };
    /** Active `el.animate(...)` instance; `cancel()` before replacing or disabling. */ animation = null;
    /** Observes {@link getProgressTarget} for {@link ParallaxElementConfig.onEnter} / {@link ParallaxElementConfig.onExit}. */ intersectionObserver = null;
    observedIntersectionTarget = null;
    observedIntersectionRoot = null;
    isIntersecting = false;
    /** Last progress passed to `onProgressChange` / `onChange` from scroll sampling (undefined until first sample after (re)install). */ lastSampledProgress;
    constructor(options){
        this.el = options.el;
        this.view = options.view;
        this.props = options.props;
        this.scrollAxis = options.scrollAxis;
        this.disabled = options.disabledParallaxController || false;
        this.id = $3e4beb9e5f6bb1f4$var$createId();
        this.translations = $3e4beb9e5f6bb1f4$var$parseTranslationProps(this.props, this.scrollAxis);
        this.setupTranslateEffects();
        this.installAnimation();
        this.syncIntersectionObserver();
    }
    /**
	* Element whose layout drives scroll progress (`targetElement`) or the animated node (`el`).
	*/ getProgressTarget() {
        return this.props.targetElement ?? this.el;
    }
    /** Recompute rect, translate span scale, scaled translations, and view-range adjustment. */ setupTranslateEffects() {
        this.rect = $3e4beb9e5f6bb1f4$var$measureRect(this.getProgressTarget(), this.view);
        this.shouldScaleTranslateEffects = $3e4beb9e5f6bb1f4$var$getShouldScaleTranslateEffects(this.props, this.translations, this.scrollAxis);
        const adjustments = $3e4beb9e5f6bb1f4$var$computeParallaxLayoutAdjustments(this.rect, this.view, this.translations, this.scrollAxis, !!this.props.shouldAlwaysCompleteAnimation);
        this.translateSpanScale = adjustments.translateSpanScale;
        this.alwaysCompleteViewCoverOffsetPx = adjustments.alwaysCompleteViewCoverOffsetPx;
        this.scaledEffects = this.shouldScaleTranslateEffects ? $3e4beb9e5f6bb1f4$var$scaleTranslateEffectsForSlowerScroll(this.translations, this.translateSpanScale) : {
            ...this.translations
        };
    }
    /** Scroll container for explicit `startScroll` / `endScroll` `ScrollTimeline` (window or custom). */ getScrollSource() {
        return this.view.scrollContainer ?? document.documentElement;
    }
    wantsIntersectionCallbacks() {
        return !!(this.props.onEnter || this.props.onExit);
    }
    handleIntersection(entries) {
        const entry = entries[0];
        if (!entry) return;
        const intersecting = entry.isIntersecting;
        if (intersecting && !this.isIntersecting) this.props.onEnter?.(this);
        else if (!intersecting && this.isIntersecting) this.props.onExit?.(this);
        this.isIntersecting = intersecting;
    }
    getIntersectionRoot() {
        return this.view.scrollContainer ?? null;
    }
    disconnectIntersectionObserver() {
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = null;
        this.observedIntersectionTarget = null;
        this.observedIntersectionRoot = null;
        this.isIntersecting = false;
    }
    /**
	* Attach intersection callbacks when needed. Skips reconnect when only
	* callback references change so React inline handlers do not reset state.
	*/ syncIntersectionObserver() {
        const wants = this.wantsIntersectionCallbacks();
        const target = wants ? this.getProgressTarget() : null;
        const root = this.getIntersectionRoot();
        if (this.disabled || !wants || typeof IntersectionObserver === "undefined") {
            this.disconnectIntersectionObserver();
            return;
        }
        if (this.intersectionObserver && this.observedIntersectionTarget === target && this.observedIntersectionRoot === root) return;
        this.disconnectIntersectionObserver();
        this.intersectionObserver = new IntersectionObserver((entries)=>this.handleIntersection(entries), {
            root: root
        });
        this.observedIntersectionTarget = target;
        this.observedIntersectionRoot = root;
        this.intersectionObserver.observe(target);
    }
    /** Replace any existing parallax animation with a new one from current props/geometry. */ installAnimation() {
        this.cancelParallaxAnimation();
        this.lastSampledProgress = void 0;
        if (this.disabled || !$3e4beb9e5f6bb1f4$var$supportsScrollDrivenAnimations()) return;
        const spec = $3e4beb9e5f6bb1f4$var$buildParallaxAnimateOptions({
            props: this.props,
            scrollAxis: this.scrollAxis,
            scrollSource: this.getScrollSource(),
            viewSubject: this.getProgressTarget(),
            shouldScaleTranslateEffects: this.shouldScaleTranslateEffects,
            scaledEffects: this.scaledEffects,
            rect: this.rect,
            shouldAlwaysCompleteAnimation: !!this.props.shouldAlwaysCompleteAnimation,
            alwaysCompleteViewCoverOffsetPx: this.alwaysCompleteViewCoverOffsetPx
        });
        if (!spec) return;
        const layers = $3e4beb9e5f6bb1f4$var$buildParallaxKeyframeLayers({
            scrollAxis: this.scrollAxis,
            translations: this.translations,
            scaledEffects: this.scaledEffects,
            shouldScaleTranslateEffects: this.shouldScaleTranslateEffects,
            translateX: this.props.translateX,
            translateY: this.props.translateY,
            globalEasing: this.props.easing,
            effects: {
                rotate: this.props.rotate,
                rotateX: this.props.rotateX,
                rotateY: this.props.rotateY,
                rotateZ: this.props.rotateZ,
                scale: this.props.scale,
                scaleX: this.props.scaleX,
                scaleY: this.props.scaleY,
                scaleZ: this.props.scaleZ,
                opacity: this.props.opacity
            }
        });
        this.animation = $3e4beb9e5f6bb1f4$var$createParallaxAnimation(this.el, layers, spec);
        this.scheduleProgressSampleAfterInstall();
    }
    /**
	* Sample progress once the scroll-driven animation exists (rAF + `ready`) so
	* `onProgressChange` fires before the first scroll event.
	*/ scheduleProgressSampleAfterInstall() {
        if (!this.wantsProgressSampling()) return;
        const animation = this.animation;
        if (!animation) return;
        const sampleIfCurrent = ()=>{
            if (this.animation !== animation) return;
            this.sampleProgressCallbacks();
        };
        requestAnimationFrame(sampleIfCurrent);
        animation.ready.then(()=>{
            requestAnimationFrame(sampleIfCurrent);
        }, ()=>{});
    }
    /**
	* Whether this element should participate in controller-driven scroll sampling for
	* `onChange` / `onProgressChange` (WAAPI present, callbacks set, not disabled).
	*/ wantsProgressSampling() {
        if (!this.props.onChange && !this.props.onProgressChange) return false;
        if (this.disabled) return false;
        if (!$3e4beb9e5f6bb1f4$var$supportsScrollDrivenAnimations() || !this.animation) return false;
        return true;
    }
    /**
	* Sample scroll-driven animation progress and invoke callbacks when it moves beyond
	* {@link PROGRESS_SAMPLE_EPSILON}. Skips the frame when progress cannot be read.
	*/ sampleProgressCallbacks() {
        if (!this.wantsProgressSampling()) return;
        const progress = $3e4beb9e5f6bb1f4$var$readAnimationSampleProgress(this.animation);
        if (progress == null) return;
        const prev = this.lastSampledProgress;
        if (prev !== void 0 && Math.abs(progress - prev) < 1e-4) return;
        this.lastSampledProgress = progress;
        this.props.onProgressChange?.(progress);
        this.props.onChange?.(this);
    }
    /** Stop WAAPI and drop the handle; does not clear inline `transform` (see `resetStyles`). */ cancelParallaxAnimation() {
        this.animation?.cancel();
        this.animation = null;
    }
    /** Merge config and re-parse translations; caller should run controller `update()` to refresh animation. */ updateProps(nextProps) {
        this.props = {
            ...this.props,
            ...nextProps
        };
        this.translations = $3e4beb9e5f6bb1f4$var$parseTranslationProps(this.props, this.scrollAxis);
        return this;
    }
    /** New cached view dimensions → recompute effects and rebuild scroll-linked animation. */ updateElement(view) {
        this.view = view;
        this.setupTranslateEffects();
        this.installAnimation();
        this.syncIntersectionObserver();
        return this;
    }
    /** Turn parallax off: cancel animation (element may still show last sampled transform until reset). */ disable = ()=>{
        this.disabled = true;
        this.cancelParallaxAnimation();
        this.disconnectIntersectionObserver();
    };
    /** Turn parallax back on: attach a new scroll-driven animation. */ enable = ()=>{
        this.disabled = false;
        this.installAnimation();
        this.syncIntersectionObserver();
    };
    /** Clear inline styles left by scroll-driven keyframes after `cancel()`. */ clearAnimatedStyles() {
        for (const name of $3e4beb9e5f6bb1f4$var$getParallaxAnimatedPropertyNames(this.props))this.el.style.removeProperty(name);
    }
    teardownIntersectionCallbacks() {
        this.props.onExit?.(this);
        this.disconnectIntersectionObserver();
    }
    /**
	* Teardown for React / controller: `onExit` when intersecting, cancel animation,
	* then clear animated properties (`transform`, and `opacity` when used).
	*/ resetStyles() {
        this.teardownIntersectionCallbacks();
        this.cancelParallaxAnimation();
        this.clearAnimatedStyles();
    }
    /** Controller lifecycle / unmount: same cleanup as {@link Element.resetStyles}. */ destroy() {
        this.teardownIntersectionCallbacks();
        this.cancelParallaxAnimation();
        this.clearAnimatedStyles();
    }
};
//#endregion
//#region src/classes/ParallaxController.ts
/**
* -------------------------------------------------------
* Parallax Controller
* -------------------------------------------------------
*
* The global controller for setting up and managing a scroll view of elements.
*
*/ var $3e4beb9e5f6bb1f4$export$2d3fa02b3cf57f0d = class ParallaxController {
    disabled;
    elements;
    scrollAxis;
    viewEl;
    view;
    _hasScrollContainer;
    _resizeObserver;
    /** rAF id for coalesced `onChange` / `onProgressChange` sampling on scroll. */ _progressSampleRafId = null;
    /** Target currently listening for scroll (window or scroll container). */ _progressScrollTarget = null;
    /**
	* Static method to instantiate the ParallaxController.
	* @returns {Class} ParallaxController
	*/ static init(options) {
        if (!(typeof window !== "undefined")) throw new Error("Looks like ParallaxController.init() was called on the server. This method must be called on the client.");
        return new ParallaxController(options);
    }
    constructor({ scrollAxis: scrollAxis = "vertical", scrollContainer: scrollContainer, disabled: disabled = false }){
        this.disabled = disabled;
        this.scrollAxis = scrollAxis;
        this.elements = [];
        this._hasScrollContainer = !!scrollContainer;
        this.viewEl = scrollContainer ?? window;
        this.view = new $3e4beb9e5f6bb1f4$var$View({
            width: 0,
            height: 0,
            scrollWidth: 0,
            scrollHeight: 0,
            scrollContainer: this._hasScrollContainer ? scrollContainer : void 0
        });
        if (this.disabled) return;
        this._addListeners();
        this._addResizeObserver();
        this._setViewSize();
    }
    /** Passive scroll → one rAF batch; also used after layout `update()` for immediate sample. */ _onScrollForProgressSampling = ()=>{
        this._scheduleProgressCallbackFlush();
    };
    _scheduleProgressCallbackFlush = ()=>{
        if (this._progressSampleRafId != null) return;
        this._progressSampleRafId = requestAnimationFrame(()=>{
            this._progressSampleRafId = null;
            this._flushProgressCallbacks();
        });
    };
    _flushProgressCallbacks = ()=>{
        if (this.disabled || !this.elements?.length) return;
        for (const el of this.elements)el.sampleProgressCallbacks();
    };
    _detachProgressScrollSampling = ()=>{
        if (this._progressSampleRafId != null) {
            cancelAnimationFrame(this._progressSampleRafId);
            this._progressSampleRafId = null;
        }
        if (this._progressScrollTarget) {
            this._progressScrollTarget.removeEventListener("scroll", this._onScrollForProgressSampling);
            this._progressScrollTarget = null;
        }
    };
    _syncProgressScrollSampling = ()=>{
        const desiredTarget = !(!this.disabled && !!this.elements?.length && this.elements.some((e)=>e.wantsProgressSampling())) ? null : this._hasScrollContainer && this.viewEl instanceof HTMLElement ? this.viewEl : window;
        if (this._progressScrollTarget === desiredTarget) return;
        this._detachProgressScrollSampling();
        if (!desiredTarget) return;
        desiredTarget.addEventListener("scroll", this._onScrollForProgressSampling, {
            passive: true
        });
        this._progressScrollTarget = desiredTarget;
    };
    _addListeners = ()=>{
        window.addEventListener("resize", this.update, false);
        window.addEventListener("blur", this.update, false);
        window.addEventListener("focus", this.update, false);
        window.addEventListener("load", this.update, false);
    };
    _removeListeners = ()=>{
        window.removeEventListener("resize", this.update, false);
        window.removeEventListener("blur", this.update, false);
        window.removeEventListener("focus", this.update, false);
        window.removeEventListener("load", this.update, false);
        this._resizeObserver?.disconnect();
        this._detachProgressScrollSampling();
    };
    _addResizeObserver() {
        try {
            const observedEl = this._hasScrollContainer ? this.viewEl : document.documentElement;
            this._resizeObserver = new ResizeObserver(()=>this.update());
            this._resizeObserver.observe(observedEl);
        } catch (e) {
            console.warn("Failed to create the resize observer in the ParallaxContoller");
        }
    }
    /**
	* Update element positions.
	* Determines if the element is in view based on the cached
	* attributes, if so set the elements parallax styles.
	*/ _updateAllElements = ()=>{
        if (this.elements) this.elements.forEach((element)=>{
            element.updateElement(this.view);
        });
    };
    /**
	* Gets the params to set in the View from the scroll container or the window
	*/ _getViewParams = ()=>{
        if (this._hasScrollContainer && this.viewEl instanceof HTMLElement) {
            const width = this.viewEl.offsetWidth;
            const height = this.viewEl.offsetHeight;
            const scrollHeight = this.viewEl.scrollHeight;
            const scrollWidth = this.viewEl.scrollWidth;
            return this.view.setSize({
                width: width,
                height: height,
                scrollHeight: scrollHeight,
                scrollWidth: scrollWidth
            });
        }
        const html = document.documentElement;
        return {
            width: window.innerWidth || html.clientWidth,
            height: window.innerHeight || html.clientHeight,
            scrollHeight: html.scrollHeight,
            scrollWidth: html.scrollWidth
        };
    };
    /**
	* Cache the view attributes
	*/ _setViewSize = ()=>{
        return this.view.setSize(this._getViewParams());
    };
    /**
	* Checks if any of the cached attributes of the view have changed.
	* @returns boolean
	*/ _checkIfViewHasChanged = ()=>{
        return this.view.hasChanged(this._getViewParams());
    };
    /**
	* -------------------------------------------------------
	* Public methods
	* -------------------------------------------------------
	*/ /**
	* Returns all the parallax elements in the controller
	*/ getElements = ()=>{
        return this.elements;
    };
    /**
	* Creates and returns new parallax element with provided options to be managed by the controller.
	*/ createElement = (options)=>{
        const newElement = new $3e4beb9e5f6bb1f4$export$db77ccec0bb4ccac({
            ...options,
            view: this.view,
            scrollAxis: this.scrollAxis,
            disabledParallaxController: this.disabled
        });
        this.elements = this.elements ? [
            ...this.elements,
            newElement
        ] : [
            newElement
        ];
        if (this._checkIfViewHasChanged()) this.update();
        else {
            this._syncProgressScrollSampling();
            this._flushProgressCallbacks();
        }
        return newElement;
    };
    /**
	* Remove an element by id
	*/ removeElementById = (id)=>{
        if (!this.elements) return;
        this.elements = this.elements.filter((el)=>el.id !== id);
        this._syncProgressScrollSampling();
    };
    /**
	* Updates an existing parallax element object with new options.
	*/ updateElementPropsById = (id, props)=>{
        if (this.elements) this.elements = this.elements.map((el)=>{
            if (el.id === id) return el.updateProps(props);
            return el;
        });
        this.update();
    };
    /**
	* Updates all cached attributes on parallax elements.
	*/ update = ()=>{
        this._setViewSize();
        this._updateAllElements();
        this._syncProgressScrollSampling();
        this._flushProgressCallbacks();
    };
    /**
	* Updates the scroll container of the parallax controller
	*/ updateScrollContainer = (el)=>{
        this._detachProgressScrollSampling();
        this._removeListeners();
        this.viewEl = el;
        this._hasScrollContainer = !!el;
        this.view = new $3e4beb9e5f6bb1f4$var$View({
            width: 0,
            height: 0,
            scrollWidth: 0,
            scrollHeight: 0,
            scrollContainer: el
        });
        this._setViewSize();
        this._addListeners();
        this._updateAllElements();
        this._syncProgressScrollSampling();
        this._flushProgressCallbacks();
    };
    disable() {
        this.disabled = true;
        this._removeListeners();
        if (this.elements) this.elements.forEach((element)=>element.disable());
    }
    enable() {
        this.disabled = false;
        if (this.elements) this.elements.forEach((element)=>element.enable());
        this._addListeners();
        this._addResizeObserver();
        this._setViewSize();
        this._syncProgressScrollSampling();
        this._flushProgressCallbacks();
    }
    /** Alias for {@link disable} — matches historical `parallax-controller` API. */ disableParallaxController = ()=>{
        this.disable();
    };
    /** Alias for {@link enable} — matches historical `parallax-controller` API. */ enableParallaxController = ()=>{
        this.enable();
    };
    resetElementStyles = (element)=>{
        element.resetStyles();
    };
    /**
	* Removes all listeners and resets all styles on managed elements.
	*/ destroy = ()=>{
        this._removeListeners();
        if (this.elements) this.elements.forEach((element)=>element.destroy());
        this.elements = void 0;
    };
};


//#region src/utils/removeUndefinedObjectKeys.ts
function $18460a4df4d3d541$var$removeUndefinedObjectKeys(obj) {
    Object.keys(obj).forEach((key)=>obj[key] === void 0 && delete obj[key]);
    return obj;
}
//#endregion
//#region src/helpers/getIsolatedParallaxProps.ts
function $18460a4df4d3d541$var$getIsolatedParallaxProps(props) {
    const { disabled: disabled, easing: easing, endScroll: endScroll, onChange: onChange, onEnter: onEnter, onExit: onExit, onProgressChange: onProgressChange, opacity: opacity, rootMargin: rootMargin, rotate: rotate, rotateX: rotateX, rotateY: rotateY, rotateZ: rotateZ, scale: scale, scaleX: scaleX, scaleY: scaleY, scaleZ: scaleZ, shouldAlwaysCompleteAnimation: shouldAlwaysCompleteAnimation, shouldDisableScalingTranslations: shouldDisableScalingTranslations, speed: speed, startScroll: startScroll, targetElement: targetElement, translateX: translateX, translateY: translateY, ...rest } = props;
    return {
        parallaxProps: $18460a4df4d3d541$var$removeUndefinedObjectKeys({
            disabled: disabled,
            easing: easing,
            endScroll: endScroll,
            onChange: onChange,
            onEnter: onEnter,
            onExit: onExit,
            onProgressChange: onProgressChange,
            opacity: opacity,
            rootMargin: rootMargin,
            rotate: rotate,
            rotateX: rotateX,
            rotateY: rotateY,
            rotateZ: rotateZ,
            scale: scale,
            scaleX: scaleX,
            scaleY: scaleY,
            scaleZ: scaleZ,
            shouldAlwaysCompleteAnimation: shouldAlwaysCompleteAnimation,
            shouldDisableScalingTranslations: shouldDisableScalingTranslations,
            speed: speed,
            startScroll: startScroll,
            targetElement: targetElement,
            translateX: translateX,
            translateY: translateY
        }),
        rest: rest
    };
}
//#endregion
//#region src/components/Parallax/hooks.ts
function $18460a4df4d3d541$var$useVerifyController(controller) {
    (0, $boE4X.useEffect)(()=>{
        const isServer = typeof window === "undefined";
        const isInstance = controller instanceof (0, $3e4beb9e5f6bb1f4$export$2d3fa02b3cf57f0d);
        if (!isServer && !controller && !isInstance) throw new Error("Must wrap your application's <Parallax /> components in a <ParallaxProvider />.");
    }, [
        controller
    ]);
}
//#endregion
//#region src/context/ParallaxContext.ts
const $18460a4df4d3d541$export$a42913da4acdf478 = (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createContext(null);
//#endregion
//#region src/hooks/useParallaxController.ts
function $18460a4df4d3d541$export$f1fe063217e567a8() {
    const parallaxController = (0, $boE4X.useContext)($18460a4df4d3d541$export$a42913da4acdf478);
    if (typeof window === "undefined") return null;
    if (!parallaxController) throw new Error("Could not find `react-scroll-parallax` context value. Please ensure the component is wrapped in a <ParallaxProvider>");
    return parallaxController;
}
//#endregion
//#region src/hooks/useParallax.ts
function $18460a4df4d3d541$export$78dabaa73e04c89f(props) {
    const controller = $18460a4df4d3d541$export$f1fe063217e567a8();
    const ref = (0, $boE4X.useRef)(null);
    const { parallaxProps: parallaxProps } = $18460a4df4d3d541$var$getIsolatedParallaxProps(props);
    $18460a4df4d3d541$var$useVerifyController(controller);
    const [element, setElement] = (0, $boE4X.useState)();
    (0, $boE4X.useEffect)(()=>{
        let newElement;
        if (ref.current instanceof HTMLElement) {
            const options = {
                el: ref.current,
                props: parallaxProps
            };
            newElement = controller === null || controller === void 0 ? void 0 : controller.createElement(options);
            setElement(newElement);
        } else throw new Error("You must assign the ref returned by the useParallax() hook to an HTML Element.");
        return ()=>{
            if (newElement) controller === null || controller === void 0 || controller.removeElementById(newElement.id);
        };
    }, []);
    (0, $boE4X.useEffect)(()=>{
        if (element) {
            if (props.disabled) {
                controller === null || controller === void 0 || controller.resetElementStyles(element);
                controller === null || controller === void 0 || controller.updateElementPropsById(element.id, parallaxProps);
            } else controller === null || controller === void 0 || controller.updateElementPropsById(element.id, parallaxProps);
        }
    }, [
        props.disabled,
        props.easing,
        props.endScroll,
        props.onChange,
        props.onEnter,
        props.onExit,
        props.onProgressChange,
        props.opacity,
        props.rootMargin,
        props.rotate,
        props.rotateX,
        props.rotateY,
        props.rotateZ,
        props.scale,
        props.scaleX,
        props.scaleY,
        props.scaleZ,
        props.shouldAlwaysCompleteAnimation,
        props.shouldDisableScalingTranslations,
        props.speed,
        props.startScroll,
        props.targetElement,
        props.translateX,
        props.translateY
    ]);
    return {
        ref: ref,
        controller: controller,
        element: element
    };
}
//#endregion
//#region src/components/Parallax/Parallax.tsx
function $18460a4df4d3d541$export$1bc430945f060dd1(props) {
    const { parallaxProps: parallaxProps, rest: rest } = $18460a4df4d3d541$var$getIsolatedParallaxProps(props);
    const { ref: ref } = $18460a4df4d3d541$export$78dabaa73e04c89f(parallaxProps);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createElement("div", {
        ref: ref,
        ...rest
    }, props.children);
}
//#endregion
//#region src/components/ParallaxBanner/helpers/getExpandedStyle.ts
const $18460a4df4d3d541$var$FALLBACK_RECT = {
    height: 0
};
function $18460a4df4d3d541$var$getExpandedStyle(layer) {
    if (Array.isArray(layer.translateY)) {
        const translateYStart = (0, $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc)(layer.translateY[0]);
        const translateYEnd = (0, $3e4beb9e5f6bb1f4$export$aaeb52f31f3429bc)(layer.translateY[1]);
        if (translateYStart.unit === "px" && translateYEnd.unit === "px") return {
            top: `${Math.abs(translateYEnd.value) * -1}px`,
            bottom: `${Math.abs(translateYStart.value) * -1}px`
        };
        if (translateYStart.unit === "%" && translateYEnd.unit === "%") {
            var _layer$targetElement$, _layer$targetElement;
            const clientRect = (_layer$targetElement$ = (_layer$targetElement = layer.targetElement) === null || _layer$targetElement === void 0 ? void 0 : _layer$targetElement.getBoundingClientRect()) !== null && _layer$targetElement$ !== void 0 ? _layer$targetElement$ : $18460a4df4d3d541$var$FALLBACK_RECT;
            const top = Math.abs(clientRect.height * .01 * translateYEnd.value) * -1;
            const bottom = Math.abs(clientRect.height * .01 * translateYStart.value) * -1;
            return {
                top: `${top}px`,
                bottom: `${bottom}px`
            };
        }
    }
    if (layer.speed) {
        const speed = layer.speed || 0;
        const absSpeed = Math.abs(speed) * -10;
        return {
            top: `${absSpeed}px`,
            bottom: `${absSpeed}px`
        };
    }
    return {};
}
//#endregion
//#region src/components/ParallaxBanner/helpers/getImageStyle.ts
function $18460a4df4d3d541$var$getImageStyle(layer) {
    return layer.image ? {
        backgroundImage: `url(${layer.image})`,
        backgroundPosition: "center",
        backgroundSize: "cover"
    } : {};
}
//#endregion
//#region src/components/ParallaxBanner/components/ParallaxBannerLayer.tsx
const $18460a4df4d3d541$var$absoluteStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
};
const $18460a4df4d3d541$export$b63f1c4843584916 = (props)=>{
    const { parallaxProps: parallaxProps, rest: rest } = $18460a4df4d3d541$var$getIsolatedParallaxProps(props);
    const { children: children, disabled: disabled, style: style, expanded: expanded = true, image: image, testId: testId, ...divProps } = rest;
    const imageStyle = $18460a4df4d3d541$var$getImageStyle(props);
    const expandedStyle = expanded ? $18460a4df4d3d541$var$getExpandedStyle(props) : {};
    const parallax = $18460a4df4d3d541$export$78dabaa73e04c89f({
        targetElement: props.targetElement,
        shouldDisableScalingTranslations: true,
        ...parallaxProps
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createElement("div", {
        "data-testid": testId,
        ref: parallax.ref,
        style: {
            ...imageStyle,
            ...$18460a4df4d3d541$var$absoluteStyle,
            ...expandedStyle,
            ...style
        },
        ...divProps
    }, rest.children);
};
//#endregion
//#region src/components/ParallaxBanner/ParallaxBanner.tsx
const $18460a4df4d3d541$var$containerStyle = {
    position: "relative",
    overflow: "hidden",
    width: "100%"
};
const $18460a4df4d3d541$export$7e2ae52bed89b740 = (props)=>{
    const [targetElement, setTargetElement] = (0, $boE4X.useState)(null);
    const containerRef = (0, $boE4X.useRef)(null);
    (0, $boE4X.useEffect)(()=>{
        setTargetElement(containerRef.current);
    }, []);
    const { disabled: disableAllLayers, style: rootStyle, layers: layers = [], ...rootRest } = props;
    function renderLayers() {
        if (targetElement) {
            if (layers && layers.length > 0) return layers.map((layer, i)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createElement($18460a4df4d3d541$export$b63f1c4843584916, {
                    ...layer,
                    targetElement: targetElement,
                    key: `layer-${i}`,
                    testId: `layer-${i}`
                }));
        }
        return null;
    }
    function renderChildren() {
        if (targetElement) return (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).Children.map(props.children, (child)=>{
            const item = child;
            if ((item === null || item === void 0 ? void 0 : item.type) === $18460a4df4d3d541$export$b63f1c4843584916) return (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).cloneElement(item, {
                targetElement: targetElement
            });
            return child;
        });
        return null;
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createElement("div", {
        ref: containerRef,
        style: {
            ...$18460a4df4d3d541$var$containerStyle,
            ...rootStyle
        },
        ...rootRest
    }, renderLayers(), renderChildren());
};
//#endregion
//#region src/components/ParallaxProvider/helpers.ts
const $18460a4df4d3d541$var$createController = (options)=>{
    if (!(typeof window === "undefined")) return (0, $3e4beb9e5f6bb1f4$export$2d3fa02b3cf57f0d).init(options);
    return null;
};
//#endregion
//#region src/components/ParallaxProvider/ParallaxProvider.tsx
function $18460a4df4d3d541$export$df63e15c6fb592aa(props) {
    const controller = (0, $boE4X.useRef)(null);
    if (!controller.current) controller.current = $18460a4df4d3d541$var$createController({
        scrollAxis: props.scrollAxis || (0, $3e4beb9e5f6bb1f4$export$8cb8b2cea11e53d2).vertical,
        scrollContainer: props.scrollContainer,
        disabled: props.isDisabled
    });
    (0, $boE4X.useEffect)(()=>{
        if (props.scrollContainer && controller.current) controller.current.updateScrollContainer(props.scrollContainer);
    }, [
        props.scrollContainer
    ]);
    (0, $boE4X.useEffect)(()=>{
        if (props.isDisabled && controller.current) controller.current.disableParallaxController();
        if (!props.isDisabled && controller.current) controller.current.enableParallaxController();
    }, [
        props.isDisabled
    ]);
    (0, $boE4X.useEffect)(()=>{
        return ()=>{
            var _controller$current;
            controller === null || controller === void 0 || (_controller$current = controller.current) === null || _controller$current === void 0 || _controller$current.destroy();
        };
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($boE4X))).createElement($18460a4df4d3d541$export$a42913da4acdf478.Provider, {
        value: controller.current
    }, props.children);
}



parcelRequire("boE4X");

var $436d0cd8c1ae5b89$export$e1d786d2f707b414;
var $436d0cd8c1ae5b89$export$458f376670bba927;
var $436d0cd8c1ae5b89$export$34e0f9847d4c02dd;
var $436d0cd8c1ae5b89$export$659910a2dd865c19;
var $436d0cd8c1ae5b89$export$9b34a77fe7337a03;
var $436d0cd8c1ae5b89$export$e7d0da6968da5dd;
var $436d0cd8c1ae5b89$export$e8e78c978b129247;
var $436d0cd8c1ae5b89$export$209876d7b1ac8f3;
$436d0cd8c1ae5b89$export$e1d786d2f707b414 = `qDgvFa_circle`;
$436d0cd8c1ae5b89$export$458f376670bba927 = `qDgvFa_circleInner`;
$436d0cd8c1ae5b89$export$34e0f9847d4c02dd = `qDgvFa_container`;
$436d0cd8c1ae5b89$export$659910a2dd865c19 = `qDgvFa_hemispheres`;
$436d0cd8c1ae5b89$export$9b34a77fe7337a03 = `qDgvFa_parallaxInner`;
$436d0cd8c1ae5b89$export$e7d0da6968da5dd = `qDgvFa_ring`;
$436d0cd8c1ae5b89$export$e8e78c978b129247 = `qDgvFa_root`;
$436d0cd8c1ae5b89$export$209876d7b1ac8f3 = `qDgvFa_scroll`;



var $f04de07f898f0cee$exports = {};
$f04de07f898f0cee$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 402.4 402.4\" enable-background=\"new 0 0 402.4 402.4\" xml:space=\"preserve\">\n\t<path fill=\"url(#dot-pattern)\" d=\"M201.2,0C90.1,0,0,90.1,0,201.2s90.1,201.2,201.2,201.2s201.2-90.1,201.2-201.2S312.4,0,201.2,0\r\n\t\tz M201.2,366.5c-91.3,0-165.3-74-165.3-165.3s74-165.3,165.3-165.3s165.3,74,165.3,165.3S292.5,366.5,201.2,366.5z\"/>\n</svg>";


var $7bc02a588ddb3bb8$exports = {};
$7bc02a588ddb3bb8$exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 184.2 184.2\" enable-background=\"new 0 0 184.2 184.2\" xml:space=\"preserve\">\n<path fill=\"#FBFBFB\" d=\"M92.1,184.2c50.9,0,92.1-41.2,92.1-92.1S143,0,92.1,0V184.2z\"/>\n<path fill=\"#A179AF\" d=\"M92.1,184.2C41.2,184.2,0,143,0,92.1S41.2,0,92.1,0V184.2z\"/>\n</svg>";


const $64c8ff15758d9290$var$Intro = ()=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
        className: $436d0cd8c1ae5b89$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                className: $436d0cd8c1ae5b89$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        translateY: [
                            100,
                            -100
                        ],
                        className: $436d0cd8c1ae5b89$export$e7d0da6968da5dd,
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($f04de07f898f0cee$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        translateY: [
                            50,
                            -50
                        ],
                        className: $436d0cd8c1ae5b89$export$e1d786d2f707b414,
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("div", {
                            className: $436d0cd8c1ae5b89$export$9b34a77fe7337a03,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("div", {
                                className: $436d0cd8c1ae5b89$export$458f376670bba927
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                        className: $436d0cd8c1ae5b89$export$659910a2dd865c19,
                        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7bc02a588ddb3bb8$exports)))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("p", {
                className: $436d0cd8c1ae5b89$export$209876d7b1ac8f3,
                children: "Scroll"
            })
        ]
    });
var $64c8ff15758d9290$export$2e2bcd8739ae039 = $64c8ff15758d9290$var$Intro;



parcelRequire("boE4X");
var $83cfdf86e233d70f$export$269d732731456c4f;
var $83cfdf86e233d70f$export$11c6980211f7c06c;
var $83cfdf86e233d70f$export$784d13d8ee351f07;
var $83cfdf86e233d70f$export$30780d0b6b610af8;
var $83cfdf86e233d70f$export$e8e78c978b129247;
$83cfdf86e233d70f$export$269d732731456c4f = `sVMnwq_barBottom`;
$83cfdf86e233d70f$export$11c6980211f7c06c = `sVMnwq_barTop`;
$83cfdf86e233d70f$export$784d13d8ee351f07 = `sVMnwq_copy`;
$83cfdf86e233d70f$export$30780d0b6b610af8 = `sVMnwq_letter`;
$83cfdf86e233d70f$export$e8e78c978b129247 = `sVMnwq_root`;



const $da55d66015a96d15$var$copy = "Parallax".split("");
const $da55d66015a96d15$var$IntroCopy = ()=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
        className: $83cfdf86e233d70f$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("div", {
                className: $83cfdf86e233d70f$export$11c6980211f7c06c
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("span", {
                className: `${$83cfdf86e233d70f$export$784d13d8ee351f07} h1`,
                children: $da55d66015a96d15$var$copy.map((letter, i)=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        translateX: [
                            0,
                            100 * (i - 3)
                        ],
                        className: $83cfdf86e233d70f$export$30780d0b6b610af8,
                        children: letter
                    }, `copy-${i}`))
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("div", {
                className: $83cfdf86e233d70f$export$269d732731456c4f
            })
        ]
    });
var $da55d66015a96d15$export$2e2bcd8739ae039 = $da55d66015a96d15$var$IntroCopy;



parcelRequire("boE4X");
var $ae9d799485ce4f5e$export$9a115a700b8a675b;
var $ae9d799485ce4f5e$export$30b08c7b829a94d6;
var $ae9d799485ce4f5e$export$34e0f9847d4c02dd;
var $ae9d799485ce4f5e$export$e8c9778bf415dd08;
var $ae9d799485ce4f5e$export$e8e78c978b129247;
var $ae9d799485ce4f5e$export$6f093cfa640b7166;
$ae9d799485ce4f5e$export$9a115a700b8a675b = `z9epoa_boxBg`;
$ae9d799485ce4f5e$export$30b08c7b829a94d6 = `z9epoa_boxOutline`;
$ae9d799485ce4f5e$export$34e0f9847d4c02dd = `z9epoa_container`;
$ae9d799485ce4f5e$export$e8c9778bf415dd08 = `z9epoa_divider`;
$ae9d799485ce4f5e$export$e8e78c978b129247 = `z9epoa_root`;
$ae9d799485ce4f5e$export$6f093cfa640b7166 = `z9epoa_text`;




var $61e1be3486591582$exports = {};
$61e1be3486591582$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 930 288\" enable-background=\"new 0 0 930 288\" xml:space=\"preserve\">\n\t<polygon fill=\"url(#noise-pattern)\" points=\"878.9,288 0,288 51.1,0 930,0 \"/>\n</svg>";


var $f5abde6a87fcefd1$exports = {};
$f5abde6a87fcefd1$exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 946 301\" enable-background=\"new 0 0 946 301\" xml:space=\"preserve\">\n<g>\n\t<polygon fill=\"#3D3547\" points=\"892.3,301 0.2,301 53.7,0 64.6,13 15.8,288 881.4,288 \t\"/>\n</g>\n<g>\n\t<polygon fill=\"#FFFFFF\" points=\"892.3,301 881.4,288 930.2,13 64.6,13 53.7,0 945.8,0 \t\"/>\n</g>\n</svg>";


var $f3d3a4e4c8593db1$exports = {};
$f3d3a4e4c8593db1$exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1440 270\" enable-background=\"new 0 0 1440 270\" xml:space=\"preserve\">\n<polygon fill=\"#FFFFFF\" points=\"1440,0 0,230 0,270 1440,40 \"/>\n</svg>";


const $356da75698e1cc20$var$Marquee = ()=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
        className: $ae9d799485ce4f5e$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                svg: (0, (/*@__PURE__*/$parcel$interopDefault($f3d3a4e4c8593db1$exports))),
                className: $ae9d799485ce4f5e$export$e8c9778bf415dd08
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                className: $ae9d799485ce4f5e$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                        svg: (0, (/*@__PURE__*/$parcel$interopDefault($61e1be3486591582$exports))),
                        className: $ae9d799485ce4f5e$export$9a115a700b8a675b
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        className: $ae9d799485ce4f5e$export$6f093cfa640b7166,
                        translateY: [
                            -70,
                            70
                        ],
                        translateX: [
                            30,
                            -30
                        ],
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("span", {
                            className: "h1",
                            children: "Horizontal"
                        })
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        className: $ae9d799485ce4f5e$export$30b08c7b829a94d6,
                        translateY: [
                            -35,
                            35
                        ],
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($f5abde6a87fcefd1$exports)))
                        })
                    })
                ]
            })
        ]
    });
var $356da75698e1cc20$export$2e2bcd8739ae039 = $356da75698e1cc20$var$Marquee;




var $boE4X = parcelRequire("boE4X");

var $bc18a1f895064cb1$export$e8e78c978b129247;
$bc18a1f895064cb1$export$e8e78c978b129247 = "root_2c81fc";


var $d676c325218912f2$exports = {};
$d676c325218912f2$exports = "<svg version=\"1.1\" viewBox=\"0 0 142 142\" height=\"142px\" width=\"142px\">\n    <defs>\n        <pattern id=\"noise-pattern\" width=\"142\" height=\"142\" fill=\"\" patternUnits=\"userSpaceOnUse\">\n            <path fill=\"#a179af\" d=\"M21,122.7l1.3-1.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0.1,1.4c-0.2,0.3-0.5,0.5-0.7,0.8c-1,1-1.3,1.5-1.1,2.2\n                c0.1,0.4,0,0.9-0.4,1.1c-0.4,0.2-0.8,0.2-1.2-0.1c-0.3-0.2-0.5-0.5-0.8-0.7c-0.1-0.1-0.2-0.2-0.2-0.2c0,0.1-0.1,0.2-0.2,0.3l-2,2\n                c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-1.4-1.4c-0.4-0.4-0.4-1,0-1.4l3.9-4c0.4-0.4,1-0.4,1.4,0L21,122.7z M34,105.6l-2.8-0.5\n                c-0.3-0.1-0.6,0-0.8,0.2c-0.2,0.2-0.3,0.5-0.3,0.8v1.6c-2.3-0.3-4.3,0.4-6.1,1c-0.5,0.2-1.1,0.4-1.6,0.5c-0.5,0.1-0.8,0.7-0.7,1.2\n                c0.1,0.5,0.6,0.8,1.1,0.8l1.5-0.2c-0.1,0.6-0.1,1.3,0.1,2c-0.6,0.4-1,0.8-0.8,1.4c0.1,0.4,0.5,0.7,1,0.7c0.7,0,2.9-1.4,3.6-3\n                c0.4-0.8,0.4-1.6,0.1-2.3c0.7-0.1,1.5-0.1,2.3,0c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4,0c1.5,0.2,2.7,0.6,3.1,0.7\n                c0.3,0.1,0.4,0.2,0.6,0.2c0.5,0,0.9-0.4,1-0.8c0.1-0.7-0.3-0.9-0.7-1.1l0,0l-0.1,0c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0v-2.1\n                C34.8,106.1,34.5,105.7,34,105.6z M71,81.2c-0.1-0.4-0.4-0.6-0.8-0.7c-0.4-0.1-0.7,0.1-0.9,0.4l-3.5,5.3c0-0.3-0.1-0.7-0.5-0.9\n                L61.5,83l0-0.1l0.9-1.5c0.3-0.4,0.2-1-0.2-1.3c-0.3-0.2-0.6-0.4-0.9-0.6c-0.6-0.4-1.1-0.7-1.4-1.1c-0.1-0.4-0.1-0.7-0.2-1\n                c-0.1-0.5-0.5-0.9-1-0.9c0,0,0,0,0,0c-0.5,0-0.9,0.4-1,0.9c-0.1,0.6,0,1.2,0.3,1.7c0.3,1,0.7,2.2,1.2,3.6l0,0\n                c-0.1,0.2-0.2,0.5-0.1,0.7c0.1,0.3,0.2,0.5,0.4,0.6l0.4,0.2c0.8,1.9,1.7,3.7,2.4,5c0.2,0.4,0.3,0.7,0.5,0.9c-0.1,0.3,0,0.6,0.2,0.8\n                c0.3,0.4,0.6,0.8,1.1,0.8h0c0.3,0,0.7-0.2,0.8-0.5c0-0.1,0.1-0.2,0.1-0.2l0.8-0.2c0.4-0.1,0.7-0.4,0.7-0.8c0.1-0.4-0.1-0.8-0.5-1\n                l-1.5-1l0.5-0.8c0,0.2,0,0.3,0.1,0.5c0.2,0.3,0.5,0.5,0.9,0.5h3.9c0.4,0,0.8-0.2,0.9-0.6c0.2-0.4,0.1-0.8-0.2-1.1l-1.3-1.3\n                c0,0,0,0,0,0C70.4,84.5,71.7,83.2,71,81.2z M48.1,80.3l1.9-0.7c0.5-0.2,0.7-0.7,0.6-1.1c-0.1-0.6-0.3-1.2-0.6-1.7\n                c-0.2-1.1-0.9-2.3-2.3-3.6c-0.2-0.2-0.4-0.2-0.6-0.3L46,72.8c-1.7-0.7-3.8-0.9-5.9-0.4c-0.5,0.1-0.8,0.5-0.8,1\n                c0,0.5,0.4,0.9,0.9,0.9l5.3,0.4c1.2,0.5,2.1,1.4,2.6,2.6c0,0.3-0.2,0.7-0.9,1.2l-2.3,0.8c-0.6-1.4-2-2.2-3.2-2.7\n                c-0.2-0.1-0.5-0.2-0.7-0.3c-0.3-0.1-0.6-0.2-0.9-0.3l-0.8-0.3c-0.3-0.1-0.6-0.1-0.9,0.1c-0.3,0.2-0.4,0.5-0.4,0.8\n                c0,0.6-0.4,0.8-1.8,1.3c-0.3,0.1-0.7,0.2-1,0.4c-0.5,0.2-0.6,0.7-0.5,1.2c0.1,0.5,0.7,0.8,1.2,0.7c0.4,0,0.7,0.3,1,0.5\n                c1,2.1,1.3,2.4,1.9,2.4c0.4,0,0.8-0.2,0.9-0.6c0.3-0.8-0.5-2-1-2.7c0.5-1.1,1.1-1.7,1.8-1.7c0.1,0.1,0.3,0.1,0.4,0.2\n                c0.8,0.5,1.7,1.8,2.1,3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.4-0.4,0.9,0,1.3c0.3,0.4,0.8,0.9,1.4,0.9c0.3,0,0.7-0.2,0.9-0.4\n                c0.2-0.3,0.3-0.7,0.2-1.2c0.5-0.3,1-0.6,1.5-0.9C47.2,80.9,47.7,80.6,48.1,80.3z M1.4,73.3c0.1-0.4-0.2-0.8-0.5-1L0,71.9v2.3\n                c0.2,0,0.4,0,0.6-0.1C1,74.1,1.3,73.7,1.4,73.3z M17.2,117.5c-0.2-0.4-0.8-0.6-1.2-0.4l-5.2,2.1c-0.2,0.1-0.4,0.3-0.5,0.5\n                c-0.1,0.2-0.1,0.5,0,0.8l0.4,1.1L9,123c-0.4,0.3-0.5,0.8-0.2,1.3c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.2,0,0.4-0.1l2.6-1\n                c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.1-0.5,0-0.8l-0.1-0.2l3.9-3.4C17.4,118.4,17.4,117.9,17.2,117.5z M27.6,71.7\n                c-0.2,0.1-0.3,0.1-0.4,0.1c-0.6,0-1.1-0.5-1.8-1.2c-0.3-0.3-0.5-0.5-0.8-0.7c-0.3-0.2-0.7-0.3-1-0.1C23.3,70,23,70.3,23,70.7V76\n                c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.3-0.6,0.7-0.9,1c-1,1.2-1.9,2.2-3.1,1.9c-0.3-0.1-0.6,0-0.9,0.2c-0.2,0.2-0.4,0.5-0.4,0.8v2\n                c0,0.4,0.2,0.7,0.5,0.9c-0.4-0.2-0.8-0.1-1.1,0.2l-0.9,0.9c-0.2,0.2-0.3,0.5-0.3,0.7c0,0.3,0.2,0.5,0.4,0.7l4.7,3.8\n                c0.4,0.3,1,0.3,1.3-0.1l0.5-0.5l2.7,0.8c0.1,0,0.2,0,0.3,0c0.4,0,0.7-0.2,0.9-0.6c0.2-0.5,0-1-0.4-1.2l-7.9-4.8\n                c0.1,0,0.2,0.1,0.3,0.1h3.9c0.5,0,1-0.4,1-1l0-2c0-0.9,0.2-1.7,0.9-2.5c0.2-0.2,0.4-0.4,0.7-0.6c0.2-0.1,0.3-0.3,0.4-0.6\n                c0.4-0.4,0.8-0.7,1.2-1.1c0.9-0.8,1.8-1.6,2.5-2.5c0.3-0.3,0.3-0.8,0-1.2C28.5,71.8,28,71.6,27.6,71.7z M32.6,65.4\n                c0.3-0.4,0.3-0.9,0-1.3c-0.3-0.4-0.9-0.4-1.3-0.2c-1.7,1.1-2.5,2.3-2.5,3.7c-0.1,0.5,0,0.9,0.2,1.4c0,0.1,0.1,0.3,0.2,0.4\n                c0.3,0.6,0.6,1.2,1,1.8c0.2,0.4,0.5,0.8,0.7,1.2c-0.1,0.3,0,0.7,0.3,0.9l0.2,0.2c0.2,0.9,0.1,1.7-0.4,2.6c-0.2,0.4-0.1,1,0.3,1.3\n                c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3l2-2c0.4-0.4,0.4-1,0-1.4l-1.3-1.3l1.2-1.2c0.8-0.4,1.4-1,1.8-1.8l0.1-0.1\n                c0.7-0.1,1.3,0.4,2,1.1c0.3,0.3,0.5,0.5,0.8,0.7c0.4,0.3,1,0.3,1.3-0.1l1.4-1.4c0.4-0.4,0.4-1,0-1.4l-3.2-3.3c0.2-0.3,0.2-0.6,0.1-1\n                c-0.2-0.4-0.5-0.6-0.9-0.6h-2c-0.5,0-1,0.4-1,1l0,0.8c0,0.3,0,0.6,0,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.7-0.1,1.3-0.3,1.7\n                l-1.2,1.2c-0.1,0-0.2,0-0.2,0c-0.6,0-1.1-0.5-1.8-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.2-0.1-0.3-0.1-0.5c0.1-0.5,0.6-1,1.1-1.6\n                C32.2,65.9,32.4,65.7,32.6,65.4z M14,62.8c-0.3-0.1-0.6-0.1-0.9,0.1c-0.3,0.2-0.4,0.5-0.4,0.8v2c0,0,0,0,0,0v2c0,0.5,0.4,1,1,1h2\n                c0.4,0,0.8-0.2,0.9-0.6c0.2-0.4,0.1-0.8-0.2-1.1l-1.3-1.3l3.2-3.3c0,0,0,0,0,0l2-2c0.4-0.4,0.4-1,0-1.4L19,57.8l1.3-1.3\n                c0.2-0.2,0.3-0.6,0.3-0.9c-0.1-0.3-0.3-0.6-0.6-0.7c-0.4-0.1-0.7-0.2-1.1-0.2c-1.4,0-2.4,0.9-3.1,1.7c-0.2,0.2-0.4,0.4-0.7,0.6\n                c-0.4,0.3-0.5,1-0.1,1.4c0.2,0.3,0.5,0.5,0.7,0.8c0.8,0.9,1.2,1.4,1.1,2c-0.2,0.2-0.4,0.3-0.5,0.5C15.4,62.5,14.8,63.1,14,62.8z\n                 M30.2,90.9c1.3-0.3,2.6-0.7,3.7-1.3c0.8,0,2-0.1,2-1.2c0-1.1-1.2-1.1-1.9-1.1c-0.3,0-0.5,0.1-0.6,0.2c0,0,0,0-0.1,0\n                c-1.1,0-2.1-0.2-2.8-0.6c-0.3-1-0.9-1.7-1.9-2.1c-0.3-0.1-0.7-0.1-1,0.1c-0.3,0.2-0.4,0.6-0.3,1c0.2,0.9,0.7,1.6,1.5,2.2\n                c0,0.3,0,0.5,0.1,0.8c0,0.1,0,0.1,0,0.2c-1.7,0.5-3.4,1.1-4.4,2.4l-3.1,1.6l-0.1-1.3c0,0,0,0,0,0c0-0.2-0.1-0.4-0.3-0.6v0l0,0\n                c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0C20.5,91,20.4,91,20.2,91c-0.6,0-1.2,0.1-1.8,0.1\n                c-1,0.1-2,0.1-2.8,0.1l-0.3-4.5c0-0.4-0.3-0.7-0.7-0.9c-0.4-0.1-0.8,0-1.1,0.3L11,89c-0.3,0.3-0.3,0.8-0.1,1.2\n                c0.7,1.2,1.7,2.1,2.9,2.5c0.2,0.4,0.5,0.6,1,0.6l4.6-0.3l0.1,1.8c0,0,0,0,0,0.1c0.1,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0l0.2,0\n                c0.3,0,0.6,0,0.8,0c0.3,0,0.5,0,0.8,0c0.9,0,1.3,0.2,1.6,0.7c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.2,0,0.4-0.1c0.5-0.2,0.7-0.7,0.6-1.1\n                c-0.2-1.1-0.2-1.9,0.1-2.5L30.2,90.9z M59.3,46.8c0,0.3,0.1,0.6,0.3,0.8l2,2c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4,0,0.5-0.1\n                c0.4-0.2,0.6-0.7,0.4-1.2c-0.3-0.8,0.1-1.2,1.1-2.2c0.1-0.1,0.2-0.2,0.3-0.3c0.5,0.1,1.1,0.3,1.7,0.4c0.2,0.1,0.3,0.3,0.5,0.5\n                c0.3,0.3,0.5,0.5,0.8,0.7c0.4,0.3,1,0.3,1.3-0.1l0.3-0.3c0.5,0.1,1,0.3,1.6,0.4c0.8,0.9,1.8,1.4,2.8,1.4c1.2,0,2.3-0.6,3.3-1.2\n                c1.5-0.4,2.7-1.1,3.8-2.2c0.3-0.3,0.4-0.8,0.1-1.2s-0.7-0.6-1.1-0.4c-1.2,0.4-2.2,1-3.2,1.7L76,45.9c-1.2,0.2-2.6,0.2-4.3-0.1\n                c-0.3-0.4-0.5-0.8-0.8-1.4c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3-0.1-0.6,0.1-0.9,0.3L68.5,45c-0.4-0.1-0.7-0.2-1.1-0.3l-0.3-0.1\n                c-0.7-0.5-1.8-1.1-3.1-0.8c-0.6-0.1-1.1-0.2-1.5-0.2C60.6,43.7,59.5,44.8,59.3,46.8z M93.1,58.2c-3.1,0-3.6,2.8-3.9,4.8\n                c-0.2,1-0.3,1.8-0.6,2.4L87,66.6c-0.2,0-0.3,0-0.6,0c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1c3.7,0,4.2-3.1,4.6-5.3l4.5-3.6\n                c-0.6-0.2-1.1-0.3-1.6-0.4c0,0,0-0.1,0-0.1C94.1,58.6,93.6,58.2,93.1,58.2z M63.8,35.6c-0.2,0.3-0.3,0.8,0,1.1\n                c0.1,0.2,0.3,0.4,0.4,0.6c1.1,1.6,1.7,2.6,0.8,4.1c-0.2,0.4-0.2,0.9,0.2,1.2c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.2l1.7-1.3\n                c0.3-0.2,0.4-0.6,0.4-0.9c-0.2-2.3-1.1-3.9-2.4-5c-0.1-0.1-0.2-0.1-0.3-0.2l-0.9-0.3C64.4,35.1,64,35.2,63.8,35.6z M104.6,81\n                c0.5,0.1,1-0.1,1.2-0.6c0.2-0.5,0-1-0.5-1.2c-1.3-0.7-1.7-1.7-2.1-2.9c-0.1-0.4-0.3-0.7-0.4-1c0,0,0-0.1-0.1-0.1\n                c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c0,0-0.1,0-0.1,0l-2.4-0.4l-1.8-5c-0.1-0.3-0.4-0.6-0.7-0.6\n                c-0.9-1.3-2.1-2.3-3.7-3.1c-0.4-0.2-0.9-0.1-1.2,0.2l-2,2.3c-0.2,0.3-0.3,0.6-0.2,1c0.1,0.3,0.4,0.6,0.8,0.6l5.2,0.8\n                c0.6,1,1,2.1,1.4,3.2c0.2,0.6,0.4,1.2,0.7,1.8c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0v0\n                c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0l0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0\n                c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0.1,0.1,0.2,0.1,0.4,0.2\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h0\n                c0,0,0,0,0,0h0l0,0h0h0c0,0,0,0,0,0h0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0l2.1,0.3l-0.3,3.1c-0.9,0.9-0.9,2.4-0.7,3.8c-0.3,0-0.6-0.1-0.8-0.2c-0.9-0.8-1.8-1.4-2.8-1.7\n                c-0.4-0.1-0.9,0.1-1.1,0.4c-0.2,0.4-0.2,0.8,0.1,1.2c0.7,0.9,1.6,1.5,2.7,1.8c1,1.1,1.7,2.5,2.1,3.2c-0.1,0.2-0.1,0.5,0,0.7\n                c0.4,0.8,0.7,1.5,1.4,1.5c0.3,0,0.7-0.2,0.8-0.5c0.2-0.4,0.3-0.7-0.2-1.9c0.2-1,0-2.3-0.2-3.5l0.4-3.8\n                C102.8,80.6,103.6,80.7,104.6,81z M69.4,36.4l0.9,5.2c0.1,0.3,0.3,0.6,0.6,0.8c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2\n                c2.7-2.1,0.6-5.1-0.6-6.6L69.7,27c-0.1-0.3-0.3-0.6-0.5-0.7c-0.3-0.1-0.6-0.1-0.9,0C66.8,27,66,28,65.7,29.2c-0.4,2.2,1.3,4.3,3,6.4\n                C68.9,35.9,69.1,36.1,69.4,36.4z M81.3,96.7c0.6,0,0.8-0.4,1-0.8c0-0.1,0.1-0.2,0.1-0.3c1.3-2.9,2.1-5.6,2.2-7.7\n                c0.5-2.4-0.2-4.2-2.2-5.4c0,0,0,0,0,0c-0.5-0.3-1.1-0.1-1.3,0.3c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.3,0.2,0.7,0.5,0.9c0,0,0.1,0,0.1,0.1\n                c0.4,0.3,1.3,1,1.1,3.3c-0.2,0.9-0.6,1.8-1,2.7c-0.6,1.6-1.3,3.2-1.3,4.8c-0.1,0.3-0.2,0.7,0,1.1C80.7,96.5,81,96.7,81.3,96.7z\n                 M91.2,76.1c-0.2-0.4-0.7-0.6-1.1-0.5c-6,1.4-10.1,3-12.1,3.8c-0.3-0.1-0.6,0-0.9,0.1c-0.5,0.4-1.1,0.8-0.9,1.5\n                c0.1,0.4,0.5,0.7,1,0.7c0.2,0,0.4,0,0.8-0.2c0.7,0.2,1.3,0.4,2,0.4c2,0,3.5-1.1,4.6-2c0.5-0.4,1.1-0.8,1.4-0.8c0,0,0.3,0.1,0.9,1.4\n                c0.2,0.5,0.7,0.7,1.2,0.6c0.5-0.1,0.8-0.6,0.7-1.1c-0.1-0.8,0.3-1.2,1.4-2c0.3-0.2,0.6-0.4,0.8-0.6C91.3,77,91.4,76.5,91.2,76.1z\n                 M87.5,90.4c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7l2-5.9c0.2-0.5-0.1-1-0.6-1.2c-0.5-0.2-1,0-1.3,0.5l-1.4,2.7l-1-1\n                c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1-0.1,1.4c0.2,0.3,0.5,0.5,0.7,0.8c1,1,1.3,1.5,1.1,2.2C86.7,89.6,86.9,90.2,87.5,90.4z\n                 M81.2,86.8c0-0.3-0.2-0.5-0.4-0.7l-1-0.8c-0.2-0.1-0.4-0.2-0.6-0.2l-2-0.1c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7l-0.1,2\n                c0,0.5,0.4,1,0.9,1l2,0.1c0,0,0,0,0,0c0.3,0,0.6-0.1,0.7-0.3l1.1-1.2C81.1,87.3,81.2,87.1,81.2,86.8z M78.2,75.8\n                c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4,0c1.5,0.2,2.8,0.6,3.2,0.7c0.3,0.1,0.4,0.2,0.6,0.2c0.5,0,0.9-0.4,1-0.8\n                c0.1-0.7-0.3-0.9-0.7-1.1l0,0l-0.1,0c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0v-2.1c0-0.5-0.3-0.9-0.8-1L79,71.2c-0.3-0.1-0.6,0-0.8,0.2\n                s-0.3,0.5-0.3,0.8v1.6c-2.3-0.3-4.3,0.4-6.1,1c-0.5,0.2-1.1,0.4-1.6,0.5c-0.5,0.1-0.8,0.7-0.7,1.2c0.1,0.5,0.6,0.8,1.1,0.8L72,77\n                c-0.1,0.6-0.1,1.3,0.1,2c-0.6,0.4-1,0.8-0.8,1.4c0.1,0.4,0.5,0.7,1,0.7c0.7,0,2.9-1.4,3.6-3c0.4-0.8,0.4-1.6,0.1-2.3\n                C76.5,75.7,77.4,75.7,78.2,75.8z M36.5,88.1c0.1,0.2,0.4,0.4,0.6,0.4l0.4,0.1c2,1.5,3.8,2.7,5.2,3.6c0.6,0.4,1.2,0.8,1.9,1.1\n                c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.7-0.2,0.9-0.5c0.2-0.5,0.1-1-0.4-1.3c-0.5-0.3-1-0.6-1.6-1c-0.8-0.6-1.3-1.3-1.8-2.1\n                c-0.2-0.3-0.5-0.7-0.7-1c-0.1-0.2-0.4-0.3-0.6-0.4l-2.5-0.4l-0.8-0.6l-3.1-4.4c-0.1-0.2-0.4-0.4-0.6-0.4l-2.9-0.5l-1.6-2.3\n                C29,78.2,28.7,78,28.4,78c-0.3,0-0.6,0.1-0.8,0.4l-0.1,0.2c-0.5-0.2-1.1,0.1-1.3,0.6c-0.3,0.7,0.1,1,0.8,1.6\n                c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0.3,1,0.8,1.7,1.3c1.8,1.4,4.3,3.3,6.8,5.2L36.5,88.1z M12.7,115.6c0.1,0.3,0.2,0.5,0.5,0.6\n                c0.5,0.3,0.7,0.3,1,0.3c0.4,0,0.8-0.3,0.9-0.7c0.1-0.2,0.1-0.4,0-0.5l0.5-0.4c0.3-0.2,0.4-0.6,0.3-1c-0.1-0.4-0.4-0.7-0.8-0.7\n                l-2-0.3V111c0-0.5-0.3-0.9-0.8-1l-4.6-0.8L7.6,109v-1.8c0-0.5-0.3-0.8-0.7-1c-0.3-0.1-0.7-0.2-1.1-0.2c-0.7-0.1-1.4-0.3-1.9-0.6\n                c-0.3-0.3-0.5-0.6-0.7-0.9c-0.3-0.4-0.9-0.5-1.3-0.3c-0.4,0.3-0.6,0.8-0.4,1.3c0.3,0.6,0.6,1,1.1,1.4c0.8,0.9,1.8,1.9,3,3v0.1\n                c0,0.5,0.3,0.9,0.8,1l0.5,0.1c1.7,1.5,3.5,2.8,4.8,3.8C12.1,115.2,12.4,115.4,12.7,115.6z M20.1,98.3c-0.5,0.2-1.1,0.3-1.7,0.4\n                c-2.2,0.5-5,1.1-5.9,3.5c-0.4,0.4-0.7,0.9-0.9,1.4l-0.9-0.2c-0.4-0.1-0.8,0.1-1,0.5c-0.2,0.4-0.2,0.8,0.1,1.1l1.4,1.6\n                c0.2,0.2,0.5,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0c0.4-0.1,0.6-0.4,0.7-0.8c0-0.1,0-0.2,0.1-0.3l0.2,0c0.3,0.1,0.6-0.1,0.9-0.3\n                c0.2-0.2,0.3-0.6,0.3-0.9c-0.1-0.6-0.1-1.1,0-1.5c1.3-1.2,3.3-1.4,5.7-0.3c0.3,0.1,0.7,0.1,0.9-0.1c0.3-0.2,0.4-0.5,0.4-0.8v-2.8\n                c0-0.3-0.1-0.6-0.4-0.8S20.4,98.2,20.1,98.3z M17.3,104.1c-0.3-0.3-0.8-0.3-1.2,0c-1.4,1-2.6,5.4-2.3,6.4c0.1,0.4,0.6,0.8,1,0.8\n                c0.6,0,1-0.5,1.3-1.1l1.2-0.1l0.1,1.7c0,1,0,2,0.1,3.1c0.1,0.5,0.5,0.8,1,0.8c0,0,0.1,0,0.1,0c0.5-0.1,0.9-0.5,0.9-1l-0.1-2.9l0-0.4\n                C19.4,108.8,19.5,105.9,17.3,104.1z M2.5,117.2c0.7,0.1,1,0.4,1.1,1.1c0.1,0.3,0.3,0.6,0.6,0.8c0.3,0.1,0.7,0.1,1-0.2l2.8-2.3\n                c0.3-0.2,0.4-0.6,0.3-1c-0.1-0.4-0.4-0.7-0.8-0.7c-1-0.2-2.4-0.1-3.6,0.1c-0.5,0.1-1,0.1-1.5,0.2c-0.4-0.1-0.9-0.1-1.4,0\n                c-0.4-0.1-0.8-0.2-1.2-0.4v2.6c0.4-0.1,0.8-0.2,1.1-0.2C1.6,117.3,2,117.3,2.5,117.2z M11.9,61.2c-1.1,0.6-2.2,1.1-3.4,1.3\n                c-2.7-1.3-5.9-1.4-8.5-1.4v2.5c2.5,0.8,5.5,1.4,8.2,1C8.5,64.8,8.7,65,9,65.2c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2\n                l2.8-2.3c0.4-0.3,0.5-0.9,0.2-1.3C12.9,61.1,12.3,61,11.9,61.2z M25.1,65.8l-2.3,0.2c-0.2-0.5-0.3-1.1-0.4-1.5\n                c-0.1-0.5-0.2-1.3-1.1-1.3c-0.9,0-1,0.3-1.3,2.6l-1.2,0.6c-0.4,0.2-0.6,0.7-0.5,1.2c0.1,0.5,0.6,0.8,1,0.7l2.4-0.2\n                c0.5,0.5,1.1,0.6,1.5,0.6c0.8,0,1.6-0.4,2.5-1.1c0.3-0.3,0.4-0.7,0.3-1.1C25.9,66,25.5,65.7,25.1,65.8z M59.1,72.6l4.6,4.3l0.1,2.8\n                c0,0.3,0.2,0.6,0.4,0.8c0.2,0.1,0.4,0.2,0.5,0.2c0.1,0,0.2,0,0.3-0.1l1.2-0.5c0.3-0.1,0.5-0.3,0.6-0.6s0.1-0.5,0-0.8l-1.3-2.7\n                c0,0,0,0,0-0.1l-1.3-2.7c-0.2-0.3-0.5-0.6-0.9-0.6c-0.3,0-0.6,0.1-0.8,0.3c-0.4-0.2-1-0.8-1.4-1.1c-0.3-0.2-0.5-0.5-0.8-0.7\n                c-1-1.6-1-2.8-1.1-4.2c0-0.4,0-0.8-0.1-1.2c0-0.3-0.2-0.5-0.4-0.7c-0.3-0.2-0.6-0.5-0.8-0.7c-1-0.9-1.9-1.7-2.9-1.7\n                c-0.6,0-1.1,0.3-1.4,0.9c-0.2,0.4-0.1,0.9,0.2,1.2l2.2,2l0.1,2.8c0,0.3,0.1,0.5,0.3,0.7L59.1,72.6C59.1,72.5,59.1,72.6,59.1,72.6z\n                 M34,50.2c-0.2,0.2-0.3,0.5-0.2,0.8c0,0.3,0.2,0.5,0.4,0.7l5.9,4c0.2,0.1,0.4,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.3\n                c0.3-0.3,0.4-0.9,0.1-1.3c-0.5-0.8-1.2-1.4-1.9-2c-1.3-1.1-2.1-1.8-1.9-2.9c0.2-0.2,0.4-0.3,0.5-0.5c0.1-0.1,0.2-0.2,0.3-0.3\n                c1,0.3,1.9,0.4,2.8,0.4c0.5,0.6,0.6,1,0.4,1.5c-0.1,0.4,0,0.8,0.3,1.1c0.3,0.3,0.8,0.3,1.1,0.1c1.3-0.8,2.3-2,3.2-3.2\n                c0.8-1,1.6-2,2.5-2.5l0.4-0.2c0.9-0.4,1.7-0.4,2.8,0.1c0.4,0.2,0.8,0.1,1.1-0.2l2-2c0.3-0.3,0.4-0.7,0.2-1.1c-0.2-0.4-0.6-0.6-1-0.6\n                c-2.6,0.3-4.5,1.2-6,2.1c-0.2,0.1-0.4,0.2-0.5,0.3l-0.9,0.6c-1.6,1-3,1.9-4.7,2.1l0,0c-0.2-0.2-0.4-0.4-0.6-0.7\n                c-0.1-0.1-0.3-0.2-0.4-0.3c-1.1-0.4-2.2,0-2.9,0.4c-0.3-0.1-0.6-0.2-0.9-0.4c-0.4-0.2-0.8-0.1-1.1,0.2c-0.3,0.3-0.4,0.7-0.3,1\n                c0.3,0.8-0.1,1.2-1.1,2.2C34.4,49.6,34.2,49.9,34,50.2z M0,95.1v1.2l0,0C0.3,95.9,0.3,95.4,0,95.1z M56,79.5c0.1,0,0.2,0.1,0.3,0.1\n                c0.2,0,0.5-0.1,0.6-0.2c0.3-0.2,0.4-0.6,0.3-0.9c-0.6-2.7-2.2-3.6-3.6-4.4c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.7-0.7-1.4-1-2.2\n                c0.1-0.1,0.2-0.2,0.4-0.4c0.8-0.8,1.4-1.4,2.2-1.1c0.4,0.1,0.9,0,1.1-0.4c0.2-0.4,0.2-0.9-0.1-1.2l-2-2c-0.3-0.3-0.8-0.4-1.2-0.1\n                c-0.4,0.2-0.6,0.7-0.4,1.2c0.2,0.7-0.1,1.2-0.9,2c-1.2-2.6-2.7-5.1-5.5-6.5l2-1c1.1-0.3,2.3-0.7,3.2-1.4c0,0,0,0,0,0\n                c0.2,0.2,0.3,0.3,0.5,0.5l0.6,2.3c0.1,0.4,0.5,0.7,0.9,0.7c0.5,0,0.8-0.3,1-0.7c0.5-1.5-0.1-2.5-0.7-3.3l-0.8-3.2\n                c-0.1-0.6-0.2-1.3-0.5-2.1c-0.2-0.5-0.7-0.8-1.2-0.6c-0.5,0.2-0.8,0.7-0.7,1.2l0.5,1.9c0,0.6-0.1,0.9-0.2,1.1l-3.3,1.7\n                c0,0,0,0-0.1,0c-1.7,0.5-3.5,1-4.6,2.4c0,0,0,0,0,0.1l0,0c-0.1,0.1-0.1,0.2-0.1,0.3c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3\n                c0,0.2,0.1,0.3,0.1,0.5c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c0,0,0,0,0,0l7.4,7.4l0.2,0.5c0.1,1.3,0.6,2.3,1.4,3.1\n                C51.8,76.3,53.2,78.5,56,79.5z M43.3,58.7c0.2,0.1,0.4,0.2,0.5,0.2c0.3,0,0.6-0.1,0.7-0.3l6-7.1c0.3-0.4,0.3-0.9,0-1.2l-0.8-1\n                c-0.2-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.5,0.1-0.7,0.2l-4.5,4.1c-0.4,0.3-0.4,0.9-0.1,1.3l0.4,0.5L43,57.5\n                C42.8,57.9,42.9,58.5,43.3,58.7z M19.8,75.6c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.5c0.2-0.4,0.2-0.9-0.2-1.2l-3.9-4\n                c-0.3-0.3-0.8-0.4-1.1-0.2l-3.9,2c-0.4,0.2-0.6,0.6-0.5,1c0,0.4,0.3,0.8,0.7,0.9L19.8,75.6z M0,65.2v5L1.4,71\n                c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.3c0.3-0.3,0.4-0.8,0.1-1.2L0,65.2z M6.3,76.6c0-0.5-0.2-0.9-0.7-1l-2.1-0.7\n                c-0.2-0.1-0.4-0.1-0.6,0c-0.2-0.1-0.5-0.1-0.7,0l-2.2,1v3.9l1.1-0.1c0.5-0.1,0.9-0.5,0.9-1l0-0.4l0.4-0.6l3-0.3\n                C5.9,77.4,6.2,77.1,6.3,76.6z M1,94.2c1.4,0.2,2.2,0.4,2.4,0.4c0,0,0,0,0.1,0c0.1,0,0.2,0,0.2,0c0.5,0,0.9-0.4,1-0.9\n                c0-0.5-0.4-1-0.9-1.1c-0.2,0-0.9-0.2-1.7-0.5v-4.5c0-0.4-0.2-0.7-0.6-0.9c-0.3-0.2-0.7-0.1-1,0.1c-0.2,0.1-0.3,0.3-0.5,0.4v6\n                c0.1,0,0.1,0.1,0.2,0.1C0.3,93.9,0.6,94.2,1,94.2z M4.8,83.2c0.3-0.5,0.2-1.1-0.3-1.4c-0.2-0.2-0.5-0.3-0.7-0.4\n                c-1.4-0.8-2.5-1.2-3.5-1.2c-0.1,0-0.2,0-0.3,0v2.6c0.8-0.4,1.8-0.3,2.9,0.3c0.2,0.1,0.4,0.2,0.6,0.3C3.9,83.8,4.5,83.7,4.8,83.2z\n                 M9.9,99.1c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.6-0.2l2.8-2.3c0.3-0.2,0.4-0.6,0.3-1c-0.1-0.4-0.4-0.7-0.8-0.7l-2-0.4\n                c0-0.1,0-0.1,0-0.2c0-1.3,0-3-1.8-4.2c-0.3-0.2-0.8-0.2-1.1,0c-0.3,0.2-0.5,0.6-0.4,1l1.4,7.1C9.4,98.7,9.6,99,9.9,99.1z M13.7,83.9\n                c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.5-0.1l1.6-0.9c0.3-0.2,0.5-0.4,0.5-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.8-0.7-0.7-1.4-0.6-2.7\n                c0-0.4,0.1-0.7,0.1-1.1c0-0.4-0.3-0.9-0.7-1l-2.4-0.8c-0.5-0.5-1.3-0.9-2.2-1l0.2-1.6c0.1-0.5-0.2-0.9-0.7-1.1l-1.9-0.6\n                c-0.3-0.1-0.6-0.1-0.8,0.1c-0.1,0-0.1,0.1-0.2,0.1l-1.6-4.7c-0.1-0.6-0.3-1.1-0.5-1.6c-0.2-0.5-0.8-0.7-1.3-0.5\n                c-0.5,0.2-0.7,0.7-0.6,1.2l0.5,1.4c0.2,0.8,0.2,1.7,0.2,2.5c0.1,2.1,0.1,4.4,2.6,5.8l0.4,1.2c0.1,0.3,0.3,0.5,0.6,0.6\n                c0.3,0.1,0.6,0.1,0.8-0.1L9.7,77l2,0.7c0.3,0.6,0.4,1.4,0.5,2.3c0.1,0.9,0.2,2,0.7,2.9c-0.3-0.1-0.5,0-0.8,0.1l-1.1,0.7\n                c-1.5,1-3,1.9-4.4,2.5v0c0,0-0.1-0.1-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.4c1.4-1.7,2.5-3.2,2.3-4.5c-0.1-0.4-0.3-0.9-1-1.2\n                c-0.5-0.2-1.1-0.1-1.3,0.4l-3.4,6.6c0,0,0,0,0,0c-0.1,0.2-0.1,0.5-0.1,0.7c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0\n                c0.1,0.2,0.2,0.3,0.4,0.5c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.5,0.1,0.8,0c0.1,0.2,0.1,0.4,0.3,0.5\n                c0.2,0.3,0.6,0.4,1,0.4c0.8,0,1.9-0.4,7-5C13.6,84.4,13.7,84.1,13.7,83.9z M3.7,101.7c0.9,0,2,0.3,3.2,0.8c0.5,0.2,1.1,0,1.3-0.5\n                c0.2-0.5,0-1.1-0.5-1.3c-0.7-0.4-1.3-0.8-1.6-1.2c0.3-0.9,0.4-1.9,0.2-3.1c0.3-0.4,0.5-0.8,0.3-1.3c-0.2-0.4-0.5-0.6-0.9-0.6\n                c-0.5,0-0.8,0.3-1.2,1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.6,1.2-0.8,2.5-0.5,3.6c-0.1,0.1-0.3,0.3-0.5,0.4c-0.5,0-1,0.1-1.5,0.2\n                c-0.5,0-1.2-0.1-1.8-0.3v3.9c0.7-0.8,1.3-1.3,2.1-1.6C2.7,101.9,3.2,101.9,3.7,101.7z M2.4,108.5c0-0.9-0.6-1.2-2.4-1.3v2.3\n                c0.4,0,0.7,0.1,1,0.1C2.2,109.5,2.4,108.8,2.4,108.5z M118.5,71.3c0.2,0.2,0.5,0.3,0.7,0.3c0.4,0.4,0.8,0.9,1.1,1.5\n                c0.2,0.3,0.5,0.5,0.9,0.5c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.5,0.7-1v-4c0-0.4-0.2-0.8-0.6-0.9c-0.4-0.2-0.8-0.1-1.1,0.2l-1.2,1.2\n                c-0.2-0.1-0.4-0.2-0.5-0.3l-0.8-0.9c-0.1-0.1-0.2-0.2-0.4-0.2c-1-0.3-1.9-0.2-2.9,0.4c-0.6,0.1-1.3,0.3-1.9,0.5c0,0-0.1,0-0.1,0\n                l-0.7-0.7c-0.3-0.3-0.7-0.4-1.1-0.2c0,0,0,0,0,0c-0.5-0.4-1-0.7-1.7-1.1c0-0.4,0-0.9,0.2-1.5c0.1-0.4-0.1-0.9-0.4-1.1\n                c-0.4-0.2-0.8-0.2-1.2,0.1c-0.5,0.5-1.2,0.7-2,0.7c-0.2,0-0.4,0-0.6,0l-0.7-0.2l-2.7-0.5c-0.7-0.2-1.3-0.3-1.8-0.4l-0.3-2\n                c-0.1-0.5-0.5-0.9-1-0.8c-0.5,0-0.9,0.5-0.9,1v2.8c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2l1.4,7.1c0.1,0.5,0.6,0.9,1.1,0.8\n                c0.5-0.1,0.9-0.6,0.8-1.1l-0.8-5.7l1.6,0.3c1,0.2,2,0.5,2.9,0.6c0.1,0,0.3,0.1,0.4,0.2c0,0-0.1,0-0.1,0.1c-2.6,1.7-1.3,4.3-0.4,6.2\n                c1.1,2.3,1.3,3.1,0.4,3.7c-0.4,0.3-0.5,0.8-0.3,1.2c0.2,0.3,0.5,0.5,0.9,0.5c0.1,0,0.2,0,0.3-0.1c1.5-0.5,2.5-0.8,3.3-0.2\n                c0.3,0.3,0.8,0.3,1.2,0.1c0.4-0.3,0.5-0.7,0.4-1.1c-0.6-1.7-1.8-3.1-2.9-4.4c-1.9-2.2-2.6-3.3-1.6-4.5c0.2-0.3,0.3-0.7,0.2-1\n                c0.4,0.2,0.8,0.4,1.2,0.6c0.5,1.2,1.6,1.8,2.7,2.1v0.6c0,0.4,0.2,0.7,0.5,0.9c0.2,0.1,0.5,0.1,0.8,0c0.1,0.3,0.2,0.6,0.1,0.9\n                c0,0.3,0.1,0.5,0.2,0.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.6,0.1,0.9,0.1c0.5,0.1,1.1,0.2,1.6,0.2c1.2,0,2.1-0.5,2.7-1.4\n                c0.2-0.3,0.2-0.7,0-1c-0.3-0.4-0.6-0.8-1-1.1c0.2,0.1,0.5,0.1,0.7,0.2L118.5,71.3z M0,2.4c0.2-0.1,0.4-0.2,0.5-0.4l0.6-1.1\n                c0.1-0.2,0.2-0.5,0.1-0.8c0,0,0,0,0-0.1H0V2.4z M7.5,27.9c-0.2-0.6-0.4-1.2-0.6-1.8c0,0,0,0,0,0c-0.2-2.1-0.1-2.9,0.8-3.2\n                c0.4-0.2,0.7-0.6,0.6-1S8,21,7.6,21l-1.9-0.3c-0.1-0.4-0.1-0.9-0.1-1.2v-0.7c0-0.5-0.4-1-1-1c-0.6,0-1,0.4-1,0.9c0,0.2,0,0.5,0,0.8\n                v2c0,0.3,0.1,0.6,0.4,0.8C4.2,23.5,4.6,25,5,26.4c0.1,0.8,0.1,1.4,0,2c0,0.3,0,0.5,0.2,0.7c0.1,0.2,0.4,0.4,0.6,0.4l0.3,0\n                c0.1,0.3,0.3,0.7,0.4,1c0.1,0.3,0.3,0.5,0.6,0.6c0.8,0.3,1.5,0.4,2.1,0.4c0,0,0,0,0,0c1,0,1.9-0.3,2.5-1c0.2,0,0.3-0.1,0.5-0.2\n                c0.2-0.2,0.4-0.4,0.4-0.7c0-0.3,0.1-0.7,0.1-1c0.3-1.2,0.3-2.7,0.3-4.1c0-1.3,0-2.5,0.2-3.2c0.1-0.2,0.3-0.3,0.4-0.4\n                c0.4-0.3,0.5-0.8,0.3-1.3c-0.2-0.4-0.7-0.7-1.2-0.5c-0.4,0.1-0.9,0.4-1.3,1.1c-1.2,1.6-1,3.9-0.9,6c0.1,0.7,0.1,1.4,0.1,2.1\n                c0,0,0,0,0,0L7.5,27.9z M2.4,8l-2-0.3c-0.1,0-0.3,0-0.4,0v5.7c0.1,0.2,0.3,0.4,0.6,0.4c0.3,0.1,0.6,0,0.8-0.2l1.1-0.9l2.1,0.4\n                c0.4,0.5,0.6,1.3,0.9,2.2c0.3,1.2,0.7,2.6,1.7,3.6c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.2l1.4-1.1c0.2-0.2,0.4-0.5,0.4-0.8\n                c0-0.3-0.2-0.6-0.4-0.8C9,15.7,8.9,15,8.9,13.7c0-0.4,0-0.7,0-1.1c0-0.4-0.4-0.8-0.8-0.9l-2.5-0.4c-0.6-0.4-1.4-0.7-2.3-0.7V9\n                C3.2,8.5,2.9,8.1,2.4,8z M46,135.9c0-0.1,0-0.1-0.1-0.2c0-0.1,0.1-0.2,0.1-0.4c0-0.2-0.1-0.3-0.2-0.5c0.4-0.1,0.7-0.4,0.7-0.8\n                l0.1-1.3c0.6,0,1,0.1,1.4,0.1l0.3,0.1c0.5,0.1,1.1-0.1,1.2-0.7c0.2-0.5-0.1-1.1-0.6-1.2c-0.1,0-0.2-0.1-0.4-0.1l-2.4-0.7\n                c-0.3-0.1-0.6,0-0.8,0.1c-0.2,0.1-0.3,0.2-0.3,0.4c-0.3,0-0.5,0-0.8,0l-0.4,0c-0.4-0.1-0.8-0.1-1.3-0.2c-0.9-0.2-1.9-0.8-2.4-3\n                c-0.1-0.3-0.4-0.6-0.7-0.7c-0.3-0.1-0.7,0-1,0.3l-5.1,5.2l-0.2,0.1c-0.6,0.2-1.3,0.3-1.9,0.5c-0.8-0.3-1.4-0.6-1.6-1.4\n                c-0.1-0.4-0.6-0.7-1-0.7c-0.5,0.1-0.8,0.4-0.9,0.9l-0.3,2.7c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.1,0,0.2,0\n                c0.8-0.1,1.7-0.3,2.6-0.6l0.2,0.1c0.3,0.1,0.6,0.2,0.9,0.3c0.4,0.1,0.8,0.1,1.1-0.2l1-1c2.9-0.8,5.7-1.5,7.9-1.5\n                c0.4,0.1,0.8,0.1,1.3,0.2c0.6,0.2,0.9,0.5,1,0.9l-0.9-0.7c-0.2-0.2-0.5-0.2-0.7-0.2c-0.3,0-0.5,0.2-0.7,0.4c-1.4,1.7-2,3.4-2.7,5\n                c-0.5,1.2-0.9,2.3-1.6,3.4l-0.1,0.2c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.8-0.3-1.1,0l-1.7,1.1h6.2l4.8-5.3\n                C45.9,136.5,46,136.2,46,135.9z M63.1,125.3c-0.4-0.4-1-0.4-1.4-0.1l-7.2,6c-0.4,0.3-0.5,1-0.1,1.4c0.2,0.2,0.5,0.4,0.8,0.4\n                c0.2,0,0.4-0.1,0.6-0.2c0,0,0,0,0,0l0,0c1.5-1.2,2.7-1.4,4.1-1.7c0.4-0.1,0.8-0.1,1.2-0.2c0.5-0.1,0.9-0.6,0.8-1.1\n                c-0.1-0.5-0.6-0.9-1.1-0.8l-0.1,0l2.3-2.2C63.4,126.3,63.4,125.7,63.1,125.3z M47.1,30.6h-2c-0.1,0-0.2,0-0.3,0.1l-5.9,2\n                c-0.5,0.2-0.7,0.6-0.7,1.1c0.1,0.5,0.5,0.8,1,0.8h7.9c0.5,0,1-0.4,1-1v-2C48.1,31.1,47.6,30.6,47.1,30.6z M22.1,25.1\n                c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.2,0,0.3-0.1c0.6-0.2,1.2-0.4,1.7-0.6c2-0.6,4.1-1.3,5.8-2.9l0.7,0.7c0.2,0.5,0.3,1.1,0.3,1.7\n                c0,0.5,0.5,1,1,0.9c0.5,0,1-0.5,0.9-1.1c0-0.2,0-0.7,0-1.7c0-0.3-0.1-0.5-0.3-0.7l-0.3-0.3c-0.2-0.5-0.5-0.9-0.7-1.2\n                c0.4-0.4,0.8-0.8,1.1-1.2l3.8-3.9c0,0,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4\n                c0-0.1,0-0.2-0.1-0.2c-0.3-0.6-0.7-1.1-1.2-1.5c0.5-0.4,0.9-0.9,1.2-1.5c0.2-0.4,0.1-1-0.3-1.2C36.9,9.6,36.3,9.7,36,10l-1.4,1.4\n                c-0.3,0.1-0.8,0.2-1.3,0.3c-0.3,0-0.6,0-0.8,0l-1.7,0c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1l1.7,0c0.3,0,0.6,0,0.8,0\n                c0.5,0,0.9,0.1,1.3,0.3l0.7,0.7c-0.9,0.8-1.7,1.7-2.5,2.6l-2.5,2.6c-1,0.9-2,1.5-3,1.7c-0.1-0.1-0.2-0.2-0.3-0.3\n                c-0.7-0.7-1.1-1.2-1.1-1.7c0.2-0.3,0.4-0.6,0.6-0.8c0.9-0.8,1.4-1.2,2.1-1c0.5,0.2,1-0.1,1.2-0.6c0.2-0.5,0-1-0.5-1.3\n                c-0.7-0.4-1.1-0.9-1.3-1.8c0.1-1.1,0.1-2.2-0.1-3.4c-0.1-0.5-0.5-0.9-1-0.8c-0.5,0-0.9,0.5-0.9,1l0,0.8c0,0.8,0,1.7,0.1,2.6\n                c-0.1,1.2-0.5,2.3-1.1,3.2c-0.2,0.2-0.4,0.4-0.6,0.6C24.1,18,24,18.1,24,18.3c0,0.1,0,0.1-0.1,0.2c-0.4,0.4-0.9,0.9-1.5,1.2\n                C22.1,20,22,20.2,22,20.5c0,0.3,0.1,0.6,0.3,0.8l1.3,1.3l-1.3,1.3C21.9,24.2,21.9,24.7,22.1,25.1z M37,18c0,0.3,0.2,0.5,0.3,0.7\n                c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4,0,0.8-0.2l0.8,0.8l-1.2,1.2c-0.7,0.6-1.5,1.4-2.1,2.2c-0.3,0.4-0.3,1,0.1,1.3\n                c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3l2-2l0.3-0.3c1.9-1.6,4-3.5,3.9-6.4c0-0.4-0.3-0.8-0.8-0.9c-0.2,0-0.3-0.1-0.5-0.1\n                C41.5,14.7,37,16.5,37,18z M24.9,49.1c-0.3-0.2-0.8-0.2-1.1,0l-1.5,1l-1-1.5c-0.1-0.2-0.4-0.4-0.6-0.4c-0.3,0-0.5,0-0.7,0.2L16.3,51\n                l-1.1-1.4c-0.3-0.4-0.9-0.5-1.3-0.3c-0.3,0.2-0.6,0.4-0.9,0.6c-0.6,0.4-1.1,0.7-1.6,0.8c-0.4-0.1-0.7-0.1-1-0.2\n                c-0.5-0.1-1,0.1-1.2,0.6c-0.2,0.5,0,1,0.4,1.3c0.5,0.3,1,0.4,1.5,0.4c0,0,0.1,0,0.1,0c1,0.2,2.3,0.3,3.8,0.3l0,0\n                c0.1,0.2,0.4,0.4,0.6,0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.2l0.4-0.3c2.1,0,4-0.1,5.5-0.2c0.4,0,0.7,0,1-0.1\n                c0.2,0.2,0.6,0.2,0.8,0.2c0.4-0.1,1.4-0.4,1.2-1.3c0-0.2-0.1-0.4-0.3-0.6l0.1-0.8C25.4,49.7,25.3,49.3,24.9,49.1z M51.5,27.7\n                c0.4,0,0.7,0,1.1,0c0,0,0,0,0,0c0.2,0,0.4-0.2,0.6-0.3c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.2,0.2-0.4,0.1-0.6l-1-6.7\n                c0-0.3-0.2-0.6-0.5-0.7c-0.3-0.1-0.6-0.2-0.9,0c-0.8,0.3-1.1,0.9-1.3,1.3c-0.5,1.2,0.2,2.7,0.9,4.2c0.1,0.1,0.1,0.2,0.2,0.4\n                c-0.2,0.1-0.3,0.2-0.5,0.3c-1.1-0.5-2.3-1.5-3.4-2.5l-0.8-0.7c-0.4-0.3-0.9-0.3-1.3,0.1c-0.4,0.3-0.4,0.9-0.1,1.3\n                c3.3,4.3,4.5,5.1,5.4,5.1C50.9,28.7,51.3,28.2,51.5,27.7z M34.8,32.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.3,0,0.5-0.1\n                c0.4-0.2,0.6-0.8,0.5-1.2l-1.3-3.7c0.2,0,0.3-0.1,0.5-0.1l6.8,1.1c0.2,0,0.3,0,0.5,0c2.1-0.8,1.3-3,0.9-4.2\n                c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.2-0.5-0.5-0.6c-0.2-0.1-0.5-0.1-0.8-0.1c-1.6,0.6-1.5,1.9-1.3,3.1c-2-0.7-3.5-0.8-5.4-0.4\n                l-1.8-0.3c-0.3-0.1-0.7,0.1-0.9,0.3c-0.2,0.2-0.2,0.5-0.2,0.7c-0.1,0-0.2,0-0.2,0.1c-0.3,0.1-0.6,0.3-0.7,0.6\n                c-0.1,0.3-0.1,0.7,0.1,0.9L34.8,32.4z M96.1,137.8c-0.1,0.5,0.2,1.1,0.8,1.2c0.1,0,0.1,0,0.2,0c0.5,0,0.9-0.3,1-0.8l0.3-1.5\n                c0.2-0.1,0.3-0.2,0.5-0.3c0.9-0.6,1.6-1.1,2.4-0.6c0.4,0.2,0.9,0.2,1.2-0.2c0.3-0.3,0.4-0.8,0.1-1.2L101,132c0,0,0,0,0,0l-3.1-4.7\n                c-0.1-0.2-0.4-0.4-0.6-0.4c-0.3-0.1-0.5,0-0.7,0.1l-1.6,1.1c-0.2,0.1-0.4,0.4-0.4,0.6c-0.1,0.3,0,0.5,0.1,0.7l2.7,4\n                c-0.6,1.1-0.9,2.3-1.1,3.5L96.1,137.8z M122.5,142h3.8c0.3-0.4,0.6-0.9,0.7-1.4c0.3,0,0.6-0.2,0.8-0.4c0.2-0.3,0.2-0.6,0.1-0.9\n                c-0.1-0.3-0.2-0.6-0.3-0.9c-0.4-1.2-0.9-2.9-2.8-3.4l0.3-0.5c0.3-0.5,0.1-1.1-0.3-1.3c-0.5-0.3-1-0.7-1.5-1.2c0,0,0,0,0,0\n                c0-0.4-0.2-0.7-0.5-0.9c-0.2-0.1-0.4-0.2-0.7-0.4c-1.4-1.7-2.2-3.7-2-5.1c0.5-1.1,1.4-2,2.7-2.7c0.5-0.2,0.7-0.8,0.5-1.3\n                c-0.2-0.5-0.7-0.7-1.2-0.6c-0.4,0.1-0.6,0.3-1,0.4c0.3-0.2,0.5-0.6,0.5-0.8c0-0.5-0.5-1-1-1l-0.2,0l-0.4-2c-0.1-0.5-0.6-0.9-1.1-0.8\n                l-2.7,0.5c-0.5,0.1-0.9,0.6-0.8,1.2l0.3,1.8c-2.3,0.5-4,1.9-5.7,3.2c-0.5,0.4-0.9,0.8-1.4,1.1c-0.4,0.3-0.5,0.9-0.3,1.3\n                c0.3,0.4,0.9,0.6,1.3,0.3l1.1-0.6c0,0.6,0.2,1.2,0.5,1.8c-0.6,0.7-0.8,1.1-0.6,1.6c0.2,0.4,0.5,0.6,0.9,0.6c1,0,2.6-2.6,3-3.8\n                c0.4-1.4,0.1-2.3-0.3-2.8c0.6-0.4,1.4-0.7,2.3-0.9c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3-0.1,0.4-0.1c1.4-0.3,2.6-0.4,3-0.4l0.3,0\n                c0.1,0,0.2,0,0.4-0.1c-1.5,0.8-2.4,1.9-2.7,3.5c-0.9,2.5,0,5.2,2.4,6.9c-0.2,0.2-0.4,0.3-0.6,0.5c-1.1,0.9-2.5,2-3.4,2\n                c-0.2,0-0.6,0-1.2-1c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3-0.1-0.6,0.1-0.9,0.3l-1.4,1.4c-0.4,0.4-0.4,1,0,1.4l2,2c0.4,0.4,1,0.4,1.4,0\n                l1.2-1.2c2.8-1.1,4-1.3,4.4-1.2c-0.1,1-2.2,3.6-3.2,4.9c-0.4,0.5-0.8,1-1.1,1.4h3.5l3.2-5.3c0.7,0.9,1.2,1.7,1.3,2.4\n                C124,139.7,123.2,140.9,122.5,142z M110.9,140.7c-0.1-0.3-0.4-0.7-1-1c-0.2-0.1-0.3-0.1-0.5-0.1l-0.8,0.1l0.6-0.8\n                c0.3-0.4,0.2-0.9-0.1-1.3c-0.3-0.3-0.8-0.4-1.2-0.2l-5.2,3.2c-0.4,0.3-0.6,0.8-0.4,1.2h3.2c0.1,0,0.2-0.1,0.3-0.1\n                c0.1,0,0.1,0.1,0.2,0.1h1.1l0.9-0.1c0.2,0,0.3,0.1,0.4,0.1h2.5C111,141.6,111.1,141.1,110.9,140.7z M142,141.1l-4.6-2.3\n                c1.2,0.2,1.9,0.3,2.2,0.4c0,0,0,0,0.1,0c0,0,0,0,0,0v0c0.1,0,0.2,0,0.2,0c0.5,0,0.9-0.4,1-0.9c0-0.5-0.4-1-0.9-1.1\n                c-0.1,0-0.5-0.1-0.9-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.3-0.2-0.5-0.4-0.7l-2-1.6c-0.4-0.3-0.9-0.3-1.2,0c-0.1-0.3-0.1-0.5-0.2-0.7\n                l0.1-0.2c0.1-0.2,0.3-0.3,0.4-0.5c0,0,0-0.1,0.1-0.1c0.3,0.1,0.7,0,0.9-0.3l1.3-1.3c0.2,0.2,0.4,0.4,0.5,0.6l0.1,0.1\n                c0.2,0.5,0.3,1.1,0.4,1.8c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0c0.5,0,1-0.5,0.9-1.1c0-0.1,0-0.5,0-1.2c0.3-0.3,0.6-0.6,0.9-0.9v-4.2\n                l-1.9,2.9c-0.3-0.4-0.6-0.8-1-1c-0.1-0.3-0.1-0.6,0-0.9c0.2-0.5-0.1-1-0.6-1.2c-0.5-0.2-1,0-1.3,0.5l-1.9,3.9c-0.2,0-0.3,0-0.5,0\n                c-0.7,0.2-1.2,0.7-1.3,1.4c-0.2,0.3-0.5,0.5-0.8,0.6c-0.7-0.2-1.2-0.3-1.7-0.4c-0.1-0.8-0.2-1.6-0.1-2.3c0.3-0.7,0.4-1.5,0.4-2.2\n                l0-0.2c0.6-1.3,1.8-1.4,3.7-0.5c0.2,0.1,0.5,0.2,0.7,0.4c0.5,0.2,1.1,0.1,1.3-0.4c0.2-0.5,0.1-1.1-0.4-1.3c-0.3-0.1-0.5-0.3-0.8-0.4\n                c-1.6-0.8-2.8-1.1-3.8-1.1c-2.3,0-2.6,2-2.7,3c-0.2,0.6-0.4,1.4-0.5,2.3c-0.1,0.1-0.3,0.2-0.6,0.2c-0.5,0-1.1-0.1-1.8-0.4\n                c-0.4-0.1-0.8,0-1,0.2c-0.3,0.3-0.3,0.7-0.2,1l0.7,1.9c0.1,0.3,0.4,0.6,0.8,0.6l1.7,0.3l0.1,1.2c0,0.2,0,0.4,0.1,0.6l0.6,6.2\n                c0,0,0,0.1,0,0.1h2.2c0.8-1.2,0.2-3.1-0.3-4.7c-0.2-0.7-0.4-1.3-0.5-1.8l0-0.3c0.7,0.2,1.4,0.3,2,0.2c0.6,1.1,1.9,2,3.8,2.7\n                c0.1,0.2,0.3,0.4,0.6,0.5c-0.3,0-0.6,0.2-0.8,0.5l-0.3,0.6l-2.8-0.2c-0.5,0-0.9,0.3-1,0.8c-0.1,0.5,0.2,1,0.7,1.1l1.7,0.6h7.8V141.1\n                z M86.8,138.9c-0.4-0.3-1-0.3-1.3,0.1l-3,3h3.3l1.2-1.8C87.2,139.8,87.2,139.3,86.8,138.9z M40.9,0h-6.2l-0.2,0.1\n                C34.2,0.3,34,0.6,34,1c0.1,1.8-1.8,4.4-3.4,6.6l-0.8,1c-0.2,0.3-0.2,0.6-0.1,0.8c-0.1,0.4,0,0.7,0.3,1c0.2,0.2,0.4,0.3,0.7,0.3\n                c0.3,0,0.5-0.1,0.7-0.3l6.3-6.6c0.2-0.2,0.5-0.5,0.7-0.7c0.2,0.4,0.6,0.7,1,0.6l0.4-0.1c0.2,0,0.3,0,0.5,0l-0.6,0.8\n                c-0.3,0.4-0.2,1,0.2,1.4C39.9,5.9,40.1,6,40.3,6l-2.4,1.5c-0.4,0.3-0.6,0.8-0.3,1.3l2.4,4.5c0.2,0.3,0.5,0.5,0.9,0.5\n                c0.1,0,0.1,0,0.2,0c0.4-0.1,0.7-0.4,0.8-0.8l0.8-5c0-0.2,0-0.4-0.1-0.6l-0.6-1.1c-0.1-0.2-0.3-0.4-0.6-0.5c-0.1,0-0.2,0-0.3,0\n                c0,0,0.1,0,0.1-0.1c0.8-0.9,1.7-1.5,2.8-1.6c0.4,0,0.9,0,1.3,0c1.7,0.2,3.6,1.1,5.5,2.2l0,0.8c0,0.3,0.2,0.6,0.4,0.7\n                c0.2,0.2,0.5,0.2,0.8,0.2c0.4-0.1,0.7-0.1,1.1-0.2l0.2,0c0.7,0.4,1.3,0.7,1.9,0.9c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.1,0.8-0.4\n                l2-2.8c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0.3,0.5,0.4,0.8,0.4c0,0,0,0,0,0c0.3,0,0.5-0.1,0.6-0.2l7.8,5.9c0.1,0.1,0.2,0.1,0.3,0.1\n                c-0.4,0-0.7,0.3-0.8,0.6c-0.2,0.7-0.1,0.8,1.7,2.4v1.5c0,0.5,0.3,0.9,0.8,1c0.1,0,0.1,0,0.2,0c0.4,0,0.8-0.3,0.9-0.7l0.8-2.5\n                c0.4-0.2,0.6-0.4,0.9-0.7c0.5-0.7,0.6-1.8,0.3-3.3c-0.1-0.4-0.5-0.8-0.9-0.8c-0.5,0-0.8,0.3-1,0.7L70,11.8c-0.4-0.1-0.9-0.3-1.2-0.4\n                c-0.1-0.1-0.3-0.1-0.4-0.1c0.2,0,0.4-0.1,0.5-0.3c0.3-0.4,0.3-1,0-1.3l-5-5.1l4.9-3.3C69.2,1,69.3,0.4,69.1,0h-2.2l-6,3\n                c0.1-0.2,0.2-0.5,0.4-0.8c0.3-0.5,0.6-1,0.9-1.5c0.2-0.3,0.3-0.5,0.5-0.8h-2.5c-0.2,0.4-0.4,0.9-0.6,1.3c-0.3,0.6-0.5,1-0.6,1.4\n                l-0.2,0.4c-0.3,0.5-0.4,0.9-0.5,1.1c0,0-0.1-0.1-0.1-0.1c-0.4-0.3-0.9-0.4-1.3,0c-1.2,1-2.3,1.3-3.2,1.5c-0.3-0.2-0.7-0.4-1-0.6\n                L52.3,0h-2.9c-2,1.6-3.3,2-4.2,2.1c-0.5,0-0.9,0-1.4,0c-0.2,0-0.3,0-0.5-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.6-0.5-1-0.5l-2.8,0.4\n                c0,0,0,0-0.1,0c0.1-0.1,0.2-0.2,0.2-0.3L40.9,0z M111.2,103.4l-0.3-0.3c0-0.2-0.1-0.3-0.3-0.4c-0.2-0.2-0.4-0.4-0.7-0.7\n                c-0.3-0.3-0.6-0.5-0.8-0.8c-1.7-2.1-1.8-3.5-0.4-5c0.3-0.3,0.4-0.9,0.1-1.3c-0.3-0.4-0.8-0.5-1.2-0.3c-1.4,0.8-2.3,1.7-2.4,2.9\n                c-0.3,1.9,1.1,3.6,2.5,5c0.3,0.3,0.5,0.6,0.8,1l-1.2,1.2c-0.3,0.3-0.4,0.8-0.1,1.2c0.2,0.4,0.7,0.6,1.1,0.4c0.8-0.3,1.4,0.3,2.2,1.1\n                c0,0,0,0,0,0c-0.2,0.2-0.4,0.4-0.5,0.5c-0.2,0.2-0.3,0.3-0.5,0.5c0-0.3-0.2-0.5-0.4-0.7c-0.4-0.3-1-0.2-1.3,0.2\n                c-2.1,2.5-6.2,3.8-10.3,5.1c-2,0.6-4.2,1.3-6,2.1c-0.4,0.2-0.7,0.7-0.6,1.1c0.1,0.5,0.5,0.8,1,0.7c0.1,0,0.1,0,0.2,0\n                c-0.3,0.3-0.3,0.7-0.1,1.1c0.7,1.3,1.5,2.5,2.6,3.6l4.6,6.5c0.3,0.4,0.7,0.5,1.1,0.3c0.4-0.2,0.7-0.6,0.6-1l-0.1-0.5\n                c0.9,0.5,1.8,0.9,2.8,1.3c1.7,1.1,3.1,2.2,4.1,3.4l-0.9-0.3c-0.3-0.1-0.7-0.1-0.9,0.2c0,0,0,0.1-0.1,0.1c-0.2-0.4-0.8-0.6-1.2-0.4\n                c-0.4,0.2-0.6,0.5-0.6,0.9c0,0.1,0,0.3,0.1,0.4c0.6,1.3,0.1,2.8-1.5,4.7c-0.4,0.3-0.8,0.7-1.2,1c-1,0.8-2,1.7-2.8,2.7\n                c-0.4,0.4-0.8,0.7-0.8,1.1h2.6c1-0.8,2.4-2,3.6-3.4c1-0.9,2-2.1,2.3-3.6c0,0,0,0,0.1,0l3.1,1.1c0.1,0,0.2,0.1,0.3,0.1\n                c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.4-0.9l-0.2-1.7c0.7-4-3-5.6-6.1-7c-0.6-0.4-1.2-0.7-1.8-1.1c-2.4-1.5-4.8-2.9-6.7-5\n                l-2.4-3.4c-0.1-0.1-0.1-0.2-0.2-0.2c0.5-0.1,0.9-0.1,1.2-0.1c0,0.4,0.3,0.8,0.7,0.9c0.1,0,0.2,0,0.3,0c0.4,0,0.7-0.2,0.9-0.6\n                c0.8-1.7,3.4-2.6,5.9-3.6c1.6-0.6,3.3-1.2,4.6-2.1c0,0.1,0,0.2,0.1,0.2c-0.5,1.2-0.5,2.5,0,3.9c0.1,0.4,0.5,0.7,0.9,0.7h2\n                c0.5,0,1-0.4,1-1v-3.7c2-0.7,3-1.5,3.3-2.6C114.8,107.1,113.1,105.3,111.2,103.4z M103,117.8c0.5,0,1.1,0.2,1.5,0.3\n                c1.1,0.8,2.1,1.4,3.1,1.7l0.3,2.5c0,0.4,0.3,0.7,0.7,0.8c0.4,0.1,0.8,0,1-0.3l2.6-3.4c0.8-0.5,1.4-1.3,1.7-2.4\n                c0.1-0.5-0.1-0.9-0.5-1.2c-0.4-0.2-0.9-0.1-1.2,0.3l-1.3,1.7c-1,0.3-2.7-0.4-4.3-1c-0.5-0.2-0.9-0.4-1.4-0.5\n                c-1.6-1.1-2.8-1.8-3.7-1.8c-0.6,0-1,0.2-1.4,0.6c-0.6,0.8-0.6,2,0,4.1l0.3,2.2c0,0.3,0.2,0.5,0.4,0.7l2.7,2.1\n                c0.2,0.1,0.4,0.2,0.6,0.2c0.2,0,0.3,0,0.5-0.1c0.3-0.2,0.5-0.6,0.5-1l-0.3-2.2c0-0.3-0.2-0.5-0.4-0.7l-2.3-1.8\n                C102.4,117.8,102.7,117.8,103,117.8z M79.4,0.2c1,1.7,1.6,3.5,1.9,4.3c0.2,0.5,0.4,1.1,1.1,1.1c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.4\n                c0.3-0.3,0.3-0.5,0.1-1.4L85.8,0h-3.3l-0.3,0.3L82,0h-2.8L79.4,0.2z M90,114c-0.4-0.3-1-0.2-1.3,0.2c-0.3,0.3-0.5,0.7-0.8,1\n                c-0.6,0.9-1.2,1.7-2.1,2.3l-3.1,0.5l0.7-1c0.8-0.8,1.9-1.5,2.8-2c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0.5-0.3,1-0.6,1.4-0.9l1.1-0.7c0.4-0.3,0.6-0.8,0.4-1.3l-0.6-1.1c-0.2-0.3-0.5-0.5-0.8-0.5c-0.4,0-0.7,0.1-0.9,0.4l-0.4,0.5\n                l-5.9,0.9c-0.3,0-0.5,0.2-0.6,0.4l-1.4,1.9c-0.2,0.3-0.2,0.7-0.1,1.1c0.2,0.3,0.6,0.5,0.9,0.5c0.4,0,0.8-0.1,1.2-0.1\n                c0.4-0.1,0.8-0.1,1.2-0.1c-0.8,0.7-1.3,1.5-1.6,2.2l-1.6,2.2c-0.1,0.1-0.3,0.1-0.4,0.2l-2.4,0.4c-0.3,0-0.5,0.2-0.6,0.4l-2,2.8\n                c-0.3,0.4-0.2,1,0.2,1.3c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c1.2-1.2,2.5-2.2,4.1-2.9l0.5-0.1c0.3,0,0.5-0.2,0.6-0.4\n                c0.8-0.3,1.6-0.5,2.4-0.8c0.1,0,0.3-0.1,0.4-0.1l3.4,2c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.5-0.3,0.6-0.6\n                l1.4-3.9c0.1-0.3,0.1-0.7-0.2-0.9c0.6-0.7,1.1-1.4,1.6-2.3C90.6,114.8,90.5,114.3,90,114z M47.4,109.8c-1.3-0.9-3-1.5-4.6-2.2\n                c-3-1.2-6-2.4-6.2-4.6c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.3-1,0.8c-0.7,2.8,1.9,4.1,4,5.2c2.3,1.1,3.3,1.8,3,2.9\n                c-0.1,0.5,0.1,1,0.6,1.2c0.1,0,0.2,0.1,0.4,0.1c0.3,0,0.7-0.2,0.9-0.5c0.2-0.3,0.4-0.4,0.9-0.4c0.1,0,0.2,0,0.4,0\n                c-0.3,0.7-0.3,1.5-0.3,2.2c0,0.3,0,0.6,0,0.9l1,0.1l1,0.1c0-0.3,0-0.7,0-1.1c0-1.5,0.1-1.8,0.7-2c0.3-0.1,0.5-0.3,0.6-0.6\n                C48,110.5,47.8,110.1,47.4,109.8z M89.6,95.3c-0.2-0.3-0.5-0.5-0.8-0.5h-3.9c-0.5,0-0.9,0.3-1,0.8c-0.1,0.4,0.1,0.9,0.5,1.1l2.3,1.1\n                l-0.7,1.5c-1.1,1.2-1.7,1.8-2.8,1.5c-0.5-0.1-1.1,0.2-1.2,0.7c-0.2,0.5,0.1,1.1,0.7,1.2c0.9,0.3,1,0.7,1,1.1c-1,1.4-1.2,1.8-0.9,2.4\n                c0.2,0.3,0.5,0.6,0.9,0.6c0.9,0,1.6-1.4,1.8-2.1l0.3-0.3c0-0.1,0.1-0.1,0.1-0.2l1.9-3.7l0.2-0.2c0.5-0.6,1-1.2,1.6-1.6\n                c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.2-0.6-0.5-0.8l0.3-0.7C89.8,96,89.8,95.6,89.6,95.3z M50.5,114.9c-0.1-0.4-0.4-0.6-0.8-0.7\n                c-0.4-0.1-0.7,0.1-0.9,0.4l-3.9,5.9c-0.2,0.3-0.2,0.7,0,1c0.2,0.3,0.5,0.5,0.9,0.5h3.9c0.4,0,0.8-0.2,0.9-0.6\n                c0.2-0.4,0.1-0.8-0.2-1.1l-1.3-1.3c0,0,0,0,0,0C49.9,118.2,51.1,116.9,50.5,114.9z M35.2,117.1l1.2,0c0.7,0,1.4,0,2,0.3\n                c0.5,0.6,1,1.1,1.6,1.6c0.4,0.3,0.9,0.2,1.2-0.1c0.3-0.3,0.4-0.8,0.2-1.2c-0.4-0.9-1-1.5-1.8-1.9l0,0c-1-1.2-2.2-2.7-4.1-2.7\n                c-0.4,0-0.7,0.1-1.1,0.2c-0.5,0.1-0.8,0.6-0.7,1c0,0.5,0,1,0,1.3c-0.5,0.4-0.9,0.8-1.2,1.2c-1-0.5-2.2-0.4-3.6,0.2\n                c-1.5-0.4-2.8-1.1-3.4-1.6c-0.4-0.3-1-0.3-1.4,0.1c-0.3,0.4-0.3,1,0.1,1.4c0.8,0.7,1.4,1.5,1.9,2.5c-0.4,0.4-0.4,0.9-0.1,1.3\n                c0.2,0.3,0.5,0.5,0.7,0.8l0.2,0.3l0.2,0.8c0.1,0.4,0.2,0.8,0.4,1.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.8-1.4,1.4-2.2,1.1\n                c-0.4-0.1-0.9,0-1.1,0.4c-0.2,0.4-0.2,0.9,0.1,1.2c0.2,0.3,0.5,0.5,0.7,0.8c1,1,1.3,1.5,1.1,2.2c-0.1,0.4,0,0.9,0.4,1.2\n                c0.4,0.2,0.9,0.2,1.2-0.1l1.8-1.8c0,0,0,0,0,0l2.9,1.9c0.2,0.1,0.4,0.2,0.5,0.2c0.3,0,0.6-0.1,0.8-0.4c0.3-0.4,0.2-1-0.2-1.4\n                c-0.2-0.2-0.5-0.4-0.7-0.6c-0.7-0.7-1.6-1.5-2.8-1.7l-1.5-1l1.1-1.1c0,0,0,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.6-1.7-0.4-3-1-3.6\n                c-0.1-0.3-0.2-0.6-0.3-0.9l0.8-0.8c0.6,0.1,1.2,0.2,1.8,0.2c0.4,0,0.8,0,1.2-0.1c0.2,0.7,0.6,1.4,1.2,2.3l0,0.1\n                c0.6,1.6,1.3,3.4,3.1,3.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0h0c0,0,0,0,0,0c0.2,0,0.4-0.1,0.6-0.2\n                c0,0,0.1-0.1,0.1-0.1l2-2c0.4-0.4,0.4-1,0-1.4L38,120c-0.4-0.4-1-0.4-1.4,0l-1,1c-0.1-0.2-0.2-0.3-0.4-0.5c-0.3-0.8-0.6-1.5-1-2.1\n                C34.6,118,35,117.6,35.2,117.1z M62.9,102.5l-1.6,6.2c-0.1,0.4,0,0.8,0.3,1c0.2,0.2,0.4,0.2,0.6,0.2c0.1,0,0.3,0,0.4-0.1\n                c1.9-0.9,2-3.2,2.1-5.1c0-0.7,0-1.3,0.1-1.8l0.1-0.5c0-0.1,0.1-0.2,0.1-0.2c0.7,0.3,1.3,0.4,1.9,0.3c0.3,0.8,1,1.8,2.7,2.6\n                c0.1,0.4,0.4,0.6,0.8,0.7c1.4,0.2,2.1,0.4,2.4,0.4c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0c0.5,0,0.9-0.4,1-0.9\n                c0-0.5-0.4-1-0.9-1.1c-0.1,0-0.2-0.1-0.4-0.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.3-0.1-0.5-0.2-0.7l-1.4-1.6c-0.3-0.3-0.7-0.4-1.1-0.3\n                c0-0.1,0-0.2,0.1-0.3l0.9-0.7c0.4-0.3,0.5-0.8,0.3-1.2c-0.2-0.4-0.7-0.6-1.2-0.5c-0.7,0.2-1.2,0.6-1.6,1.2c-0.4,0.3-0.9,0.6-1.3,0.8\n                c-0.4-0.2-0.9-0.3-1.2-0.3c0.2-0.7,0.4-1.4,0.7-2.1c0.5-0.6,0.9-1.4,1.2-2.1l0.1-0.3c1.2-1.5,2.5-1.7,4.2-0.8\n                c0.2,0.1,0.4,0.2,0.6,0.3c0.5,0.3,1.1,0.2,1.3-0.3c0.3-0.5,0.2-1.1-0.3-1.4c-0.1-0.1-0.2-0.1-0.3-0.2c0.2,0,0.4,0.1,0.6,0\n                c0.8-0.3,1.4,0.3,2.2,1.1c0.3,0.3,0.5,0.5,0.8,0.7c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.3,0.5-0.7,0.4-1.1\n                c-0.5-1.4-1.4-2.8-2.2-4.2c-1.9-3.1-3-5.2-1.9-6.7c0.3-0.4,0.3-0.9,0-1.3c-0.3-0.4-0.9-0.4-1.3-0.2c-2.6,1.7-1.3,4.3-0.4,6.2\n                c1.1,2.3,1.3,3.1,0.4,3.7c-0.4,0.3-0.6,0.8-0.4,1.3c0,0.1,0.1,0.2,0.2,0.2c-1.3-0.8-2.5-1.1-3.4-1.1c-2.1,0-2.9,1.7-3.3,2.7\n                c-0.5,0.7-0.9,1.4-1.3,2.4c-0.3,0.3-0.6,0.4-1.1,0.4c0,0,0,0,0,0c-0.4,0-1-0.1-1.6-0.4c-0.3-0.1-0.6-0.1-0.9,0.1\n                c-0.3,0.2-0.4,0.5-0.4,0.8v1.9c0,0.5,0.3,0.9,0.8,1l1.3,0.2l-0.2,0.9C63,102.1,63,102.3,62.9,102.5z M49,125.2\n                c-0.1-0.5-0.3-1.2-1.1-1.2c-0.9,0-1,0.3-1.2,2.8l-1.2,0.9c-0.4,0.3-0.5,0.8-0.3,1.2c0.2,0.4,0.5,0.6,0.9,0.6c0.1,0,0.2,0,0.3,0\n                l2.5-0.7c1.1,0.7,2.4,0.3,3.9-1.3c0.3-0.3,0.4-0.8,0.1-1.2c-0.2-0.4-0.7-0.6-1.1-0.4l-2.3,0.7C49.2,126,49.1,125.5,49,125.2z\n                 M21.7,132.6c0.2-0.2,0.3-0.6,0.2-0.9c-0.1-0.3-0.3-0.6-0.6-0.7c-0.6-0.2-1.3-0.4-1.9-0.4c-1.6,0-3.1,0.7-4.3,1.3c-1,0.5-2,1-2.8,1\n                c-0.4,0-1-0.1-1.7-0.8c1.6-1.4,1.6-3.7,1.5-5.3l0-0.8c0-0.4-0.2-0.7-0.5-0.9c-0.3-0.2-0.7-0.1-1,0.1c-2.5,1.7-3.7,3.6-3.7,5.6\n                c0,3.3,3.2,5.7,4.9,6.9c0.1,0.1,0.2,0.2,0.4,0.3c0,0.1,0,0.1,0.1,0.2c0.1,0.4,0.5,0.7,0.9,0.7c0.8,0,1.1-0.6,1.1-0.7\n                c0.2-0.5,0-0.9-0.3-1.1c0.1-0.5,0.5-1,1.1-1.7c0.2-0.2,0.3-0.4,0.5-0.5c0.7-0.1,1.3,0.4,2,1.1c0.3,0.3,0.5,0.5,0.8,0.7\n                c0.3,0.3,0.8,0.3,1.2,0.1c0.4-0.2,0.5-0.7,0.4-1.1c-0.3-0.8,0.1-1.2,1.1-2.2C21.3,133.1,21.5,132.9,21.7,132.6z M2.5,50.1\n                c0.1-0.7-0.1-1.2-0.3-1.4C1.6,48,0.7,48,0.4,48c-0.1,0-0.1,0-0.2,0l0-0.7c0-0.2-0.1-0.3-0.2-0.5v8.7c0.2-0.1,0.5-0.2,0.7-0.2\n                c0.9-0.3,1.8-0.6,2.7-0.9c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.1c0.5-0.2,1-0.5,1.5-0.8c1.5-0.9,2.7-2.2,3.5-4c0.2-0.5,0.1-1-0.3-1.3\n                c-0.4-0.3-1-0.2-1.3,0.2c-0.3,0.3-0.5,0.7-0.8,1c-0.6,0.9-1.3,1.7-2.2,2.4c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0-0.5,0.1-0.8,0.1\n                c-0.4,0.1-0.9,0.1-1.3,0.1l1.5-2.1C2.4,50.4,2.5,50.3,2.5,50.1z M28.2,142H32c0.1-0.5,0-1.1,0-1.6c0.4-1.2,0.3-2.6-0.2-4\n                c-0.1-0.4-0.6-0.7-1-0.6c-0.4,0-0.8,0.3-0.9,0.8c-0.2,1-0.1,2.2,0.1,3.3l0,0.3C29.7,140.8,29.1,141.4,28.2,142z M28.8,137.2l-4.9-3\n                c-0.3-0.2-0.6-0.2-0.8-0.1c-0.3,0.1-0.5,0.3-0.6,0.6l-1.4,3.9c-0.1,0.3-0.1,0.7,0.2,1c0.2,0.2,0.5,0.4,0.8,0.4c0,0,0.1,0,0.1,0\n                l6.4-0.9c0.4-0.1,0.7-0.4,0.8-0.8C29.3,137.9,29.1,137.4,28.8,137.2z M114.2,75.5c-0.1-0.4-0.6-0.7-1-0.6c-0.4,0-0.8,0.3-0.9,0.8\n                c-0.2,1-0.1,2.2,0.1,3.4l0,0.3c-0.3,0.7-1,1.4-1.9,2c-0.5-0.2-1.2-0.4-1.9-0.7c-0.4-0.2-0.8-0.1-1.1,0.2c-0.3,0.3-0.4,0.7-0.2,1.1\n                l0.3,0.9c-0.1,0.1-0.3,0.1-0.4,0.2l-0.2,0.1c-1.6-0.1-2.3,0.6-2.6,1.3c-0.7,0.4-1.4,1.1-1.5,2.1c-0.1,1.3,0.9,2.4,1.7,3.1\n                c0.1,0.1,0.3,0.2,0.5,0.2l3,0.5c0.1,0,0.1,0,0.2,0c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5,0-1-0.5-1.2c-1.3-0.7-1.7-1.7-2.1-2.9\n                c0-0.1,0-0.1-0.1-0.2c0.3-0.1,0.5-0.3,0.8-0.4c0.2,0,0.5,0.1,0.7,0.1c0.4,0.1,0.8,0.1,1.1,0.1c0.3,0,0.7-0.1,0.9-0.4\n                c0.2-0.3,0.3-0.6,0.1-0.9l-0.1-0.2c0.2-0.1,0.5-0.2,0.7-0.4c1.4,0.3,2.4,0.1,3-0.7c0.7-0.8,0.7-2,0.6-3.2\n                C114.9,78.3,114.8,77,114.2,75.5z M98.1,4.2c0,0,0.1,0,0.1,0c1,0.3,2,1.2,2.8,2.1c0.6,0.7,1.2,1.3,1.8,1.8c0.1,0.1,0.3,0.2,0.4,0.2\n                c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0,0.5-0.1,0.7-0.3l2-2c0.2-0.2,0.3-0.4,0.3-0.7\n                c0-0.3-0.1-0.5-0.3-0.7l-1.4-1.4c-0.4-0.4-1-0.4-1.4,0l-1.2,1.2c-0.9-1.1-2-2.2-3.6-2.3c-1-0.2-2.1-0.2-3.2,0.2\n                c-0.1,0-0.3,0.1-0.4,0.2c-0.7,0.6-1.3,1.8-0.4,3.8c0,0.4,0,0.8,0.2,1.2c0,0.2,0.1,0.3,0.3,0.4c1,1,1.5,1.5,1.7,1.7c0,0,0,0,0.1,0.1\n                c0.2,0.2,0.5,0.3,0.7,0.3c0.4,0,0.7-0.2,0.9-0.6c0.2-0.4,0-0.8-0.2-1.1v0c-0.2-0.2-1-1.1-1.5-2.2c0.2-0.5,0.6-0.9,1.1-1.4\n                C97.8,4.5,98,4.4,98.1,4.2z M31.1,40.3l4.5-5.8c0.2-0.3,0.6-0.4,0.9-0.4c0.4,0.1,0.6,0.3,0.8,0.6c0.8,2.1,1.8,2.6,2.7,2.7\n                c0.5,0,1,0,1.4,0c0.4,0,0.7-0.1,1.1-0.1c0.1-0.2,0.2-0.3,0.3-0.4c0.2-0.2,0.5-0.3,0.8-0.2l2.5,0.4c0.1,0,0.3,0,0.4,0.1\n                c0.5,0.1,0.9,0.6,0.8,1.2c0,0.1,0,0.1-0.1,0.1c0.3-0.4,0.8-0.6,1.2-0.3c0.3,0.1,0.6,0.3,0.9,0.4c0.4,0,0.9-0.3,1.4-0.6\n                c0.3-0.2,0.6-0.4,0.9-0.5c0.5-0.2,1-0.1,1.3,0.4l1.1,1.7l3.4-2.2c0.2-0.1,0.5-0.2,0.8-0.1c0.3,0.1,0.5,0.2,0.6,0.5l0,0l1.5-3.4\n                c-0.5-0.8-0.9-0.8-1-0.8c-0.5,0-1.3,0.4-2,0.9c-1,0.6-2.1,1.2-3.2,1.2c-0.2,0-0.3,0-0.4,0c-0.9,0-1.4,0-1.5,0c0,0-0.1,0-0.1,0\n                c-0.5,0-1-0.4-1-0.9c0-0.5,0.4-1,0.9-1c0.8-0.1,1.4-0.2,1.8-0.4c-0.4-0.2-0.7-0.5-0.8-0.7c-0.3-0.4-0.5-1.2-0.1-2.3\n                c0.1-0.3,0.4-0.5,0.7-0.6c0.3-0.1,0.7,0,0.9,0.3l1.7,1.7c2.1-0.2,5.2-1.6,7-3.6l1-2.3c-0.1,0.1-0.2,0.3-0.4,0.4l-0.8,0.4\n                c0,0.1,0,0.2-0.1,0.3c-0.2,0.3-0.5,0.6-0.9,0.6c0,0,0,0,0,0c-0.4,0-0.7-0.2-1.1-0.5c-0.2-0.2-0.4-0.5-0.4-0.8\n                c-0.2-0.2-0.4-0.5-0.7-0.8c-0.9-1.2-2.2-2.7-3.4-4.4l-0.4-0.2c-0.5-0.2-0.8-0.8-0.6-1.3l0,0c-0.8-1.2-1.5-2.3-1.9-3.3\n                c-0.3-0.5-0.6-1-0.6-1.6c-0.1-0.5,0.3-1,0.8-1.1c0.5-0.1,1,0.2,1.1,0.6c0.1,0.3,0.2,0.6,0.4,0.9c0.3,0.3,0.9,0.6,1.6,0.8\n                c0.3,0.1,0.7,0.3,1,0.4c0.5,0.2,0.7,0.7,0.5,1.2L57.4,19l0.1,0.1l4.2,1.5c0.5,0.2,0.8,0.8,0.6,1.3l-0.6,1.7l1.7,0.6\n                c0.4,0.1,0.6,0.5,0.6,0.9c0,0.2,0,0.3-0.1,0.4l0.5-1.2c0.2-0.4,0.6-0.7,1.1-0.6c0.5,0.1,0.8,0.5,0.8,1c0,1.5-0.6,3-1.8,4.3l-2.2,5.2\n                c0.6,2-0.6,3.3-1.5,4.2c-0.2,0.2-0.4,0.4-0.6,0.7c0,0.1-0.1,0.1-0.2,0.1l1-0.6c0.3-0.2,0.7-0.2,1.1,0c0.3,0.2,0.5,0.6,0.4,1l-0.1,1\n                c0.2,0.2,0.3,0.4,0.3,0.7c0,0.9-0.9,1.1-1.3,1.1c0,0-0.1,0-0.1,0c-0.3,0-0.5-0.1-0.7-0.3c0,0,0,0,0,0c-0.3,0-0.6,0-1-0.1\n                c-1.4-0.1-3.3-0.2-5.2-0.5L54,41.8C53.8,42,53.5,42,53.2,42c-0.3-0.1-0.5-0.2-0.6-0.5l-0.1-0.1c-1.4-0.2-2.6-0.5-3.6-0.8\n                c-0.5-0.1-1.1-0.3-1.6-0.7c-0.3-0.3-0.5-0.7-0.3-1.1c-0.2,0.3-0.6,0.5-1,0.4l-0.3-0.1c-0.4-0.1-0.9,0-1.4,0v1.3c0,0.5-0.4,0.9-0.9,1\n                c-0.5,0-1-0.3-1-0.8c-0.1-0.7-0.4-1-1.1-1.1c-0.5,0-0.9,0-1.3,0c-2,0.2-4.8,1.3-7.6,2.4L31.5,43c-0.2,0.3-0.6,0.5-1,0.3\n                c-0.3-0.1-0.6-0.1-0.9-0.2l-0.2,0c-0.9,0.4-1.8,0.7-2.5,0.9c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.4-0.5-0.4-0.8\n                v-2.8c0-0.5,0.3-0.9,0.8-1c0.4-0.1,0.9,0.1,1.1,0.5c0.3,0.7,0.9,1,1.8,1.2c0.6-0.2,1.2-0.5,1.8-0.7L31.1,40.3z M59.6,39.5L59.6,39.5\n                l0.1,0C59.7,39.5,59.7,39.5,59.6,39.5z M71.7,5.5L72.2,6C73,6.9,73.7,8.4,74,9.6c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.3-0.1,0.6,0.1,0.8\n                c0.3,0.6,0.7,1.3,1.5,1.3c0.3,0,0.6-0.2,0.8-0.4c0.2-0.2,0.3-0.4,0.3-0.7c0.3,0,0.7,0,1-0.1c-0.1,0-0.2,0.1-0.2,0.2l-1,1.1\n                c-0.2,0.2-0.3,0.5-0.2,0.7c0,0.3,0.2,0.5,0.4,0.7l0.9,0.7c0.3,0.3,0.7,0.5,1,0.8c0.1,0.1,0.2,0.2,0.3,0.2c0.6,0.5,1.3,1.2,1.8,1.8\n                l0.6,1.6c-0.1,0-0.2,0-0.4,0c-0.4,0-0.9-0.1-1.3-0.1c-0.3,0-0.5-0.1-0.8-0.1c-0.3-0.2-0.6-0.4-0.9-0.6c-0.6-0.6-0.9-1.4-1.2-2.2\n                c-0.1-0.4-0.3-0.7-0.4-1.1c-0.2-0.4-0.7-0.7-1.2-0.5c-0.5,0.1-0.8,0.6-0.7,1.1c0.3,1.8,1,3.2,2.2,4.2c0.4,0.3,0.8,0.6,1.3,0.9\n                c0.1,0.1,0.2,0.1,0.4,0.1c0.7,0.4,1.5,0.6,2.3,0.9c0.6,0.2,1.3,0.4,1.9,0.7c0.1,0.2,0.4,0.4,0.7,0.5l0.4,0.1\n                c1.3,0.7,2.2,1.6,2.9,2.7c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.3,0,0.4-0.1c0.5-0.2,0.7-0.8,0.5-1.2l-1-2.8c-0.1-0.3-0.4-0.6-0.8-0.6\n                l-2.3-0.4c-0.1,0-0.1-0.1-0.2-0.1l-0.7-2c0-0.8-0.3-1.6-0.9-2.5l0,0c0.2-0.1,1,0,1.7,0.1c0.4,0.1,0.8,0.1,1.1,0.1\n                c0.3,0,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.6,0.1-0.9l-0.7-1.9c-0.1-0.3-0.4-0.6-0.8-0.6l-5.4-0.9l-0.1-0.3c-0.1-0.2-0.3-0.4-0.5-0.5\n                c0.4,0,0.8,0,1.1-0.1l2.1,0.3c0.3,0.1,0.6,0,0.8-0.2c0.2-0.2,0.3-0.5,0.3-0.8c0-0.6-0.1-1.2-0.3-1.8c0-1-0.6-2.4-1.8-4.2\n                C80.2,4.1,80.1,4,80,3.9l-1.2-0.7C77,1.8,75,0.7,72.8,0.1c-0.5-0.1-1,0.1-1.2,0.6c-0.2,0.5,0,1,0.5,1.2l5.5,3\n                c1.2,1.1,2.1,2.4,2.6,3.7c-0.1,0.1-0.3,0.2-0.9,0.3l-2.9-0.5c-0.3-1.6-1.6-2.9-2.9-4c-0.2-0.2-0.4-0.4-0.7-0.6l-1.7-1.4\n                c-0.3-0.2-0.6-0.2-1-0.1c-0.3,0.1-0.6,0.4-0.6,0.8c0,0-0.1,0.1-0.5,0.1c-0.4,0-0.9-0.1-1.3-0.1C67.3,3.1,66.9,3,66.6,3\n                c-0.5,0-1,0.3-1,0.8c-0.1,0.5,0.2,1,0.7,1.1c0.5,0.1,1,0.6,1.4,1.3c0.7,2.3,1,2.9,1.8,2.9c0.4,0,0.7-0.2,0.9-0.5\n                c0.4-0.7-0.2-2-0.6-2.8C70.3,5.4,71,5.1,71.7,5.5z M56.6,11.7c-0.5,0.2-0.8,0.6-0.7,1.1c0.1,0.5,0.6,0.8,1.1,0.8\n                c0.8-0.1,1.6,0.1,2.4,0.7l0.5,0.5c0.4,0.4,0.9,0.9,1.3,1.3l0.4,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3l0.1,0.1\n                c0.4,0.5,0.8,1.1,1.2,1.6l-0.6,0.6c-0.3,0.3-0.4,0.7-0.2,1.1c0.2,0.4,0.5,0.6,0.9,0.6c0,0,0,0,0.1,0l4.3-0.3c0.5,0,0.8-0.4,0.9-0.8\n                c0.1-0.5-0.2-0.9-0.6-1.1c-0.6-0.3-1.2-0.5-1.7-0.9V18c0.7,0.1,1.4,0.3,1.9,0.7c0.2,0.2,0.3,0.4,0.5,0.7c0.2,0.5,0.8,0.7,1.3,0.4\n                c0.5-0.2,0.7-0.8,0.5-1.3c-0.2-0.5-0.5-0.9-0.9-1.2c-1.2-1.2-2.9-1.4-4.4-1.5c-0.3,0-0.5-0.1-0.8-0.1c-0.1-0.3-0.2-0.6-0.2-0.9\n                c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.5,0.2-0.8c0-0.3-0.2-0.5-0.4-0.7l-0.2-0.1c0.1-0.1,0.1-0.2,0.2-0.3\n                c0.2-0.3,0.3-0.7,0.1-1.1c-0.2-0.3-0.6-0.5-0.9-0.5l-2.1,0.1c-0.4,0-0.8,0.3-0.9,0.7c-0.1,0.4,0,0.8,0.4,1.1l0.8,0.6\n                c-0.2,0.6-0.3,1.1-0.4,1.7c0,0,0,0.1-0.1,0.1c-0.5-0.6-1-1.1-1.6-1.5c-0.6-0.6-1.2-1.2-1.5-1.8c0-0.4,0.1-0.8,0.1-1.2\n                c0-0.3,0-0.6,0-0.9c0-0.5-0.3-0.9-0.7-1c-0.5-0.1-0.9,0.1-1.1,0.5c-0.5,0.9-0.6,1.9-0.3,2.8C57,11.5,56.8,11.6,56.6,11.7z\n                 M92.4,41.1c-0.2-0.3-0.6-0.4-1-0.4l-5.5,1c-1.7-0.5-3.4-0.9-5.1-1.2c-2.5-1.8-2.8-2.5-2.8-2.7c0,0,0,0,0,0c0.1-0.5-0.1-1.1-0.7-1.2\n                c-0.5-0.2-1.1,0.1-1.2,0.6c0,0,0,0,0,0l0,0c0,0,0,0,0,0l-1,3.4c-0.1,0.3,0,0.6,0.2,0.9c0.2,0.2,0.5,0.4,0.8,0.4c0.9,0,2.3,0.2,4,0.5\n                l0.3,0.2c0.7,0.5,1.5,1.1,1.7,1.4c0.2,0.3,0.6,0.4,0.9,0.3l2.8-0.5c1.9,0.6,3.5,1.2,4.9,1.8c0.7,1.1,2,1.8,3.2,2.4\n                c0.2,0.3,0.1,0.5-0.1,0.8c-0.3,0.4-0.2,1,0.2,1.3c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3l1-1c0.5,0.2,1,0.5,1.4,0.8\n                c0,0,0,0,0,0c-0.1,1,0.1,1.9,0.2,2.8c0,0.2,0.1,0.5,0.1,0.7l-0.4,0c-0.3,0-0.5,0.1-0.7,0.3l-2,2c-0.3,0.3-0.4,0.7-0.2,1.1\n                c0.1,0.4,0.5,0.6,0.9,0.6l0.5,0c2.1,0,3.4-0.7,3.8-2c1.3,0.1,2.2,0.4,2.8,1.4c0.2,0.4,0.6,0.6,1.1,0.5c0.4-0.1,0.8-0.5,0.8-1v-2\n                c0-0.4-0.2-0.7-0.6-0.9c-0.9-0.4-1.7-0.7-2.2-0.9c-0.2-0.6-0.8-1.5-2.2-3.1c0-0.3,0-0.6-0.2-0.8c-0.1-0.1-0.1-0.2-0.2-0.2l-1.8-1.8\n                c-0.4-0.4-1-0.4-1.4,0l0,0l-0.7-0.3c-0.6-0.8-1.6-1.5-3-2.2c-0.2-0.5,0-1.2,0.3-2C92.7,41.8,92.6,41.4,92.4,41.1z M123.5,2.2\n                c0.9-0.5,2-1.2,2.8-2.2h-3.8c-0.1,0.2-0.3,0.5-0.4,0.7C123.5,2.2,122.1,2.1,123.5,2.2z M70.7,63.1c-0.1,0.5,0.2,1,0.7,1.2\n                c0.3,0.1,0.7,0.2,1.1,0.2c1.3,0.2,2.1,0.4,2.5,1.3l0,0v0c0.2,0.4,0.5,0.6,0.9,0.6c0.1,0,0.3,0,0.4-0.1c0.5-0.2,0.7-0.8,0.5-1.3\n                L74,59c-0.2-0.5-0.8-0.7-1.3-0.5c-0.5,0.2-0.7,0.7-0.6,1.2l0.9,2.8l-1.2-0.2C71.3,62.2,70.8,62.6,70.7,63.1z M136.6,103.8\n                c-0.4-0.2-0.8-0.1-1.1,0.2c-0.3,0.3-0.4,0.7-0.2,1.1l0.7,1.9c0.1,0.3,0.4,0.6,0.8,0.6l1.7,0.3c0.3,0.3,0.7,0.6,1.2,0.9\n                c0.1,0.1,0.2,0.1,0.4,0.2c0.6,0.2,1.3,0.4,1.9,0.5v-2.3c-0.3,0-0.7-0.1-1-0.1l-0.1-0.2c0,0,0,0,0,0l-0.5-1.3\n                c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.4-0.5,0.7-0.8l0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2v-3.9c-0.4-0.1-0.9-0.3-1.4-0.4\n                c-0.3-0.1-0.6-0.1-0.8,0.1l2.2-3.1v-1.2c0,0-0.1-0.1-0.1-0.1c-0.3-0.2-0.6-0.3-0.9-0.2c-0.3-0.1-0.7,0-0.9,0.2l-7.9,7.1\n                c-0.4,0.3-0.4,0.8-0.2,1.2c0.2,0.3,0.5,0.5,0.8,0.5c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3-0.1l3.7-1.4\n                c0.2-0.1,0.3-0.2,0.5-0.3l1.5-2c0,0.2,0,0.4,0,0.6l0.8,2.2l-0.6,0.7C138.7,104.3,137.9,104.4,136.6,103.8z M131,1.9\n                c-0.2-0.3-0.6-0.6-0.9-0.5l-2.1,0.1c-0.4,0-0.8,0.3-0.9,0.7c-0.1,0.4,0,0.8,0.4,1.1l0.8,0.6c-0.2,0.6-0.3,1.1-0.4,1.7\n                c-0.6,0.9-0.6,1.9-0.1,2.8c0.1,0.1,0.2,0.3,0.3,0.4l1,0.7c0.1,0.1,0.2,0.2,0.3,0.4l-1,1c-0.3,0.3-0.4,0.7-0.2,1.1\n                c0.2,0.4,0.5,0.6,0.9,0.6c0,0,0,0,0.1,0l4.3-0.2c0.5,0,0.8-0.4,0.9-0.8c0.1-0.5-0.2-0.9-0.6-1.1c-0.6-0.3-1.2-0.6-1.7-0.9\n                c0-0.3-0.2-0.5-0.4-0.7l-1.1-0.8c-0.4-0.6-0.6-1.2-0.6-1.8c0.2-0.2,0.4-0.4,0.6-0.6c0.3-0.3,0.5-0.5,0.7-0.8\n                c0.2-0.2,0.3-0.5,0.2-0.8c0-0.3-0.2-0.5-0.4-0.7l-0.2-0.1c0.1-0.1,0.1-0.2,0.2-0.3C131.1,2.7,131.2,2.3,131,1.9z M48.6,5.6\n                c-0.3-0.3-0.8-0.4-1.2-0.1l-3.6,2.3c-0.3,0.2-0.5,0.6-0.4,1c0.1,0.4,0.4,0.7,0.8,0.8l1.4,0.2c0,0.2,0,0.3,0,0.5l-0.4,1.2\n                c0,0.1-0.1,0.3,0,0.5c0.2,1,0.7,1.8,1.7,2.2c0.4,0.4,0.8,0.8,1.3,1.2l-0.3,0.9c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.1,0.4,0.2,0.6,0.2\n                c0.2,0,0.4-0.1,0.5-0.2l1.8-1.2c0.3-0.2,0.5-0.6,0.4-1c-0.1-0.4-0.3-0.7-0.7-0.8c-0.1,0-0.2-0.1-0.3-0.1l0.1-0.2\n                c0.1-0.3,0.1-0.5-0.1-0.8c-0.1-0.2-0.4-0.4-0.6-0.5c-0.3-0.1-0.7-0.1-1-0.2c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.5-0.5-1.2-0.5-1.8L48,9.4\n                C48,9.1,48,8.8,47.9,8.6c0.2-0.6,0.5-1.2,0.9-1.7C49,6.5,49,6,48.6,5.6z M8.7,138.9c0.4-0.1,0.7-0.4,0.8-0.7c0.1-0.4-0.1-0.8-0.4-1\n                l-3.4-2.5c-0.5-0.8-1.3-1.4-2.4-1.7c-0.5-0.1-0.9,0.1-1.1,0.5c-0.2,0.4-0.1,0.9,0.3,1.2l1.7,1.2c0.3,1-0.3,2.8-0.8,4.4\n                c-0.2,0.5-0.3,0.9-0.5,1.4c-0.1,0.1-0.1,0.2-0.2,0.3H5c0.6-1,1.1-1.9,1.3-2.7L8.7,138.9z M71.6,17.3l-2,5.9c-0.1,0.3,0,0.6,0.1,0.9\n                c0.2,0.3,0.5,0.4,0.8,0.4h1.8c0.2,0.1,0.4,0.1,0.6,0.2c0.3,1,0.6,1.8,0.9,2.7c-0.1,0.1-0.2,0.3-0.4,0.4c-1,1.1-2.2,2.3-1.9,3.8\n                c0.1,0.4,0.3,0.7,0.7,0.8c0.4,0.1,0.7,0,1-0.2l1.2-1.2c0.6,0.6,1.2,1.1,1.8,1.7c1.7,1.5,3.3,2.8,3.2,4.8c0,0.4,0.2,0.8,0.6,1\n                c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.1,0.8-0.4l1.2-1.5l3.5-0.1c0.5,0,0.9-0.4,1-1c0-0.5-0.4-1-0.9-1c-4.6-0.3-7.7-2.4-9.7-6.7\n                c0.5-0.7,0.8-1.5,0.6-2.4c-0.3-1.1-1.3-1.7-2.1-2.1c-0.4-1.7-0.7-3.5-1-5l-0.1-0.8c-0.1-0.4-0.4-0.8-0.9-0.8\n                C72.1,16.6,71.8,16.9,71.6,17.3z M3.7,128.8c0.4,0.1,0.9-0.1,1.1-0.5c0.2-0.4,0.2-0.9-0.2-1.2l-2-2c-0.2-0.2-0.5-0.3-0.8-0.3\n                c-0.3,0-0.6,0.2-0.7,0.4L0,127.2v4.2c0.2-0.2,0.4-0.5,0.6-0.7C1.7,129.5,2.5,128.5,3.7,128.8z M103.6,0.5c0.7-0.2,1.4-0.4,2-0.5\n                h-3.2c0,0,0,0,0,0C102.6,0.5,103.1,0.7,103.6,0.5z M25.3,33.6L24,34.3c-0.1-0.1-0.2-0.3-0.2-0.4l-0.4-1.2c0-0.2-0.1-0.3-0.2-0.4\n                c-0.7-0.8-1.6-1-2.7-0.8c-0.5-0.1-1.1-0.2-1.7-0.2l-0.3-0.9c-0.1-0.4-0.5-0.7-0.9-0.7c-0.4,0-0.8,0.2-1,0.6l-0.8,2\n                c-0.1,0.4-0.1,0.8,0.2,1.1c0.3,0.3,0.7,0.4,1,0.3c0.1,0,0.2-0.1,0.3-0.1l0.1,0.2c0.1,0.3,0.3,0.5,0.5,0.6c0.2,0.1,0.5,0.1,0.8,0\n                c0.3-0.1,0.6-0.3,0.9-0.4c0.3-0.1,0.5-0.3,0.8-0.4c0.6,0.2,1.1,0.6,1.5,1.2l0.4,1.3c0.1,0.3,0.3,0.5,0.5,0.6\n                c0.2,0.6,0.3,1.2,0.3,1.9c0,0.1,0,0.3,0.1,0.4c0,0,0,0-0.1-0.1c-0.3-0.1-0.8-0.1-1,0.2c-2.7,2.5-4.4,3-5.5,3.1c-0.5,0-0.9,0-1.4,0\n                c-0.2,0-0.3,0-0.5-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.6-0.5-1-0.5l-2.8,0.4c-0.1,0-0.3,0-0.4,0.1C10,42,9.6,42.5,9.7,43\n                c0.1,0.5,0.6,0.9,1.1,0.8l0.4-0.1c0.2,0,0.3,0,0.5,0l-0.6,0.8c-0.3,0.4-0.2,1,0.2,1.4c0.4,0.3,1,0.3,1.4-0.1\n                c0.8-0.9,1.7-1.5,2.8-1.6c0.4,0,0.9,0,1.3,0c1.7,0.2,3.6,1.1,5.5,2.2l0,0.8c0,0.3,0.2,0.6,0.4,0.7c0.2,0.2,0.5,0.2,0.8,0.2\n                c0.4-0.1,0.7-0.1,1.1-0.2l0.2,0c0.7,0.4,1.3,0.7,1.9,0.9c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.1,0.8-0.4l2-2.8c0.3-0.4,0.2-1-0.1-1.3\n                c-0.4-0.3-0.9-0.4-1.3,0c-1.2,1-2.3,1.3-3.2,1.5c-0.3-0.2-0.7-0.4-1-0.6l-0.3-5.4c0-0.1-0.1-0.2-0.1-0.4c0.1,0.1,0.2,0.1,0.3,0.1\n                c0.1,0,0.1,0,0.2,0c0.4,0,0.8-0.2,0.9-0.6l1.6-4c0.2-0.4,0.1-0.8-0.2-1.1C26.1,33.5,25.7,33.4,25.3,33.6z M13.1,30.9\n                c-1.7,0.5-2,2-2,3.2c-1.9-0.8-3.4-1-5.7-0.5l-1.7-0.3c-0.3-0.1-0.6,0-0.8,0.2c-0.2,0.2-0.3,0.5-0.3,0.8v0c-0.2,0-0.4,0.1-0.6,0.1\n                c-0.3,0.1-0.5,0.2-0.7,0.5c-0.1,0.2-0.2,0.5-0.1,0.8l1.4,4.4c0.1,0.4,0.5,0.7,0.9,0.7c0,0,0.1,0,0.2,0c0.5-0.1,0.8-0.5,0.8-1v-3.9\n                c0.3-0.1,0.6-0.2,0.9-0.2l6.4,1.1c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0s0,0,0,0c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0h0h0l0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c2-0.6,2-2.6,2.1-3.9c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.7-0.4-0.9\n                C13.8,30.8,13.4,30.8,13.1,30.9z M66.9,126.4c0.3-0.1,0.6-0.4,0.7-0.7c0.4-2.1-1.1-3.8-2.4-5.1c-0.2-0.2-0.3-0.4-0.5-0.6\n                c-0.1-0.8-0.4-1.7-0.7-2.6c0.2-0.3,0.6-0.6,1.2-0.9c0.1-0.1,0.2-0.2,0.3-0.4c0.1,0,0.2,0.1,0.3,0.1c0.6,0,1.6-0.8,3-2.5\n                c0.6-0.7,1.1-1.6,1.6-2.4l5.7-1.4l-5.2-0.8c-0.1-0.7-0.6-1.9-2.8-1.9c-0.5,0-1,0.4-1,1c0,0,0,0,0,0.1c-0.3,0-0.5,0.1-0.8,0.1\n                l0.9,0.1c0.1,0.4,0.5,0.6,0.9,0.6c0.7,0,0.8,0.2,0.8,0.2c0,0,0,0,0,0.1c0,1.3-2.6,4.4-3.4,4.9c-0.2,0.1-0.4,0.3-0.5,0.5\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.9,0-1.7-0.3-2.6-1.1c-0.1-0.2-0.2-0.3-0.4-0.6l-1.9-1.9c-0.3-0.4-0.7-0.8-1.1-1.2l1.1-1.5\n                c0.3-0.4,0.2-1-0.1-1.3c-0.4-0.3-1-0.3-1.3,0l-2,2c0,0-0.1,0.1-0.1,0.2l-3,4.5c0.1-0.2,0.2-0.6,0.2-1.4c0.6-1,0.9-2.3,1.1-3.5\n                l1.9-4.1c0.6-0.2,1.4-0.1,2.5,0.2c0.5,0.1,1-0.1,1.2-0.5c0.2-0.4,0.1-1-0.3-1.3c-0.9-0.6-0.9-1.3-0.9-2.6c0-0.4,0-0.7,0-1\n                c0-0.1,0-0.3-0.1-0.4c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.3-0.3-0.6-0.4h0c0,0,0,0,0,0c0,0,0,0,0,0l-2-0.3v-4.7\n                c0-0.4-0.2-0.8-0.6-0.9c-0.5-1.3-1.4-2.3-2.7-3.2c-0.4-0.2-0.8-0.2-1.2,0l-2.8,2.3c-0.3,0.2-0.4,0.6-0.3,1c0.1,0.4,0.4,0.7,0.8,0.7\n                l4.7,0.8c0.2,0.9,0.2,1.9,0.2,2.9c0,0.6,0,1.2,0,1.8c0,0.1,0,0.3,0.1,0.4c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0,0h0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0\n                c0,0,0,0,0,0h0c0,0,0,0,0,0c0,0,0,0,0,0h0c0,0,0,0,0,0s0,0,0,0s0,0,0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0l1.5,0.3l-1.4,2.9c-1.3,0.9-1.8,2.5-2.1,4.1c0,0-0.1,0-0.1,0c-0.3-0.1-0.6-0.1-0.9-0.2c-0.6-0.8-1.4-1.4-2.3-1.7\n                c-0.4-0.1-0.8,0-1,0.3c-0.3,0.3-0.3,0.7-0.1,1.1c0.4,0.9,1.2,1.6,2.2,2c0.5,1,0.7,2.3,0.8,2.9c-0.2,0.2-0.2,0.5-0.2,0.7\n                c0.1,0.7,0.1,1.8,1.2,1.8c0.3,0,0.5-0.1,0.7-0.3c0,0,0,0,0.1-0.1L52,115c-0.3,0.4-0.2,1,0.2,1.4c0.4,0.3,1,0.2,1.4-0.2l3.5-4.7\n                l1.2,1.3c0.6,0.7,1.3,1.5,2,2.1c0.5,0.8,1,1.7,1.4,2.4c-0.5,1.5,0.4,2.8,1,3.5c0,0.9-0.2,1.5-0.7,1.9c-0.2,0.2-0.3,0.5-0.3,0.8\n                c0,0.3,0.1,0.6,0.4,0.8c0.2,0.2,0.4,0.4,0.7,0.6c0.8,0.8,1.7,1.7,3.1,1.7C66.1,126.6,66.5,126.5,66.9,126.4z M51.1,134.2\n                c2.7-1.7,3.8-4,4.5-5.8c0.4-0.8,0.7-1.6,0.8-2.3l0-0.2l0.1-0.3c0.7-2.6,1.4-5,3.5-6.7c0.3-0.3,0.4-0.7,0.3-1\n                c-0.1-0.4-0.4-0.7-0.8-0.7c-1.6-0.2-2.8,0.2-3.7,1.1c-1.5,1.6-1.4,4.4-1.4,6.7l0,0.8c-0.2,0.7-0.4,1.3-0.6,1.9\n                c-0.9,1.7-2.6,3.7-3.9,5.1c-0.3,0.1-0.5,0.3-0.8,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.6,0.7-1,1.2-0.7,1.9c0.2,0.4,0.6,0.6,0.9,0.6\n                C49.3,135.8,49.6,135.8,51.1,134.2z M26.2,141.4c-0.4-0.2-0.8-0.1-1.1,0.2c-0.1,0.1-0.2,0.2-0.2,0.4h2.8\n                C27.2,141.9,26.7,141.7,26.2,141.4z M15.9,140.8c-0.3-0.5-0.8-0.6-1.3-0.4c-0.2,0.1-0.5,0.3-0.7,0.4c-0.5,0.4-1,0.7-1.4,1.1h3.2\n                C16.1,141.7,16.1,141.2,15.9,140.8z M98.9,1.1c0.2,0,0.4-0.1,0.7-0.2c0.2-0.1,0.3-0.2,0.4-0.4c0-0.1,0.1-0.1,0.1-0.2\n                c0.1-0.1,0.2-0.2,0.4-0.3h-2.6c0,0.1,0,0.3,0.1,0.4C98.1,0.8,98.5,1.1,98.9,1.1z M118.6,91.8c-0.2,0.2-0.3,0.5-0.3,0.8v0\n                c-0.2,0-0.4,0.1-0.6,0.1c-0.3,0.1-0.5,0.2-0.7,0.5c-0.1,0.2-0.2,0.5-0.1,0.8l1.4,4.4c0.1,0.4,0.5,0.7,0.9,0.7c0,0,0.1,0,0.2,0\n                c0.5-0.1,0.8-0.5,0.8-1v-3.9c0.3-0.1,0.6-0.2,0.9-0.2l6.4,1.1c0,0,0,0,0.1,0c0,0,0,0,0,0h0h0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0h0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0\n                c0.1,0,0.1,0,0.2,0c2-0.6,2-2.6,2.1-3.8c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.7-0.4-0.9c-0.3-0.2-0.6-0.3-0.9-0.2c-1.7,0.5-2,2-2,3.2\n                c-1.9-0.8-3.4-1-5.7-0.5l-1.7-0.3C119.1,91.5,118.8,91.6,118.6,91.8z M132.6,82.7l0-0.5c0.1-0.2,0.1-0.3,0.1-0.5c0-0.3,0-0.6,0-1\n                c0-0.4,0-0.8-0.1-1.2c0.2-2.7,1.1-3.9,3.1-4c0.5,0,0.9-0.4,0.9-0.9c0.1-0.5-0.2-0.9-0.7-1.1c-1.8-0.5-3.1-0.2-4.1,0.7\n                c-1.2,1.2-1.3,3.3-1.2,5.1c0,0.4,0,0.8,0,1.3l-1.7,0.1c-0.5,0-0.8,0.3-0.9,0.8c-0.1,0.4,0.1,0.9,0.6,1.1c0.7,0.3,0.8,0.9,0.9,2.3\n                c0,0,0,0,0,0c-0.2,0-0.5,0-0.7,0c-1.1,0-2.2,0-3.2,0.3l0,0c-0.4-0.3-1-0.2-1.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c-1.2,0.6-2,1.5-2.7,2.8\n                c-0.2,0.4-0.1,0.9,0.2,1.2l1.4,1.4c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l2.5-2.7c2.3,1.1,3.8,1,4.7,0\n                C132.8,87.2,132.7,85.1,132.6,82.7z M90.7,25.2c1.8-2.1,3.7-4.3,6.3-5.4l2-0.6c0.5-0.2,0.8-0.7,0.7-1.2c-0.1-0.5-0.6-0.8-1.1-0.7\n                c-0.7,0.1-1.5,0.4-2.2,0.7l-8.6,2.6c-0.4,0.1-0.7,0.5-0.7,1c0,0.5,0.3,0.8,0.8,0.9l1.3,0.3c-0.4,0.8-0.7,1.6-0.9,2.5\n                c-1.3,1.5-2.5,2.6-3.8,3.1l-0.7-1.8c-0.1-0.3-0.4-0.5-0.7-0.6L81,25.5c-0.5-0.1-1,0.2-1.2,0.8l-0.5,2.7c-0.1,0.3,0,0.5,0.1,0.7\n                c0.1,0.2,0.4,0.4,0.6,0.4l2.1,0.4l0.4,0c0.6,0,1.2-0.1,1.7-0.2c0.6,0.2,1.1,0.3,1.5,0.3c2.7,0,3.5-2.6,4.2-4.5\n                C90.2,25.8,90.5,25.5,90.7,25.2z M107.1,0H106c0.2,0.1,0.3,0.1,0.5,0.1L107.1,0z M136.3,1.3l0.7,1.6c0.3,0.8,0.4,1.7,0.6,2.6\n                c0,0.1,0.1,0.3,0.1,0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.4-0.4c-0.3-0.8-0.8-1.4-1.4-1.7c-0.1-0.3-0.1-0.6,0-0.9\n                c0.2-0.5-0.1-1-0.6-1.2c-0.5-0.2-1,0-1.3,0.5l-2,4c-0.2,0.4-0.1,1,0.3,1.2c0.4,0.3,0.9,0.2,1.3-0.1l1.3-1.3c0.2,0.2,0.4,0.4,0.5,0.6\n                l0.1,0.1c0.2,0.5,0.3,1.1,0.4,1.8c0,0.5,0.5,0.9,1,0.9c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.2,0-0.6,0-1.5\n                c0.5,2.2,1.2,4.5,3.5,5.5l0.5,1.2c0,0,0.1,0.1,0.1,0.1V7.7c-0.1,0-0.3,0.1-0.4,0.2c0,0,0,0,0,0l-2.7-5.8c-0.1-0.3-0.2-0.5-0.3-0.7\n                l2.8,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.4-0.1V0h-7.8l2,0.7C136.2,0.9,136.2,1.1,136.3,1.3z M119.9,81.2l2.8,0.5\n                c0.1,0,0.1,0,0.2,0c0.4,0,0.8-0.2,0.9-0.6c0.2-0.4,0-0.9-0.4-1.2c-0.9-0.6-0.9-1.3-0.9-2.6c0-0.1,0-0.2,0-0.3\n                c0.4-0.2,0.9-0.4,1.4-0.6c0.2,0,0.4,0.1,0.7,0.1c0.4,0.1,0.7,0.1,1.1,0.1c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7v-0.3\n                c0.4-0.2,0.8-0.4,1.2-0.5c0.4,0.1,0.7,0.1,1.1,0.1c2.6,0,3.2-2.3,3.6-3.7c0.2-0.2,0.3-0.5,0.4-0.7v1.2c0,0.4,0.3,0.8,0.7,0.9\n                c0.4,0.1,0.8,0,1.1-0.3c0.5-0.6,0.9-0.7,1.1-0.7c0.6,0,1.4,0.5,2.2,1c1.1,0.7,2.3,1.5,3.8,1.5c0.1,0,0.1,0,0.2,0v-2.3l-7.6-3.8\n                c-0.2-0.1-0.5-0.1-0.7,0c0-0.3,0.1-0.5,0.1-0.8c0-0.4-0.3-0.8-0.7-1c-0.4-0.1-0.9,0.1-1.1,0.5c-0.6,1-0.9,2.2-1.1,3.3l-0.1,0.4\n                c-0.7,0.8-1.6,1.6-3,2.3c-0.5-0.2-1-0.4-1.6-0.7c-0.3-0.2-0.7-0.1-1,0c-0.3,0.2-0.5,0.5-0.5,0.8V74c-0.3,0.1-0.6,0.2-0.9,0.3\n                l-0.3,0.1c-1.3-0.1-2.2,0.3-2.8,1.2c-1,0.5-2,1.2-2.3,2.4c-0.2,0.9,0.1,1.8,0.8,2.8C119.4,81,119.6,81.1,119.9,81.2z M87.7,37.3\n                c-0.2-0.1-0.4-0.2-0.6-0.2l-2-0.1c-0.6,0-1,0.4-1,0.9L84,40c0,0.5,0.4,1,0.9,1l2,0.1c0,0,0,0,0,0c0.3,0,0.6-0.1,0.7-0.3l1.1-1.2\n                c0.2-0.2,0.3-0.5,0.2-0.7c0-0.3-0.2-0.5-0.4-0.7L87.7,37.3z M116.1,2.7c0.2,0.4,0.6,0.6,1.1,0.6c0.4,0,0.9-0.2,1.6-0.5\n                c0.2-0.1,0.3-0.2,0.4-0.4l1.5-2.5h-3.5C116.1,1.4,115.8,2.1,116.1,2.7z M106.1,26.3l1.4,1.6c0,0,0.1,0.1,0.1,0.1\n                c-0.2-0.3-0.2-0.6-0.1-0.9c0.2-0.4,0.5-0.6,0.9-0.6h3.9c0.4,0,0.8,0.3,0.9,0.7c0.4,1.4,0.4,2.6,0,3.9c0.2,0.4,0.1,0.8-0.2,1.1\n                l-3.2,3.3l1.3,1.3c0,0,0,0,0.1,0.1c0.1,0.2,0.2,0.4,0.2,0.6v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0\n                c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0.2-0.1,0.5-0.2,0.6c-0.2,0.3-0.5,0.5-0.7,0.8\n                c-1,1-1.3,1.5-1.1,2.2c0.2,0.5-0.1,1-0.5,1.2c-0.4,0.2-1,0.1-1.2-0.3c-0.7-0.9-1.3-1.4-2-1.6l-4.6,1.8c-1.1,0.8-2.3,1.5-3.5,1.9\n                c-0.9,1-1.2,1-1.5,1c-0.4,0-0.8-0.2-0.9-0.6c-0.3-0.7,0.2-1.2,0.7-1.8c0.2-0.2,0.4-0.3,0.6-0.3c0,0,0,0,0.1,0\n                c0.4-0.5,1.1-1.5,1.4-2.5c-0.5-0.9-0.6-1.8-0.3-2.8c0-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.8,0.4-1.6,0.5-2.2,0.5\n                c-1.1,0-1.7-0.5-2-0.9c-0.3-0.3-0.3-0.8-0.1-1.1c0.2-0.4,0.6-0.5,1-0.4c0.6,0.1,1.1,0.2,1.6,0.2c0.4,0,0.7,0,1-0.1\n                c0.3-0.1,0.7-0.3,1-0.5c0.7-0.6,1.2-1.8,1.7-3c0.2-0.5,0.4-1,0.6-1.5c0-0.2,0.1-0.4,0.3-0.6c0.7-1.4,2-3.1,4.7-3.7\n                C105.5,25.9,105.9,26,106.1,26.3z M102.3,30.6l-0.2,0.2v0.7c0.4,0,0.8,0.3,1,0.7c0.3,1.3-3.4,3.6-4.1,4c-0.1,0.1-0.2,0.2-0.4,0.2\n                c0.3,0,0.6,0.1,0.8,0.4c0.5,0.7,0.8,1.6,0.7,2.6c0.2,0.2,0.3,0.4,0.5,0.6c0,0,0.1,0.1,0.1,0.1c1.5-1,3-1.9,4.7-1.7l3.2-1.3l-0.9-0.9\n                c-0.1-0.1-0.1-0.1-0.1-0.2v0c0,0,0,0,0,0c-0.1-0.2-0.1-0.3-0.1-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0\n                c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0,0c0.4-0.5,0.8-0.9,1.3-1.3c0.7-0.7,1.4-1.4,1.9-2.1\n                l-3.1-3.2c0,0,0,0,0,0c0.1,0.3,0.1,0.7-0.1,0.9c-0.3,0.4-0.8,0.5-1.2,0.3C104.8,28.6,103.6,29.5,102.3,30.6z M68.1,134h3.9\n                c0.4,0,0.8-0.3,0.9-0.7c0.1-0.4,0-0.8-0.3-1.1c-1.9-1.6-1.9-3-1.6-4.3c0.9-1.8,1.8-3.6,2-5.6c0.4-1.9-0.1-3.5-1.4-5l8.7-5.3\n                c0.5-0.3,0.6-0.9,0.4-1.3c-0.3-0.5-0.8-0.6-1.3-0.4l-11.8,5.9c-0.4,0.2-0.6,0.7-0.5,1.1c0.1,0.4,0.5,0.8,1,0.8h1.5\n                c1.1,1.2,1.6,2.5,1.5,3.9c-0.2,0.8-0.6,1.7-1,2.6c-0.4,0.8-0.7,1.7-1,2.5c-0.9,1.8-1.8,3.7-2.1,5.7c0,0.3,0.1,0.6,0.2,0.8\n                C67.6,133.8,67.8,134,68.1,134z M7.6,39.4l-1,0.1c-0.4,0-0.7,0.3-0.8,0.6c-1.9,0.8-3.4,1.5-4.6,2.1c-0.4,0.2-0.8,0.4-1.1,0.6v2\n                c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.5-0.2c0.3-0.2,0.7-0.4,1.2-0.7c0.9-0.3,2.1-0.4,3.3-0.6c0.5-0.1,1.1-0.1,1.6-0.2\n                c0.5-0.1,0.8-0.5,0.8-1l0-0.8l0.4-0.2l7.2-0.7c0.5-0.1,0.9-0.5,0.9-1l0-0.9l3.4-0.3c0.5,0,0.8-0.4,0.9-0.9c0-0.5-0.2-0.9-0.7-1\n                l-0.7-0.2c-0.1-0.4-0.5-0.7-1-0.7c-0.2,0-0.3,0-1,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.4,0.2-1,0.4-1.6,0.6\n                C13.1,37.4,10.3,38.4,7.6,39.4z M62.6,142c0.5-0.8,0.9-1.5,1.1-2.2c0.2,0.2,0.5,0.4,0.8,0.3c0.4,0,0.8-0.1,1.2-0.1\n                c0.6-0.1,1.2-0.2,1.5-0.1c0,0.4,0.3,0.8,0.7,0.9c0.1,0,0.2,0,0.3,0c0.4,0,0.7-0.2,0.9-0.6c0.8-1.7,3.4-2.6,5.9-3.6\n                c2.9-1.1,5.8-2.1,7-4.6c0.2-0.5,0.1-1-0.4-1.3c-0.4-0.3-1-0.2-1.3,0.2c-2.1,2.5-6.3,3.8-10.3,5.1c-2,0.6-4.2,1.3-6,2.1\n                c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.3-0.1-0.4c0.4-1.2,0.8-2.4,1.1-3.6c0.1-0.5-0.1-0.9-0.5-1.1c-0.4-0.2-0.9-0.1-1.2,0.3\n                c-0.3,0.3-0.5,0.7-0.8,1c-0.9,1.2-1.7,2.3-3.4,3.1c-0.1,0.1-0.3,0.2-0.3,0.3l0.7-2c0.1-0.3,0.1-0.7-0.2-1c-0.2-0.3-0.6-0.4-0.9-0.4\n                l-6.3,1c-0.4,0.1-0.7,0.4-0.8,0.8c-0.1,0.4,0.1,0.8,0.5,1l4.9,2.9c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.2,0,0.3-0.1\n                c0.3-0.1,0.5-0.3,0.6-0.6l0.5-1.3c0,0.1,0,0.2,0.1,0.3c0.2,0.5,0.7,0.8,1.2,0.6c0.7-0.2,1.3-0.3,1.7-0.4c-0.4,1-0.8,1.9-1.2,2.9\n                H62.6z M1.2,142c-0.1-0.2-0.3-0.4-0.5-0.5L0,141.1v0.9H1.2z M52.3,141.6c0-0.4-0.3-0.7-0.6-0.9c-0.3-0.1-0.8-0.1-1,0.2\n                c-0.4,0.4-0.9,0.7-1.2,1.1h2.9L52.3,141.6z M15.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3c0.1,0,0.1-0.1,0.2-0.2h-3.2c-1.3,1.2-2,2.4-2.3,3.8\n                c-0.6,1-1.2,2-1.8,2.8c-0.2,0.3-0.3,0.7-0.1,1C8.5,8,8.8,8.2,9.2,8.2h1.2c0.4,1.1,1.2,2.1,2,3l0.8,1.3c0.3,0.5,0.6,1,0.9,1.5\n                c0.1,0.3,0,0.6-0.2,1c-0.8-0.4-1.7-0.7-2.6-0.9c-0.4-0.1-0.9,0.1-1.1,0.5c-0.2,0.4-0.1,0.9,0.2,1.2l2,2c0.3,0.3,0.8,0.4,1.2,0.1\n                c0.2-0.1,0.4-0.2,0.5-0.4c1.9,1.5,3,3.8,3.8,5.9c-0.2,0.6-0.1,1.2,0.1,1.9c0,0.1,0.1,0.3,0.2,0.4c0.2,0.2,0.5,0.5,0.8,0.8l0,0.1\n                c0.3,1,0.6,1.9,1,2.8c0,0.1,0.1,0.1,0.1,0.2c1.6,2.4,7.7,3,9.1,3c0.6,0,1.7,0,1.8-1c0-0.4-0.1-0.7-0.4-0.9c0.3-0.3,0.6-0.6,0.9-1\n                c0.3-0.4,0.3-1-0.1-1.4c-0.4-0.4-1-0.3-1.4,0L29,29.4c-0.6,0.4-1.2,0.6-1.8,0.6c-2.1,0-4.5-2.5-6.4-4.5l0,0\n                c-0.2-0.6-0.4-1.3-0.7-1.9c0.2-0.3,0.5-0.7,0.9-1c0.3-0.3,0.5-0.5,0.7-0.8c0.3-0.4,0.3-1-0.1-1.3l-1.2-1.2c0.5-0.5,1-1,1.5-1.6\n                l1.7-1.7c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1-0.2c0.2-0.5,0.2-1,0.1-1.5c-0.2-1.7-1.5-2.8-2.6-3.7c-0.5-0.4-1-0.8-1.3-1.3\n                l0-0.1c0-0.2,0-0.4,0-0.6c0-1.1,0-1.9-0.2-2.6c-0.1-0.7-0.1-1.5,0.1-2c0.3-0.3,0.6-0.5,0.9-0.8c0.2-0.2,0.4-0.4,0.7-0.6\n                c0.4-0.3,0.5-0.8,0.2-1.3c-0.2-0.4-0.8-0.6-1.2-0.4c-1,0.4-1.7,1-2.2,1.9c-0.4,0.2-0.7,0.2-1.1,0.1c-0.5-0.2-1,0.1-1.2,0.5\n                c-0.2,0.5,0,1,0.4,1.3c0.7,0.4,1.2,1,1.4,1.8L18,6.5c0.1,0.6,0.1,1.1,0.1,1.6l0,0.5c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.3,0,0.4l0,0.1\n                c-0.1,1.3-0.2,2.6,0,3.8c0.1,0.4,0.3,0.7,0.7,0.8c0.4,0.1,0.7,0,1-0.2l1.2-1.3c0.5,0.5,1,1.1,1.1,1.6c0,0.1,0,0.2,0,0.4\n                c-0.6,0.5-1.1,1.1-1.6,1.6L18.8,18c-0.3,0.2-0.6,0.3-0.8,0.3c-0.3-1.8-1.1-3.5-2-5c-0.3-1-1-2-1.8-3c-1.1-1.8-2.2-3.9-2-5.8\n                C13.1,2.9,14.2,1.2,15.1,0.5z M5,0H2.7c-1,1.7-1.8,3.2-1.2,4.3c0.2,0.4,0.7,0.9,1.9,0.9C4,5.2,4.9,5,6.1,4.7\n                c0.5-0.1,0.7-0.6,0.6-1.1C6.6,3.1,6.1,2.7,5.6,2.7c-0.6,0-1-0.1-1.1-0.3c-0.1-0.2-0.2-0.7,0.2-2C4.8,0.3,4.9,0.2,5,0z M80.6,136.8\n                c0,0.2,0,0.3,0.2,0.4l2,1.2c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.2-0.2l0.6-1.6c0-0.1,0-0.3-0.1-0.4\n                c-0.1-0.1-0.2-0.2-0.4-0.1l-2.5,0.4C80.7,136.6,80.6,136.7,80.6,136.8z M90.3,140.6c-0.2,0.5-0.5,0.9-0.8,1.4h2.4l0.2-0.7\n                c0.2-0.5,0.4-1,0.5-1.4c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.3-0.1,0.5-0.2,0.6-0.5c0.9-1.5,1.2-3,0.9-4.6l0-0.2\n                c0.1-0.3,0.1-0.6,0.2-0.9c0-0.2,0.1-0.4,0-0.5c-0.2-0.8-0.7-1.4-1.4-1.9c-0.4-1.1-0.7-2.2-0.4-3.4l0.1-0.2c0.1-0.5-0.1-1.1-0.7-1.2\n                c-0.5-0.1-1.1,0.1-1.2,0.7l0,0v0l-0.1,0.3c0,0,0,0,0,0c-0.1,0.2-0.1,0.5-0.2,0.7c-0.3,1.3-0.5,1.9-1.2,2.1c-0.4,0.1-0.7,0.5-0.7,0.9\n                c0,0.4,0.3,0.8,0.7,1c0.3,0.1,0.7,0.2,1,0.2c0.4,0.1,0.8,0.2,1.1,0.3l0,0.1c0.3,0.7,0.5,1.3,0.6,2c-0.2,0.9-0.4,1.3-0.9,1.5\n                c-3.3-1.1-4.8-2.5-4.9-4.7c0.3-0.8,0.4-1.7,0.5-2.6c0.1-0.7,0.1-1.3,0.3-1.8c0.8-0.4,1.5-1,2.1-1.5c1.4-1.2,2.7-2.2,4.1-1.2\n                c0.4,0.3,0.9,0.2,1.3-0.1c0.3-0.3,0.4-0.9,0.1-1.3l-1.1-1.6c-0.3-0.4-0.8-0.6-1.2-0.3l-12.5,6.1c-0.5,0.2-0.7,0.8-0.5,1.2\n                c0.2,0.5,0.7,0.7,1.2,0.6l4.2-1.2c-0.3,1.3-0.5,2.4-0.5,3.4c-0.2,0.4-0.5,0.7-1,0.9c-0.4,0.1-0.6,0.4-0.7,0.8\n                c-0.1,0.4,0.1,0.7,0.4,1l7.5,5.1c0,0.1-0.1,0.1-0.1,0.2L90.3,140.6z M24.9,0.7l0.3,0.9c-0.1,0.1-0.3,0.1-0.4,0.2l-0.2,0.1\n                c-1.6-0.1-2.3,0.6-2.6,1.3c-0.7,0.4-1.4,1.1-1.5,2.1c-0.1,1.3,0.9,2.4,1.7,3.1c0.1,0.1,0.3,0.2,0.5,0.2l3,0.5c0.1,0,0.1,0,0.2,0\n                c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5,0-1-0.5-1.2c-1.3-0.7-1.7-1.7-2.1-2.9c0-0.1,0-0.1-0.1-0.2c0.3-0.1,0.5-0.3,0.8-0.4\n                c0.2,0,0.5,0.1,0.7,0.1C26,4,26.4,4.1,26.7,4.1c0.3,0,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.6,0.1-0.9l-0.1-0.2c0.2-0.1,0.5-0.2,0.7-0.4\n                c1.4,0.3,2.4,0.1,3-0.7C31.8,1.1,32,0.6,32,0h-3.8c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.3-0.1-0.4-0.1h-2.8C24.8,0.2,24.8,0.5,24.9,0.7z\n                 M73.9,130.4l0.8,0.1l0.6,0.8c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4,0,0.5-0.1l1.5-0.9c0.4-0.2,0.5-0.7,0.4-1.1\n                c-0.1-0.4-0.5-0.7-0.9-0.8l-2-0.2l-1.5-1.9c-0.3-0.4-0.8-0.5-1.2-0.3c-0.4,0.2-0.6,0.7-0.5,1.1l0.6,2.2\n                C73.2,130.1,73.5,130.4,73.9,130.4z M67.8,141.5l-0.9,0.5h2.2c0,0,0-0.1,0-0.1C68.8,141.5,68.2,141.3,67.8,141.5z M81,141\n                c-1.3-2.2-2.7-3.6-4.3-4.2c-0.4-0.2-0.9,0-1.2,0.4c-0.2,0.4-0.2,0.9,0.1,1.2l3.6,3.6H82L81,141z M116.8,114.3\n                C116.8,114.3,116.8,114.3,116.8,114.3l1.3,0c0.2,0.3,0.5,0.5,1,0.7c0.1,0,0.2,0.1,0.2,0.1c0.4,0.1,0.9,0.2,1.5,0.2\n                c2.3,0,2.6-0.7,2.6-1.2c0-0.7-0.5-1.1-1.5-1.1c-0.4,0-0.8,0-1.4,0.1l0-1.3c0.3-0.3,0.7-0.7,1-1.1c0.3-0.3,0.6-0.6,0.9-0.9l0.3-0.3\n                c1-1,2-2,3.2-2.6c0.6-0.1,1.1-0.3,1.6-0.5c0.8-0.1,1.8-0.1,2.7,0.3c0.5,0.2,1-0.1,1.2-0.6c0.2-0.5,0-1.1-0.5-1.3\n                c-0.5-0.2-0.7-0.5-0.9-0.7c0.7-1,1.1-2.2,1.3-3.5c0.6-0.7,0.9-1,0.7-1.6c-0.2-0.4-0.5-0.6-0.9-0.6c-0.4,0-0.7,0.2-1.4,1c0,0,0,0,0,0\n                c-0.1,0.1-0.1,0.1-0.2,0.2c-0.8,1-1.6,2.5-1.6,3.9c-0.3,0.4-0.7,0.7-1.2,0.9c-0.5,0.1-1.1,0.3-1.6,0.5c-0.9,0.1-1.8,0.1-2.8-0.2\n                c-0.3-0.1-0.6,0-0.9,0.2c-0.2,0.2-0.4,0.5-0.4,0.8l0,2.4l-1.1,1.2c-1.2,1.2-2,1.5-3.1,1.1c-0.3-0.1-0.6,0-0.9,0.1\n                c-0.3,0.2-0.4,0.5-0.4,0.8l0,2C115.8,113.9,116.2,114.3,116.8,114.3z M116.2,101.7h1.5c0.1,0.1,0.3,0.3,0.4,0.4c1,1,1.3,1.5,1.1,2.2\n                c-0.1,0.4,0,0.9,0.4,1.2c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.3l2-2c0,0,0,0,0,0l3.9-4c0.4-0.4,0.4-1,0-1.4l-1.4-1.4\n                c-0.4-0.4-1-0.4-1.4,0l-3.4,3.4c-0.9-0.3-1.8-0.4-2.7-0.4l-1.7,0c-0.2,0-0.4,0.1-0.5,0.2c-0.2-0.2-0.6-0.3-0.9-0.3\n                c-1.2,0.2-2.2,0.2-2.5,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.5,0.3-1.7,0.5-2.5c0.2-0.5,0.3-1,0.4-1.4c0,0,0,0.1,0,0.1\n                c0.2,0.3,0.5,0.5,0.8,0.5c0,0,0,0,0,0c0.5,0,0.8-0.3,1.3-1c0.1-0.2,0.2-0.4,0.2-0.7c0,0,0-0.1,0-0.3c0.2-0.4,0.4-0.8,0.6-1.2\n                c0.3-0.5,0.6-1,0.9-1.5c1.1-1.8,2.2-3.6,1.6-4.8c0.4-1.2,0.8-2.4,1.1-3.6c0.1-0.5-0.1-0.9-0.5-1.1c-0.4-0.2-0.9-0.1-1.2,0.3\n                c-0.3,0.3-0.5,0.7-0.8,1c-0.9,1.2-1.7,2.3-3.4,3.1c-0.5,0.2-0.7,0.8-0.5,1.3c0.2,0.5,0.7,0.8,1.2,0.6c0.7-0.2,1.3-0.3,1.7-0.4\n                c-0.5,1.4-1.1,2.9-1.7,4.3c-0.3,0.6-0.5,1-0.6,1.4l-0.2,0.4c-0.1,0.1-0.1,0.2-0.1,0.3c0.1-2.3-1.3-3.2-2.6-3.5\n                c-0.3-0.1-0.5,0-0.7,0.1l-2.6,1.6c-0.4,0.3-0.6,0.8-0.4,1.3s0.7,0.7,1.2,0.5c0.7-0.2,1.2-0.4,1.7-0.4c0.6,0,0.8,0.2,1.2,1.1l-1,1.3\n                c-0.5-0.2-1.2,0.1-1.4,0.6c-0.4,1,0.9,3,1.7,3.9c0.3,0.4,0.6,0.7,1.1,0.9c0.6,0.4,1.3,0.6,2,0.6c0.7,0,1.5-0.2,2.2-0.7\n                C115.6,101.6,115.9,101.7,116.2,101.7z M88.9,0.8c-1.4,2.1-3,4.5-1.7,7l-0.4,1.1c-0.1,0.3,0,0.6,0.1,0.9c0.2,0.3,0.5,0.4,0.8,0.4\n                h1.6l1.4,1.4c-0.1,0.5-0.5,1.2-0.8,1.9c-0.6,1.1-1.3,2.4-1.1,3.7c0.1,0.5,0.5,0.8,1,0.8h2c0.3,0,0.6-0.2,0.8-0.4\n                c0.2-0.3,0.2-0.6,0.1-0.9c-0.3-0.8,0.1-1.2,1.1-2.2c0.3-0.3,0.5-0.5,0.7-0.8c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0.5,0.4,1,0.9,1.1\n                l6.6,0.7c0.4,0,0.7-0.1,0.9-0.4l0,0c-2.3,3-3.1,6.5-3.7,9.3l0,0.2c-0.7,1.2-1.6,2.4-2.4,3.7l-0.6,0.8c0-0.1,0-0.1,0-0.2\n                c0.3-1.5-0.4-3-2.3-4.5c-0.4-0.3-0.9-0.3-1.2,0c-0.4,0.3-0.5,0.8-0.3,1.2l1.6,3.3c-0.5,0.4-0.9,0.9-1.3,1.4c-1,1.2-1.9,2.2-3.1,1.9\n                c-0.3-0.1-0.6,0-0.9,0.2c-0.2,0.2-0.4,0.5-0.4,0.8l0,0.8c0,2-0.1,4.7,2.5,6C91,40,91.2,40,91.3,40c0.3,0,0.5-0.1,0.7-0.3\n                c0.3-0.3,0.3-0.8,0.1-1.2c-1.7-2.5-0.5-3.9,1.6-6.1c0.8-0.8,1.5-1.6,2-2.4l0,0c0.1,0,0.1-0.1,0.1-0.2c0,0.2,0,0.3,0.1,0.5\n                c0.2,0.3,0.5,0.5,0.8,0.5c0,0,0.1,0,0.1,0c2.6,0,3.3-2.7,4-5.4c1.9-3,3.7-6.3,3.9-9.6c0.2-0.3,0.5-0.6,0.8-0.9\n                c0.3-0.3,0.4-0.7,0.2-1.1c-0.1-0.4-0.5-0.6-0.9-0.6l-0.3,0c-0.1-0.6-0.3-1.3-0.5-1.9c-0.1-0.4-0.5-0.6-0.9-0.6\n                c-0.3,0-0.8,0.2-0.9,0.6l-0.8,1.8l-6.1-0.3c-0.4,0-0.7,0.2-0.9,0.5c0-0.3-0.1-0.6-0.3-0.8l-1.7-1.8C92.4,10.1,92,9.5,91.3,9l1.1-1.1\n                c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L91,5.2c-0.2-0.2-0.5-0.3-0.8-0.3L91.9,0h-2.4C89.3,0.3,89.1,0.5,88.9,0.8z\n                 M93.1,107.3c0.6,0.3,1.3,0.8,2.1,1.4c0.1,0.1,0.2,0.2,0.3,0.3s0.2,0.2,0.3,0.2c1,1,1.8,2,2,2.3c0.2,0.4,0.5,0.7,1,0.7\n                c0.4,0,0.7-0.2,0.9-0.5c0.3-0.5,0-0.9-0.2-1.2l1.4-1.4c0.4-0.4,0.4-1,0-1.4l-2-2c-0.4-0.4-1-0.4-1.4,0l-1.3,1.3\n                c-1.8-1.7-3.8-2.3-5.8-2.9c-0.6-0.2-1.2-0.4-1.7-0.6c-0.5-0.2-1,0.1-1.2,0.5c-0.2,0.5,0,1,0.5,1.3l1.2,0.6c-0.5,0.4-0.9,0.8-1.3,1.4\n                c-0.3,0-0.5,0-0.7,0c-0.5,0-1.1,0.5-1.1,1c0,0.9,0.7,1.2,2.7,1.2C91.1,109.4,92.7,108.6,93.1,107.3z M124.8,125.1\n                c0.2,0.3,0.5,0.5,0.9,0.5c0.1,0,0.3,0,0.4-0.1l1.8-0.9c0.5-0.2,0.7-0.8,0.4-1.3l-0.9-1.8c0-0.1-0.1-0.2-0.2-0.3l-4.4-4.4\n                c-0.3-0.3-0.9-0.4-1.3-0.1c-0.4,0.3-0.5,0.8-0.3,1.2L124.8,125.1z M136,124.7c1,0.2,2,0.3,3,0.3c1.1,0,2-0.1,3-0.3V122l-0.7-0.4\n                c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.4-0.6-0.7-1.1-0.7c-0.9,0-3.8,1.4-4.7,2.6c-0.4,0.6-0.4,1.1-0.3,1.4\n                C135.3,124.4,135.6,124.6,136,124.7z M129.7,0.7c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1c0.3-0.2,0.6-0.4,0.7-0.7h-2.2\n                C129.3,0.3,129.4,0.6,129.7,0.7z M129.6,121.8c0.1,0,0.2,0,0.3,0c0.8-0.2,1.6-0.5,2.5-0.9l0.2,0c0.3,0.1,0.6,0.1,0.9,0.2\n                c0.4,0.1,0.8,0,1-0.3l0.9-1.1c2.4-1,4.7-1.8,6.5-2.2v-2.6c-0.6-0.4-1.1-1-1.6-2.3c-0.1-0.3-0.4-0.6-0.8-0.6\n                c-0.3-0.1-0.7,0.1-0.9,0.4l-4.5,5.8l-0.2,0.1c-0.6,0.2-1.2,0.5-1.8,0.7c-0.9-0.2-1.4-0.5-1.8-1.2c-0.2-0.4-0.7-0.6-1.1-0.5\n                c-0.4,0.1-0.8,0.5-0.8,1v2.8c0,0.3,0.1,0.6,0.4,0.8C129.2,121.7,129.4,121.8,129.6,121.8z M133.7,115.8c0.2,0.3,0.4,0.5,0.8,0.5\n                c0,0,0.1,0,0.1,0c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.4-0.5,0.6-0.7c0.9-1,2.2-2.3,1.5-4.2c-0.1-0.4-0.5-0.7-0.9-0.7\n                c-0.4,0-0.8,0.2-0.9,0.6c-0.5,1.1-1,2-1.5,2.4c-1.3-0.9-3.1-0.9-4.6-0.9l-0.3-0.2c-0.8-0.5-1.7-1-2.5-1.4c0.3-0.2,0.5-0.4,0.8-0.5\n                h1.3c0.5,0,0.9-0.4,1-0.8c0.1-0.5-0.2-0.9-0.7-1.1c-0.7-0.2-1.3-0.2-1.9-0.1h-2.3c-0.5,0-0.9,0.4-1,0.9c-0.1,0.7,0,1.3,0,1.8\n                c0,0.2-0.1,0.4,0,0.5c0,0.2,0.1,0.3,0.3,0.4c0.8,2.2,3.2,2.4,4.8,2.4C130.4,115.3,132.1,116.1,133.7,115.8z M141.1,61.2l-0.2,0\n                c-1.1-0.4-2.3-0.9-3.6-1.4l-0.9-0.4c-0.3-0.1-0.6-0.1-0.9,0.1c-0.3,0.2-0.4,0.4-0.5,0.7c-0.1,0.8,0.1,1.4,0.5,1.9\n                c0.8,0.9,2.2,1.1,4.3,1.1l0.8,0c0.4,0.2,0.9,0.3,1.4,0.5v-2.5C141.7,61.2,141.4,61.2,141.1,61.2z M108.6,0.1\n                c-0.2,0.3-0.4,0.5-0.6,0.8c-0.2,0.3-0.5,0.7-0.7,1c-0.2,0.3-0.2,0.7,0,1l0.6,1.1c0.2,0.3,0.5,0.5,0.8,0.5c0,0,0,0,0,0\n                c0.3,0,0.7-0.2,0.8-0.5c0.9-1.5,1.2-2.7,1.1-3.8c0.1-0.1,0.1-0.2,0.2-0.4h-2.5C108.5,0,108.6,0.1,108.6,0.1z M51.4,84.6\n                C51.4,84.5,51.4,84.5,51.4,84.6l0.2-0.3c0.1,0.1,0.3,0.1,0.4,0.2c1.4,2.8,4.4,4.8,6.7,6.4L59,91c0.6,1,1.3,2,1.9,3.1l0.5,0.8\n                c0.1,0.2,0.4,0.4,0.7,0.5c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.2c0.8-0.6,1-1.3,1-1.8c0-1.3-1.3-2.3-3.4-3.8\n                c-1.7-2.5-3.7-5.1-6.8-6.6c-0.1-0.2-0.2-0.5-0.2-0.7c-0.1-0.3-0.3-0.6-0.6-0.7c-0.3-0.1-0.7-0.1-0.9,0.1l-0.5,0.4\n                c-0.8-0.3-1.8-0.4-2.7-0.6c-0.4-0.1-0.8,0.2-1,0.5c-0.2,0.4-0.1,0.8,0.2,1.1l0.9,0.9L44,87.6c-0.4,0.3-0.5,0.9-0.2,1.4\n                c0.3,0.4,0.9,0.5,1.3,0.3l5.9-4C51.2,85.1,51.4,84.9,51.4,84.6z M7.3,123c0.5-0.1,0.8-0.6,0.8-1.1C8,121.3,7.5,121,7,121\n                c-1.3,0.2-2.5,0.5-3.5,0.8l-2.8,0.6L0,122v2.7c1.2-0.2,2.3-0.5,3.4-0.8L7.3,123z M76.3,104.9c0.4,1.3,1,3,2.8,3.8\n                c0.1,0.1,0.3,0.1,0.4,0.1c0.3,0,0.5-0.1,0.7-0.3c0.3-0.3,0.4-0.8,0.2-1.1l-3.9-7.9c-0.1-0.3-0.4-0.5-0.7-0.5\n                c-0.3-0.1-0.6,0.1-0.9,0.3l-2,2c-0.3,0.3-0.4,0.8-0.2,1.2c0.2,0.4,0.6,0.6,1,0.5C75.2,102.5,75.6,103,76.3,104.9z M2.3,40.3\n                c-0.2-0.4-0.6-0.7-1.1-0.6c-0.4,0.1-0.8,0.1-1.2,0.2v2.3c0.7,0,1.3-0.3,1.9-0.7C2.3,41.2,2.5,40.7,2.3,40.3z M3.2,29.4\n                C3.7,29.3,4,28.9,4,28.4c0-0.3,0-0.6,0-0.9c0-1.3,0-3-1.9-4.3L0,17.8v6.7c0.1,0,0.3,0.1,0.5,0.2l1.6,4.2C2.3,29.3,2.7,29.6,3.2,29.4\n                z M104.3,107c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0.1,0,0.1,0c0.2,0,0.3-0.2,0.3-0.4l0.1-4.5c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1\n                l-2.5,0.4c-0.1,0-0.2,0.1-0.3,0.2s0,0.3,0,0.4L104.3,107z M93,104.6c0.6,0.3,1.2,0.5,1.8,0.7c0.1,0.1,0.3,0.1,0.4,0.1\n                c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c2.5,0.1,3.5-2,4.2-3.6c1.2-0.9,2.8-2.2,3.1-4c0.3,0,0.6-0.2,0.7-0.5c0.1-0.3,0.1-0.6,0-0.9\n                c-0.1-0.3-0.3-0.6-0.4-0.8c-0.5-1.2-1.2-2.9-3.3-3c-0.4,0-0.8,0.2-1,0.6c-0.2,0.4-0.1,0.8,0.2,1.1c0.9,0.9,1.4,1.6,1.7,2.3\n                c-1.3,0.9-2,2.5-2.6,4l-0.3,0.2c-0.8,0.6-1.6,1.2-2.2,1.8c-0.1-0.3-0.2-0.6-0.2-0.9l0.5-1.2c0.2-0.4,0-1-0.4-1.2s-0.9-0.2-1.3,0.2\n                c-0.5,0.5-0.7,1.1-0.8,1.8l-0.9,2.1C92.4,103.8,92.6,104.4,93,104.6z M81.1,101.1l1.4-1.3c0.4-0.4,0.4-1,0.1-1.4l-1.3-1.5\n                c-0.2-0.2-0.5-0.3-0.8-0.3l-1.6,0.1c-0.3,0-0.5,0.1-0.7,0.4c-0.2,0.2-0.2,0.5-0.2,0.8l0.2,1.2c0,0.2,0.1,0.4,0.2,0.5l1.3,1.5\n                c0.2,0.2,0.4,0.3,0.7,0.3c0,0,0,0,0,0C80.7,101.3,80.9,101.3,81.1,101.1z M91.2,94.6c0.3,0,0.6-0.1,1-0.2c0.3,0.3,0.7,0.5,1.1,0.8\n                c0.1,0,0.1,0.1,0.2,0.1v0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.2,0,0.4-0.1,0.5-0.2\n                c0,0,0,0,0,0l5.9-4c0.3-0.2,0.5-0.6,0.4-1c-0.1-0.4-0.3-0.7-0.7-0.8c-0.4-0.1-0.7-0.2-1.1-0.2c-1.9,0-3,1.4-4.1,2.7\n                c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2-0.2-0.7-0.4-1.2-0.3c-0.3-0.8-0.3-1.9-0.3-3l0-0.8c0-0.5-0.3-0.9-0.8-1c-0.5-0.1-0.9,0.2-1.1,0.6\n                c-1.5,3.8-1.5,5.1-1,5.9C90,94.2,90.4,94.6,91.2,94.6z M57.1,46.3c-0.5-0.1-0.9,0.1-1.1,0.5l-1,2.1l-1.3,0.3\n                c-0.3,0.1-0.5,0.2-0.6,0.5C53,49.9,53,50.2,53,50.4l1.2,4.1c0.1,0.4,0.5,0.7,0.9,0.7c0.1,0,0.2,0,0.2,0l1.8-0.4\n                c0.4-0.1,0.8-0.5,0.8-1l0-6.6C57.9,46.8,57.5,46.4,57.1,46.3z M89.5,46.1c-0.2-0.3-0.6-0.4-0.9-0.3c-2.2,0.4-3.8,1.4-4.7,2.9\n                c-0.1,0.1-0.1,0.2-0.1,0.3l-0.2,1c-0.1,0.4,0.1,0.8,0.5,1c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.4-0.3,0.6-0.5\n                c1.3-1.1,2.4-2,4-1.2c0.4,0.2,0.9,0.1,1.2-0.3c0.3-0.4,0.3-0.9,0-1.3L89.5,46.1z M90.8,50.4h-2c-0.4,0-0.8,0.3-0.9,0.7L86,57\n                c-0.1,0.4,0,0.9,0.4,1.2c0.2,0.1,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.3l1.7-1.7h1.6c0.5,0,1-0.4,1-1v-4\n                C91.8,50.9,91.4,50.4,90.8,50.4z M62.6,59c-0.4-0.4-1-0.4-1.4,0l-1.4,1.4c-0.3,0.3-0.4,0.8-0.2,1.1l2.8,5.6c0.2,0.3,0.5,0.5,0.9,0.5\n                c0.1,0,0.1,0,0.2,0c0.4-0.1,0.8-0.5,0.8-1v-2.4l1.1-1.1c0.4-0.4,0.4-1,0-1.4L62.6,59z M83.7,46.7c-0.4-0.3-1-0.1-1.3,0.3\n                c-0.8,1.1-1.3,2.2-1.6,3.4l-2.7,5.9c-0.2,0.4-0.1,0.9,0.2,1.2c0.3,0.3,0.8,0.3,1.2,0.1l1.1-0.7c0.2,0.8,0.6,1.7,1,2.5\n                c0.3,1.8,0.3,3.2-0.5,4.3l-0.8-1.3c-0.3-0.5-0.9-0.6-1.4-0.3l-1.7,1c-0.2,0.1-0.4,0.4-0.4,0.6c-0.1,0.3,0,0.5,0.1,0.7l1.5,2.4\n                c0.1,0.2,0.4,0.4,0.6,0.4c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.5-0.1l1.6-1c1.6-0.6,2.5-1.4,3-2.4c0.7-1.7-0.1-3.5-0.9-5.1\n                c-0.1-0.5-0.2-1-0.3-1.6c-0.5-2-0.9-4.1-0.5-6.2l1.4-3.1C84.3,47.5,84.1,47,83.7,46.7z M6.3,54c-0.4,0.1-0.7,0.4-0.8,0.8l-0.4,2\n                c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5,0-0.7,0c-1.1,0-2.5,0.2-3.6,1.6c-0.2,0.3-0.3,0.8,0,1.1C0.8,59.9,1.1,60,1.4,60c0,0,0.1,0,0.1,0\n                l7.1-1.1c0.3-0.1,0.6-0.3,0.8-0.6c0.1-0.3,0.1-0.7-0.1-1l-2.1-3C7,54.1,6.6,54,6.3,54z M92.8,76c0,0.4,0,0.7,0,1.1\n                c0,0.3,0.2,0.5,0.4,0.7C93.4,78,93.7,78,94,78l0.2,0c0,0.1,0,0.2,0.1,0.3c0.1,0.4,0.3,0.7,0.7,0.8c0.1,0,0.2,0,0.3,0\n                c0.3,0,0.5-0.1,0.7-0.3l1.4-1.6c0.3-0.3,0.3-0.8,0.1-1.1c-0.2-0.4-0.6-0.6-1-0.5l-0.9,0.2c-0.3-0.5-0.6-1-0.9-1.5\n                c-0.3-1.1-0.9-1.8-1.9-2.1c-0.1,0-0.3-0.1-0.5,0L91,72.3c-0.1,0-0.3,0-0.5,0v-1.5c0-0.4-0.3-0.8-0.6-0.9c-0.4-0.1-0.8,0-1.1,0.3\n                L86,73.4c-0.3,0.3-0.3,0.9-0.1,1.2c0.3,0.4,0.8,0.5,1.2,0.3c0.6-0.3,1.3-0.5,1.8-0.6c0.2,0.2,0.5,0.2,0.7,0.2l1.3-0.2\n                c0.7,0.1,1.2,0.4,1.7,0.8C92.8,75.4,92.8,75.7,92.8,76z M33.1,43c-0.4-0.2-0.8-0.1-1.1,0.2c-1.7,1.8-2.5,3.7-2.9,5.2\n                c-0.1,0.2-0.1,0.4-0.2,0.6l-0.3,1c-0.4,1.7-0.8,3.2-1.8,4.3l0,0c-0.3-0.1-0.6-0.1-0.9-0.2c-0.2,0-0.4,0-0.5,0\n                c-1.3,0.4-1.7,1.3-1.9,2.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.4,0.1-0.7,0.4-0.8,0.8c-0.1,0.4,0.1,0.8,0.4,1c0.9,0.6,0.9,1.3,0.9,2.6\n                c0,0.4,0,0.7,0,1.1c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0l7.1-0.2c0.5,0,0.9-0.4,0.9-0.8c0.1-0.5-0.2-0.9-0.7-1.1\n                c-0.9-0.3-1.8-0.4-2.8-0.5c-1.8-0.2-2.9-0.3-3.6-1.4c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2,0-0.3c0.8-0.3,1.5-0.7,2.2-1.2\n                c0.8,0.2,1.3,0.5,1.6,1.1c0.2,0.4,0.5,0.6,1,0.6c0.4,0,0.8-0.3,0.9-0.7c0.4-1.4,0.2-3,0.1-4.5c-0.1-1.3-0.3-2.5-0.1-3.5l0.1-0.5\n                c0.2-0.5,0.6-1.1,1.9-1.4c0.5-0.1,0.8-0.5,0.8-1V44C33.7,43.6,33.5,43.2,33.1,43z M33,56.3c-0.1,0.4,0,0.8,0.3,1l5.3,4.8\n                c0.2,0.2,0.4,0.3,0.7,0.3c0.1,0,0.2,0,0.3-0.1c0.3-0.1,0.6-0.4,0.6-0.8l0.6-3.9c0.1-0.4-0.1-0.8-0.5-1c-0.3-0.2-0.8-0.2-1.1,0.1\n                l-1.5,1.1c0,0,0,0,0,0c-0.8-1.1-1.9-2.5-3.9-2.1C33.4,55.6,33.1,55.9,33,56.3z M115.2,62.1c-1.1-2-2.5-3-4.3-3.8l-1.2-1.2\n                c-0.4-0.4-1-0.4-1.4,0l-0.1,0.1c-0.2-0.1-0.5-0.2-0.8-0.3c-0.5-0.2-1,0-1.3,0.5l-2,4c-0.2,0.4-0.1,1,0.3,1.2\n                c0.4,0.3,0.9,0.2,1.3-0.1l2.9-2.9l0,0c0.4,0.1,0.7,0.3,1.1,0.4l4.4,4.5c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.4,0.2\n                c0.4,0.1,0.7,0.2,1,0.2c1.4,0,2.4-0.9,3.1-1.7c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.2,0.4-0.6,0.3-0.9c0-0.2-0.2-0.4-0.3-0.5\n                c0.3,0,0.6-0.2,0.7-0.4c0.3-0.4,0.2-1-0.2-1.3l-0.8-0.7c-1.8-1.4-3.8-3-3.8-4.6c0-0.5-0.3-0.9-0.8-1l-2.1-0.3\n                c-0.3-0.1-0.7,0.1-0.9,0.3c-0.2,0.3-0.3,0.6-0.2,1l0.1,0.4l-0.6-0.4c-0.7-0.7-1.2-1.6-1.8-2.4c-0.8-1.3-1.6-2.6-3.2-3.8\n                c-0.4-0.3-1-0.2-1.3,0.2l-2,2.3c-0.2,0.2-0.3,0.5-0.2,0.8c0,0.3,0.2,0.6,0.5,0.7l6.8,3.9c0.7,0.6,1.4,1.1,2.3,1.5\n                c0.1,0,0.2,0.1,0.3,0.1l0.4,0.1l5.8,3.3C117.1,60.6,116,61.3,115.2,62.1z M56,59.5c0.1,0.4,0.4,0.7,0.8,0.8c0.2,0,0.5,0.1,0.7,0.1\n                c0,0,0,0,0,0c1.8,0,3.2-1.3,4.4-2.5c0.5-0.5,1-0.9,1.4-1.2l0.4-0.3c0.2-0.1,0.3-0.1,0.5-0.1c0.3,0.5,0.8,1,1.3,1.3\n                c-0.3,0.8-0.3,1.9,0.4,3.4c0,0,0,0,0,0c-0.1,0.4-0.1,0.8,0.2,1.1c1,1,1.5,1.5,1.7,1.7c0,0,0,0,0.1,0.1c0.2,0.2,0.5,0.3,0.8,0.3\n                c0,0,0,0,0,0c0.4,0,0.7-0.3,0.9-0.6c0.1-0.4,0-0.8-0.3-1.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0.4-0.1,0.6-0.5,0.6-0.9v-2\n                c0-0.4-0.2-0.7-0.5-0.9c0.1,0,0.1-0.1,0.2-0.1l1.3,0c0.5,0,0.9-0.4,1-0.8c0.1-0.5-0.2-0.9-0.7-1.1c-0.7-0.2-1.4-0.2-2,0\n                c-0.6,0-1.2,0-1.8-0.2c-0.2-0.3-0.4-0.6-0.6-0.8c0.7-0.4,1.3-0.8,2-1.1c0.9-0.1,1.7-0.5,2.5-0.8l0.3-0.1c2.1-0.4,3.4,0.2,4.1,1.8\n                c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.5,0.7,0.8,1.2,0.6c0.5-0.2,0.8-0.7,0.6-1.2c-0.1-0.2-0.2-0.5-0.3-0.7c-1-2.4-2.3-3.5-4-3.5\n                c-0.9,0-1.7,0.3-2.5,0.6c-0.9,0.2-1.8,0.5-2.8,0.9c-0.6,0.1-1.4,0-2.3-1.5c-0.2-0.3-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.1-0.8,0.3\n                l-1.4,1.4c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.7,0.7l-0.7,0.4c-0.2,0.1-0.4,0.2-0.5,0.3l-5.8,3.5\n                C56.1,58.7,55.9,59.1,56,59.5z M49.4,100l-0.3-1c0.1-1.8-0.5-3.6-1.8-5.3c-0.3-0.4-0.8-0.5-1.2-0.3c-0.4,0.2-0.6,0.7-0.5,1.2\n                l1.5,4.6c-0.1,1.1-0.7,2.2-1.6,3.1c-0.5,0.2-1,0.1-1.8-0.4l-1.5-1.5c1.1-1.1,1.4-2.5,1.4-3.7c0-0.3,0-0.5,0-0.8c0-0.3,0-0.6,0-0.8\n                l0-0.8c0-0.3-0.2-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-0.9-0.1c-0.2,0.1-0.3,0.1-0.4,0.1c-0.6,0-1.1-0.5-1.8-1.2c-0.3-0.3-0.5-0.5-0.8-0.7\n                c-0.4-0.3-0.9-0.3-1.3,0c-0.4,0.3-0.4,0.9-0.1,1.3c0.2,0.2,0,0.6-0.2,0.9c-1.7,1.5-2,2-1.8,2.6c-0.5,0.7-1,1.3-1.8,1.8\n                c-0.4,0.2-0.8,0.4-1.2,0.6c-0.3,0-0.5,0.1-0.8,0.1c-0.4,0.1-0.9,0.1-1.3,0.1l1-1.5c0.8-0.8,1.9-1.5,2.8-2c0,0,0,0,0,0c0,0,0,0,0,0v0\n                c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.5-0.3,1-0.6,1.4-0.9l1.1-0.7c0.4-0.3,0.6-0.8,0.4-1.3L37,91.7c-0.2-0.3-0.5-0.5-0.8-0.5\n                c-0.4,0-0.7,0.1-0.9,0.4L35,92l-5.9,0.9c-0.3,0-0.5,0.2-0.6,0.4L27,95.3c-0.2,0.3-0.2,0.7-0.1,1.1c0.2,0.3,0.5,0.5,0.9,0.5\n                c0.4,0,0.8-0.1,1.2-0.1c0.4-0.1,0.8-0.1,1.2-0.1c-0.8,0.7-1.3,1.5-1.6,2.2l-1.6,2.2c-0.1,0.1-0.3,0.1-0.4,0.2l-2.4,0.4\n                c-0.3,0-0.5,0.2-0.6,0.4l-2,2.8c-0.3,0.4-0.2,1,0.2,1.3c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c1.2-1.2,2.5-2.2,4.1-2.9\n                l0.5-0.1c0.3,0,0.5-0.2,0.6-0.4c0.8-0.3,1.6-0.5,2.4-0.8c0.9-0.3,1.8-0.6,2.7-0.9c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.1\n                c0.6-0.2,1-0.5,1.5-0.9c1.5-0.9,2.6-2.2,3.5-4c0.1-0.1,0.1-0.2,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.2c1.7,0.1,2.4,0.5,2.5,0.8\n                c0,0.1,0,0.2,0,0.4c-0.2,0.9-1.3,2.1-2.3,2.9c-0.1,0-0.2-0.1-0.3-0.1c-0.4-0.1-0.9,0-1.1,0.4c-0.2,0.3-0.7,1-0.4,1.7\n                c0.2,0.3,0.6,0.6,1,0.6c0.2,0,0.5,0,1-0.3c0.5,0.3,1.1,0.6,1.6,1c0.5,0.3,1,0.6,1.4,0.9l1.4,1.4c0.2,0.2,0.4,0.3,0.7,0.3\n                c0.2,0,0.3,0,0.5-0.1c0.6-0.3,1.1-0.7,1.5-1.1c1-0.5,1.9-1.6,2.8-3.3C49.5,100.5,49.5,100.2,49.4,100z M141.4,44.5\n                c0.2,0.2,0.4,0.3,0.6,0.3v-2c-0.2,0.1-0.3,0.2-0.5,0.4C141.1,43.5,141.1,44.1,141.4,44.5z M122.3,27.5L122.3,27.5\n                c0.4-0.3,0.5-0.7,0.4-1.1c0.3-1.5-0.4-3-2.3-4.5c-0.4-0.3-0.9-0.3-1.2,0c-0.4,0.3-0.5,0.8-0.3,1.2l1.6,3.3c-0.5,0.4-0.9,0.9-1.3,1.4\n                c-1,1.2-1.9,2.2-3.1,1.9c-0.3-0.1-0.6,0-0.9,0.2c-0.2,0.2-0.4,0.5-0.4,0.8l0,0.8c0,2-0.1,4.7,2.5,6c0.1,0.1,0.3,0.1,0.4,0.1\n                c0.3,0,0.5-0.1,0.7-0.3c0.3-0.3,0.3-0.8,0.1-1.2c-1.7-2.5-0.5-3.9,1.6-6.1C121.1,29.1,121.8,28.4,122.3,27.5z M140.7,39.8\n                c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.5,0.3-1.7,0.5-2.5c0.2-0.5,0.3-1,0.4-1.5c0.1-0.2,0.1-0.4,0.1-0.5c0.6-3-1-4-2.5-4.3\n                c-0.3-0.1-0.5,0-0.7,0.1l-2.6,1.6c-0.4,0.3-0.6,0.8-0.4,1.3c0.2,0.5,0.7,0.7,1.2,0.5c0.7-0.2,1.2-0.4,1.7-0.4c0.6,0,0.8,0.2,1.2,1.1\n                l-1,1.3c-0.5-0.2-1.2,0.1-1.4,0.6c-0.4,1,0.8,3,1.7,3.9c0.3,0.4,0.6,0.7,1.1,0.9c0.6,0.4,1.3,0.6,2,0.6c0.1,0,0.2,0,0.3,0v-2.3\n                C141.4,39.9,140.9,39.8,140.7,39.8z M67.5,68.1c-0.6,0.1-1.3,0.3-1.9,0.6l-0.7-0.7c-0.3-0.3-0.7-0.4-1.1-0.2\n                c-0.4,0.2-0.6,0.5-0.6,0.9v2c0,0.4,0.2,0.7,0.5,0.9c0.3,0.2,0.7,0.1,1-0.1c0.1-0.1,0.3-0.2,0.4-0.3l0.2,0.2c0.2,0.2,0.5,0.3,0.8,0.3\n                c0.3,0,0.6-0.2,0.7-0.4c0.3-0.5,0.7-0.9,1.1-1.1c2-0.2,3.9,0.9,5.1,3.1c0.2,0.3,0.4,0.4,0.7,0.5c0,0,0.1,0,0.1,0\n                c0.3,0,0.5-0.1,0.7-0.3l2-2c0.2-0.2,0.3-0.6,0.3-0.9c-0.1-0.3-0.3-0.6-0.6-0.7c-0.5-0.2-1.1-0.4-1.7-0.7c-1.5-0.6-3.3-1.4-5-1.4\n                C68.9,67.6,68.1,67.8,67.5,68.1z M133.8,78.6c-0.4,0-0.8,0.3-0.9,0.8c-0.1,0.4,0.1,0.8,0.4,1.1l1,0.6c0.2,0.1,0.3,0.1,0.5,0.1\n                c0.1,0,0.2,0,0.2-0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4-0.1l1.9-0.8l4.4-0.4v-3.9l-5.4,2.4L133.8,78.6z M103.1,46.8\n                c0.1,0,0.2,0,0.2-0.1l4-2.9c0.2-0.1,0.2-0.3,0.1-0.5c-0.1-0.2-0.3-0.3-0.5-0.2l-6,1.8c-0.1,0-0.3,0.2-0.3,0.3c0,0.2,0.1,0.3,0.2,0.4\n                l2,1.2C102.9,46.8,103,46.8,103.1,46.8z M124.8,35.9c1.3,0.7,1.7,1.7,2.1,2.9c0.1,0.4,0.3,0.7,0.4,1c0.2,0.4,0.5,0.6,0.9,0.6\n                c0,0,0,0,0,0l7-0.2c0.5,0,0.9-0.4,0.9-0.9c0.1-0.5-0.2-0.9-0.7-1.1c-1-0.3-1.9-0.4-2.9-0.5c-1.7-0.2-3.2-0.3-4.5-1.7\n                c-0.1-0.3-0.2-0.5-0.3-0.8c0-0.1,0-0.1-0.1-0.2c0.6-0.3,1-0.6,1.4-1c0.9,0.2,1.6,0.6,2.2,1.3c0.3,0.3,0.7,0.4,1.1,0.3\n                c0.4-0.2,0.6-0.6,0.6-1c-0.1-1.4-0.8-2.9-1.5-4.5c-0.6-1.2-1.2-2.5-1.3-3.5l0-0.4c0-0.4,0.1-0.9,1.1-1.1c0.3-0.1,0.5-0.2,0.6-0.5\n                c0.1-0.2,0.2-0.5,0.1-0.8l-1-2.8c-0.1-0.4-0.4-0.6-0.8-0.6c-0.4,0-0.7,0.1-0.9,0.5c-1.1,1.9-1.2,3.9-1.1,5.4c0,0.2,0,0.4,0,0.6\n                l0.1,1c0.2,1.5,0.3,2.9-0.1,3.9c-0.3-0.1-0.6-0.1-0.9-0.2c-0.2,0-0.4,0-0.6,0c-0.6,0.2-1.4,0.7-1.4,2.1c-0.2,0-0.3,0.1-0.5,0.1\n                c-0.4,0.1-0.7,0.4-0.8,0.8C124.2,35.3,124.4,35.7,124.8,35.9z M115,22.1c-0.5,2-0.2,3.5,0.9,4.8c0.2,0.2,0.5,0.3,0.7,0.3\n                c0.2,0,0.4-0.1,0.6-0.2c0.4-0.3,0.5-0.9,0.2-1.3c-0.6-0.9-0.7-1.9-0.5-3.2c0.2-0.8,0.5-1.6,0.9-2.3c0.8-1.9,1.6-3.8,0.8-5.5\n                c-0.5-1.1-1.6-1.9-3.3-2.5c-0.5-0.1-0.9,0-1.2,0.5c-0.2,0.4-0.1,0.9,0.2,1.2c2.3,1.9,1.8,3.8,1.1,6.2\n                C115.3,20.7,115.1,21.4,115,22.1z M122.2,4.8l-6.3,3.7c-0.2-0.3-0.3-0.7-0.5-1.2c-0.1-0.4-0.3-0.8-0.4-1.2c0,0,0,0,0-0.1\n                c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0s0,0,0,0c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0-0.2-0.1-0.4,0c-0.1,0-0.2,0-0.4,0.1c0,0-0.1,0-0.1,0\n                l-1.3,0.8l0.7-1.8c0.7-2.9-1.7-1.1-1.7-1.1c-0.9,0.9-2.2,1.8-4,2.7c-0.5,0.2-0.7,0.8-0.5,1.3c0.2,0.5,0.7,0.7,1.2,0.6\n                c0.4-0.1,0.7-0.2,0.9-0.2c0.2,0,0.2,0,0.4,0.5c0.1,0.3,0.2,0.5,0.3,0.7c0,0,0,0.1,0.1,0.1v0c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.4,0.3\n                c0.1,0,0.1,0,0.2,0.1c0.2,0,0.5,0,0.7-0.1c0,0,0,0,0,0l2.7-1.6l0.8,2.4c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0.1,0.6,0.1,0.8-0.1l0,0\n                c0.4,0.1,0.8,0.2,1.3,0.2c0.8,0,1.7-0.2,2.8-0.5c0.2-0.1,0.4-0.2,0.5-0.3l3.1-3.9c0.3-0.4,0.3-0.9,0-1.3\n                C123.1,4.7,122.6,4.6,122.2,4.8z M121.7,33.6c0.2,0,0.4-0.1,0.6-0.2l1.5-0.6c0.1-0.1,0.2-0.3,0.3-0.4l3.7-6.1c0.2-0.5-0.1-1-0.5-1.2\n                c-0.5-0.2-1,0-1.3,0.4l-5.2,6.7c-0.2,0.4-0.1,0.9,0.3,1.2C121.3,33.6,121.5,33.6,121.7,33.6z M141.5,46.4c-0.4-0.1-0.8,0-1.1,0.4\n                l-1.4,1.9c-0.2,0.3-0.2,0.7-0.1,1.1c0.2,0.3,0.6,0.5,0.9,0.5c0.2,0,0.4,0,0.5-0.1l0.2,2.2l-1.4,2c-0.1,0.1-0.3,0.1-0.4,0.2l-2.4,0.4\n                c-0.3,0-0.5,0.2-0.6,0.4l-2,2.8c-0.3,0.4-0.2,1,0.2,1.3c0.2,0.2,0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c1.2-1.2,2.5-2.2,4.1-2.9\n                l0.5-0.1c0.3,0,0.5-0.2,0.6-0.4c0.5-0.2,1.1-0.4,1.6-0.6v-8.7C141.9,46.7,141.7,46.5,141.5,46.4z M132.2,19c0,0.1,0.1,0.1,0.1,0.2\n                c-0.1,0.6,0,1.5,0.1,2.8c0,0.4,0.3,0.8,0.8,0.9l1.9,0.5c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2c0.2-0.2,0.4-0.5,0.3-0.8L136,19\n                c0-0.1,0-0.2-0.1-0.4c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.2,0.4-0.4,0.4-0.7c0-0.3,0-0.5-0.2-0.8c-0.1-0.2,0.1-1.2,0.2-1.6\n                c0.2-0.7,0.4-1.5,0.2-2.1l0.7-1.3c0.2-0.4,0.1-1-0.3-1.3c-0.4-0.3-1-0.2-1.3,0.2l-1.5,1.7c-0.3,0.3-0.3,0.7-0.1,1.1\n                c0,0,0,0.1,0.1,0.1l-2.3,4.6C132.1,18.4,132.1,18.8,132.2,19z M113.8,19.6c0.3-0.1,0.5-0.4,0.5-0.7c0.1-0.3,0-0.6-0.3-0.9l-1.4-1.4\n                c-0.2-0.2-0.4-0.3-0.7-0.3s-0.5,0.1-0.7,0.3l-0.9,0.9l-0.2-0.8c0.1-0.7,0.5-1.3,1-2c0.7-1.1,1.5-2.4,1.3-4.1c-0.1-0.5-0.5-0.9-1-0.9\n                h-3.9c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.2-0.2,0.6-0.2,0.9l1.6,5.8c-0.1,0.7,0,1.5,0.4,2.2c0,0.1,0.1,0.2,0.2,0.3l0.2,0.2l1.5,5.3\n                c0.1,0.4,0.5,0.7,0.9,0.7c0,0,0.1,0,0.1,0c0.5-0.1,0.8-0.5,0.8-1l0-0.8C112.4,21.7,112.4,20.3,113.8,19.6z M126.9,9.5\n                c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4-0.1c-0.2,0.2-0.4,0.4-0.6,0.6l-1.4,1.4c-0.2,0.2-0.3,0.5-0.3,0.8c-0.7,1.1-1.4,2.3-2.1,3.6\n                c-0.5,0.6-0.9,1.1-1.4,1.4c-0.2,0.2-0.4,0.4-0.4,0.7c0,0.3,0.1,0.6,0.3,0.8l0.1,0.1c-0.1,0.3-0.2,0.5-0.3,0.8\n                c-0.1,0.3-0.1,0.7,0.1,0.9c1.2,1.7,2.7,2.4,4.2,2.2c0.2,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.5-0.4,0.8-0.7\n                c1.1-0.7,2.2-1.8,3.1-2.8c0.9-0.9,1.8-1.9,2.5-2.2c0.2,0,0.4,0,0.7,0c0.5,0,0.9-0.3,1-0.8c0.1-0.5-0.2-1-0.7-1.1\n                c-0.5-0.2-1.1-0.1-1.7,0.1c-2.1,0.5-3.5,2.1-4.9,3.8c-0.5,0.5-0.9,1.1-1.4,1.6c-0.1,0-0.1,0.1-0.2,0.1l-2.2-2.2\n                c0.2-0.5,0.5-1,0.7-1.5c0,0,0,0,0,0c1-1.2,1.9-2.2,3.1-1.9c0.4,0.1,0.9-0.1,1.1-0.4c0.2-0.4,0.2-0.9-0.2-1.2l-1.2-1.2\n                c0.2-0.3,0.5-0.6,0.7-0.8L126.9,9.5z M112.9,49.5l-0.7-2.1c-0.1-0.3-0.4-0.6-0.8-0.6l-2.1-0.3c-0.3-0.1-0.7,0.1-0.9,0.3\n                c-0.2,0.3-0.3,0.6-0.2,1l1,2.8c0.1,0.3,0.4,0.6,0.8,0.6l2,0.3c1,0.3,1.9,0.5,2.5,0.5c0.9,0,1.6-0.3,2-0.9c0.8-1.1,0.4-2.7,0-4.4\n                c0-0.4,0-0.9,0-1.4c0-1.7,0-3.5,0.9-4.6l1.4-0.8c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.4\n                c-0.2,0.2-0.3,0.5-0.2,0.8c0,0.3,0.2,0.5,0.5,0.7c1.6,1,2.7,1.9,3.3,2.6c0.2,1.2-0.5,2.2-1.7,3.8c-0.8,1-1.7,2.2-2.4,3.7\n                c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.2,0,0.3c0,0.1,0,0.3,0.1,0.4c0,0,0,0.1,0.1,0.1c0.4,0.6,0.8,1.1,1.3,1.4l-1.2,1.3\n                c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l1.9-1.9c2.2-0.2,3.9-2.9,5.7-5.8c0.3-0.5,0.6-1,0.9-1.5l3-3.2\n                c0,0,0.1,0,0.1,0c0,0,0,0,0,0c1.2,1.3,3.3,2.6,4,2.6c0.5,0,0.9-0.3,1-0.8c0.2-0.9-0.4-1.2-2.3-2.2c-0.5-0.6-1-1.1-1.5-1.3\n                c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3,0-0.6,0.1-0.8,0.3l-0.6,0.6c-1.3,0.6-2.4,2.1-3.4,3.6l-5.8,6.2l-0.5-0.5\n                l3.2-3.3c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3,0.1-0.6,0.3-1c0.4-0.9,0.9-2.2-0.1-3.8c-0.3-1.2-1.1-2.4-2.3-3.7c0.5-0.7,1.1-1.8,0.6-3.2\n                c-0.1-0.3-0.4-0.6-0.7-0.7c-0.3-0.1-0.7,0-0.9,0.3l-1.1,1.1c-0.2-0.2-0.5-0.3-0.8-0.2c-1.2,0.3-2.1,0.8-2.8,1.6l-4.4,2.6\n                c-0.4,0.2-0.6,0.6-0.5,1c0.1,0.4,0.4,0.7,0.8,0.8l2,0.3c0,0.9,0.2,1.9,0.5,2.9C114.5,48.6,114.1,49.3,112.9,49.5z M134.8,67.4\n                c0.6,0.7,1.4,1.1,2.4,1.4c0.4,0,0.8,0,1.1-0.1c1,0.2,2,0.5,2.7,1l1,0.6v-5l-0.5-0.9c-0.2-0.3-0.5-0.5-0.8-0.5\n                c-0.3,0-0.6,0.1-0.8,0.4c-0.2,0.3-0.4,0.6-0.6,0.9c-0.4,0.6-0.7,1.1-1.1,1.4c-0.8-0.2-1.5-0.4-2.1-0.7c-0.5-0.7-0.7-1.8-1-2.8\n                l-0.2-0.8c-0.1-0.5-0.5-0.7-1-0.8c-0.5,0-0.9,0.3-0.9,0.8C132.6,64.6,133.2,66.3,134.8,67.4z M135.3,24.4c-0.3-0.1-0.7,0.1-0.9,0.4\n                c-0.2,0.3-0.3,0.7-0.1,1c0.6,1.6,1.7,1.8,2.3,1.8c0.2,0,0.4,0,0.6-0.1c-0.2,0.5-0.6,1-1.1,1.5c-0.3,0.3-0.4,0.7-0.2,1.1\n                c0.2,0.4,0.5,0.6,0.9,0.6c0,0,0,0,0,0c0.2,0,0.5-0.1,0.7-0.3c0.1-0.1,0.5-0.4,1-0.9c1.2-0.7,1.6-2,1.9-3.2c0.4-1.5,0.7-1.9,1.2-1.9\n                c0.1,0,0.3,0,0.5,0.1v-6.7l-0.1-0.3c-0.2-1.7-0.7-3.3-1.8-4.5c-0.3-0.4-0.8-0.5-1.3-0.2c-0.4,0.2-0.6,0.8-0.4,1.2L140,18\n                c0.1,2.6-1,5.4-2.3,6.8L135.3,24.4z M132.6,56.2c0.7-0.5,1.4-1.2,1.9-1.9c1-1.2,1.9-2.2,3.1-1.9c0.4,0.1,0.9-0.1,1.1-0.4\n                c0.2-0.4,0.2-0.9-0.2-1.2l-2-2c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.2-0.7,0.4l-3.9,5.9c-0.3,0.4-0.2,0.9,0.1,1.3\n                c0.2,0.2,0.4,0.3,0.7,0.3C132.3,56.4,132.5,56.3,132.6,56.2z M127.5,62.1c-2.1,1.4-3.7,1.4-5.6,1.5c-1,0-2,0-3,0.2\n                c-0.5,0.1-0.8,0.5-0.8,1c0,0.5,0.4,0.9,0.9,0.9l6.9,0.7c0,0,0.1,0,0.1,0c0.3,0,0.5-0.1,0.7-0.3c0.3-0.3,0.6-0.6,0.9-1\n                c1-1.1,1.8-2.2,3.6-2.8c0.4-0.1,0.7-0.5,0.6-1s-0.3-0.8-0.7-0.9c0,0,0,0-0.1,0c0.1-0.4,0.2-0.8,0.1-1.2c-0.1-0.3-0.3-0.8-0.9-1.1\n                c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.5,0.1-0.7,0.1c0.2-1,0.9-2.2,1.5-3.4l0.5-1c0.1-0.2,0.2-0.4,0.3-0.6c0.8-1.6,1.6-3.5,1.3-5.4\n                c-0.1-0.4-0.3-0.7-0.7-0.8c-0.4-0.1-0.8,0-1,0.3l-2.2,2.6c-0.2,0.3-0.3,0.6-0.2,0.9c0.1,0.3,0.3,0.6,0.6,0.7\n                c0.4,0.1,0.5,0.3,0.5,0.3c0,0,0,0.2-0.1,0.5l-0.2,0.4c-0.6,1-1.8,2.2-2.9,3.4c-1.3,1.4-2.7,2.9-3.4,4.1c-0.2,0.4-0.1,0.9,0.2,1.2\n                c0.3,0.3,0.8,0.3,1.2,0.1c1.1-0.8,2.1-1.1,3-1.2c0.2,0.3,0.4,0.6,0.7,0.8c0,0-0.1,0.1-0.1,0.1C127.9,61.5,127.7,61.8,127.5,62.1z\n                 M135.4,90.9l-1.6,6.2c-0.1,0.4,0,0.8,0.3,1c0.2,0.2,0.4,0.2,0.6,0.2c0.1,0,0.3,0,0.4-0.1c1.9-0.9,2-3.2,2.1-5.1\n                c0-0.7,0-1.3,0.1-1.8l0.1-0.5c0-0.1,0.1-0.2,0.1-0.2c0.7,0.3,1.3,0.4,1.9,0.3c0.3,1,1.2,1.8,2.6,2.5v-6c0,0-0.1,0.1-0.1,0.1\n                c-0.7,0.6-1.3,1.1-2,1.3c-0.4-0.2-0.9-0.3-1.2-0.3c0.2-0.7,0.4-1.4,0.7-2.1c0.5-0.6,0.9-1.4,1.2-2.1l0.1-0.3\n                c0.4-0.5,0.9-0.9,1.3-1.1v-2.6c-1.8,0.2-2.6,1.7-3,2.6c-0.5,0.7-0.9,1.4-1.3,2.4c-0.6,0.5-1.4,0.5-2.7,0c-0.3-0.1-0.6-0.1-0.9,0.1\n                c-0.3,0.2-0.4,0.5-0.4,0.8v1.9c0,0.5,0.3,0.9,0.8,1l1.3,0.2l-0.2,0.8C135.5,90.4,135.4,90.7,135.4,90.9z\"/>\n        </pattern>\n\n        <!-- <mask id=\"noise-mask\">\n            <rect height=\"100%\" width=\"100%\" fill=\"url(#noise-pattern)\" />\n        </mask> -->\n    </defs>\n</svg>";


var $2026db1aa7643d8b$exports = {};
$2026db1aa7643d8b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 144 144\" xml:space=\"preserve\">\n<defs>\n    <pattern id=\"dot-pattern\" width=\"142\" height=\"142\" patternUnits=\"userSpaceOnUse\">\n\t\t<path fill=\"#a179af\" d=\"M99.8,144L99.8,144l-3.7,0l0,0C97.1,143,98.8,143,99.8,144z M127.3,144h2.2C128.8,143.7,128,143.7,127.3,144z\n\t\t\t M144,10.3C144,10.3,144,10.3,144,10.3L144,10.3C144,10.3,144,10.3,144,10.3z M144,69.8v-3c-0.3,0.4-0.5,1-0.5,1.5\n\t\t\tC143.5,68.8,143.7,69.3,144,69.8z M144,52.8v-3c-0.3,0.4-0.5,1-0.5,1.5C143.5,51.8,143.7,52.3,144,52.8z M42.4,10.3\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C42.7,9,42.4,9.6,42.4,10.3z M27.6,16.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C25.2,13,25,13.6,25,14.3c0,0.7,0.3,1.4,0.8,1.8C26.2,16.6,26.9,16.9,27.6,16.9z M28.1,8.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC26.7,8.1,27.4,8.4,28.1,8.4z M32.2,12c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C34.9,11,33.2,11,32.2,12z M38.5,9.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC37.2,9.1,37.9,9.4,38.5,9.4z M48.5,7.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C47.2,7.6,47.9,7.9,48.5,7.9z M62,5.9c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC60.7,5.7,61.3,5.9,62,5.9z M54.7,7c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C57.4,6,55.7,6,54.7,7z M53.2,12.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C55.9,11.5,54.2,11.5,53.2,12.5z\n\t\t\t M49.2,18.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C51.9,17.5,50.2,17.5,49.2,18.5z M43,19.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC41.7,19.1,42.4,19.4,43,19.4z M40.7,25.6c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C39.9,24.5,40.2,25.2,40.7,25.6z M30.7,20\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C33.4,19,31.7,19,30.7,20z M37.2,26.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C39.9,25.5,38.2,25.5,37.2,26.5z\n\t\t\t M41.7,32.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C44.4,31.9,42.7,31.9,41.7,32.9z M47.7,35.5c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8\n\t\t\tC50.4,34.5,48.7,34.5,47.7,35.5z M53.7,32c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C56.4,31,54.6,31,53.7,32z M52.7,25.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C55.4,24.5,53.7,24.5,52.7,25.5z\n\t\t\t M56.7,21c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8C59.4,20,57.7,20,56.7,21z M65.2,21c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\ts1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C67.9,20,66.1,20,65.2,21z M65.3,30.5c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8S65.8,30.9,65.3,30.5z\n\t\t\t M66.2,37.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8C68.9,36.5,67.1,36.5,66.2,37.4z M58.4,39.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C58.7,38.4,58.4,39.1,58.4,39.8z M54,43.9\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C52.7,43.6,53.3,43.9,54,43.9z M71.2,32.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8S70.7,31.7,71.2,32.1z M60.7,14\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C63.4,13,61.7,13,60.7,14z M64.7,11.7c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C63.9,10.5,64.2,11.2,64.7,11.7z M72,5.4\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C70.6,5.2,71.3,5.4,72,5.4z M71.7,7.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C74.4,6.5,72.6,6.5,71.7,7.5z\n\t\t\t M71.2,13.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C73.9,12.5,72.1,12.5,71.2,13.5z M71.7,21c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8\n\t\t\tC74.4,20,72.6,20,71.7,21z M80.5,8.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C79.1,8.6,79.8,8.9,80.5,8.9z M80.1,12c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC82.9,11,81.1,11,80.1,12z M79.1,20c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C81.9,19,80.1,19,79.1,20z M79.6,29c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C82.4,28,80.6,28,79.6,29z M82.6,36\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C85.4,35,83.6,35,82.6,36z M73.2,35.5c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C75.9,34.5,74.1,34.5,73.2,35.5z M75.7,44.4\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C78.4,43.5,76.6,43.5,75.7,44.4z M67.2,43.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C69.9,43,68.1,43,67.2,43.9z M90.6,38.9\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C93.4,38,91.6,38,90.6,38.9z M88.6,32c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C91.4,31,89.6,31,88.6,32z M88.5,29.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC87.1,29.1,87.8,29.4,88.5,29.4z M87.1,17c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C89.9,16,88.1,16,87.1,17z M86.6,8.5\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C89.3,7.5,87.6,7.5,86.6,8.5z M88,6.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C86.6,6.2,87.3,6.4,88,6.4z M98,4.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8h-3.7c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C96.6,4.2,97.3,4.4,98,4.4z\n\t\t\t M96.5,12.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C95.1,12.6,95.8,12.9,96.5,12.9z M103.5,12.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C102.1,12.6,102.8,12.9,103.5,12.9z\n\t\t\t M103,19.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C101.6,19.6,102.3,19.9,103,19.9z M95.5,19.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C94.1,19.1,94.8,19.4,95.5,19.4z M94.1,24\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C96.8,23,95.1,23,94.1,24z M101.1,27.6c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C100.4,26.5,100.6,27.2,101.1,27.6z\n\t\t\t M95.6,31c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C98.3,30,96.6,30,95.6,31z M97.9,41.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C98.1,39.9,97.9,40.6,97.9,41.3z M102.1,45.9\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C104.8,45,103.1,45,102.1,45.9z M107.1,40.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C109.8,39.5,108.1,39.5,107.1,40.4z\n\t\t\t M104.1,33.5c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C106.8,32.5,105.1,32.5,104.1,33.5z M108.6,31.1c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8S108.1,30.7,108.6,31.1z M110.9,23.4c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC109.6,23.1,110.3,23.4,110.9,23.4z M115.3,12.8c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C115.6,11.5,115.3,12.1,115.3,12.8z M121.9,8.4\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C120.6,8.1,121.3,8.4,121.9,8.4z M128.4,4.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-0.2-0.2-0.5-0.4-0.8-0.5h-2.2c-0.3,0.1-0.5,0.3-0.8,0.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC127.1,4.7,127.7,4.9,128.4,4.9z M129.8,6.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-0.9-1-2.7-1-3.7,0C130.1,5,129.8,5.7,129.8,6.3z M122.8,12.3\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-0.9-1-2.7-1-3.7,0C123.1,11,122.8,11.6,122.8,12.3z M123.9,22.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C122.6,22.1,123.3,22.4,123.9,22.4z\n\t\t\t M116.6,22.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C119.3,21.5,117.6,21.5,116.6,22.5z M121.6,31.6c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8S121.1,31.2,121.6,31.6\n\t\t\tz M133.5,31.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C133.2,33.2,133.5,32.5,133.5,31.8z M124.3,36.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C124.6,34.9,124.3,35.6,124.3,36.3z M118.1,35.5\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C120.8,34.5,119.1,34.5,118.1,35.5z M112.6,34.5c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C115.3,33.5,113.6,33.5,112.6,34.5z M115.3,44.8\n\t\t\tc0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C115.6,43.4,115.3,44.1,115.3,44.8z M126.9,44.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C125.6,44.6,126.2,44.9,126.9,44.9z\n\t\t\t M138,44.3c0-0.7-0.3-1.4-0.8-1.8c-0.9-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C137.7,45.6,138,45,138,44.3z M137.3,35.5c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8S137.7,35.9,137.3,35.5z M126.8,23.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC127.1,22.4,126.8,23.1,126.8,23.8z M129.1,14.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C131.8,13.5,130.1,13.5,129.1,14.5z M137.9,14.9\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C136.6,14.6,137.2,14.9,137.9,14.9z M139.9,5.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8C138.6,5.2,139.2,5.4,139.9,5.4z\n\t\t\t M137.9,27.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C136.6,27.6,137.2,27.9,137.9,27.9z M139.6,30.5c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8v0c0-0.7-0.3-1.3-0.8-1.8C142.3,29.5,140.5,29.5,139.6,30.5\n\t\t\tz M108.8,10.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C109.1,9.5,108.8,10.1,108.8,10.8z M114.4,6.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C113.1,6.2,113.8,6.4,114.4,6.4z\n\t\t\t M106.5,7.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C105.1,7.6,105.8,7.9,106.5,7.9z M44.7,42.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C47.4,41.5,45.7,41.5,44.7,42.4z\n\t\t\t M36.7,40.6c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8C35.9,39.5,36.2,40.1,36.7,40.6z M32.6,35.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C31.2,35.1,31.9,35.4,32.6,35.4z M26.2,25\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8C28.9,24,27.2,24,26.2,25z M21.7,19.5C21.2,20,21,20.6,21,21.3c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C24.4,18.5,22.7,18.5,21.7,19.5z M28,40.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C28.2,39.4,28,40.1,28,40.8z M33.7,43.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C36.4,42.5,34.7,42.5,33.7,43.4z M24.7,46.4\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C27.4,45.5,25.7,45.5,24.7,46.4z M19,42.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0C19.2,40.9,19,41.6,19,42.3z M44.7,27.5c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tC47.4,26.5,45.7,26.5,44.7,27.5z M2.6,12.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC0.3,9,0,9.6,0,10.3v0.1c0,0.7,0.3,1.3,0.8,1.8C1.2,12.6,1.9,12.9,2.6,12.9z M2.5,29.3c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC2.8,27.9,2.5,28.6,2.5,29.3z M9.1,38.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C7.7,38.1,8.4,38.4,9.1,38.4z M4.3,20.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C6.9,19.5,5.2,19.5,4.3,20.5z\n\t\t\t M14.7,6C14.3,6.5,14,7.1,14,7.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C17.5,5,15.7,5,14.7,6z M7.5,8.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C7.8,7.5,7.5,8.1,7.5,8.8z M8.7,13.5C8.3,14,8,14.6,8,15.3\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8\n\t\t\tC11.5,12.5,9.7,12.5,8.7,13.5z M18.2,12c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C20.9,11,19.2,11,18.2,12z M6.1,5.9c0.7,0,1.4-0.3,1.8-0.8C8.4,4.7,8.7,4,8.7,3.3\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C3.8,2,3.5,2.7,3.5,3.3c0,0.7,0.3,1.4,0.8,1.8C4.7,5.7,5.4,5.9,6.1,5.9z M10.7,23\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8C13.5,22,11.7,22,10.7,23z M15.5,20.3c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C15.8,19,15.5,19.6,15.5,20.3z M16.2,30.1c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\ts1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tC15.5,29,15.8,29.6,16.2,30.1z M21.7,32c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C24.4,31,22.7,31,21.7,32z M13.2,35.5c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8C16,34.5,14.2,34.5,13.2,35.5z M8.2,46.4\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C11,45.5,9.2,45.5,8.2,46.4z M6.7,44.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0C6.3,40.9,6,41.6,6,42.3C6,43,6.3,43.6,6.7,44.1z M31.2,139.7\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C30.9,141,31.2,140.3,31.2,139.7z M33.7,135.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C36.4,134.9,34.7,134.9,33.7,135.8z\n\t\t\t M44.7,137.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C47.4,136.9,45.7,136.9,44.7,137.8z M55.2,136.8c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC57.9,135.9,56.2,135.9,55.2,136.8z M62.2,137.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\ts1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C64.9,136.9,63.2,136.9,62.2,137.8z M72.2,136.8\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C74.9,135.9,73.1,135.9,72.2,136.8z M90.3,135c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C89.2,135.8,89.8,135.5,90.3,135z M96.1,134.8\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C98.8,133.9,97.1,133.9,96.1,134.8z M116.1,137.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC118.8,136.8,117.1,136.9,116.1,137.8z M132.1,139.3c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C134.8,138.4,133,138.4,132.1,139.3z M107.8,137.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C106.6,138.3,107.3,138,107.8,137.5z M20.4,137.2c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8S20.9,137.7,20.4,137.2z M12.7,138.2\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C12.4,139.5,12.7,138.8,12.7,138.2z M39.9,49.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C40.2,48.4,39.9,49.1,39.9,49.8z M48.9,51.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C49.2,50.4,48.9,51.1,48.9,51.8z M56.4,47.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C56.7,46.4,56.4,47.1,56.4,47.8z M58.4,57.6\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C57.2,58.4,57.9,58.1,58.4,57.6z M49.2,61.6c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C48.4,60.4,48.7,61.1,49.2,61.6z\n\t\t\t M42.2,56.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C44.9,55.4,43.2,55.5,42.2,56.4z M35.7,57.9c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC38.4,56.9,36.7,57,35.7,57.9z M32.7,50.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C35.4,49.5,33.7,49.5,32.7,50.4z M32.4,59.1\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C31.3,59.9,31.9,59.6,32.4,59.1z M24.1,57.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C22.7,57.1,23.4,57.4,24.1,57.4z\n\t\t\t M15.7,59.6c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8C15,58.4,15.3,59.1,15.7,59.6z M13,64.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C13.3,62.9,13,63.6,13,64.3z M23.6,70.3\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C22.2,70.1,22.9,70.3,23.6,70.3z M29.1,65.4c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C27.7,65.1,28.4,65.4,29.1,65.4z\n\t\t\t M34.7,65.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C37.4,64.5,35.7,64.5,34.7,65.4z M30.6,74.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC29.2,74.6,29.9,74.8,30.6,74.8z M24.6,80.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C23.2,80.1,23.9,80.3,24.6,80.3z M16.2,79.4c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.3,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C19,78.4,17.2,78.4,16.2,79.4z M20.4,70.9\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C21.2,72.1,20.9,71.4,20.4,70.9z M10.2,73.9c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C13,72.9,11.2,72.9,10.2,73.9z M10.1,69.3\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C8.7,69.1,9.4,69.3,10.1,69.3z M9.6,58.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C7.3,54.9,7,55.6,7,56.3c0,0.7,0.3,1.4,0.8,1.8C8.2,58.6,8.9,58.9,9.6,58.9z M1.8,58.4\n\t\t\tC1.3,58.9,1,59.6,1,60.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8C4.5,57.5,2.7,57.5,1.8,58.4z M2.1,70.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.1,0.1-0.2,0.2-0.3,0.3v3c0.1,0.1,0.2,0.2,0.3,0.3C0.8,70.6,1.4,70.8,2.1,70.8z\n\t\t\t M2.1,53.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.1,0.1-0.2,0.2-0.3,0.3v3\n\t\t\tc0.1,0.1,0.2,0.2,0.3,0.3C0.8,53.6,1.4,53.9,2.1,53.9z M2.8,73.4C2.3,73.9,2,74.6,2,75.2s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C5.5,72.4,3.7,72.4,2.8,73.4z M5.6,85.3c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C3.3,81.4,3,82,3,82.7c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC4.3,85,4.9,85.3,5.6,85.3z M1.5,94.7c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C1.8,93.4,1.5,94,1.5,94.7z M6.1,103.3c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC4.7,103,5.4,103.3,6.1,103.3z M11.2,94.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C14,93.9,12.2,93.9,11.2,94.9z M7,88.7c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC7.3,87.4,7,88,7,88.7z M20.2,89.7c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0C15.3,88.4,15,89,15,89.7c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C19.9,91.1,20.2,90.4,20.2,89.7z M22.6,98.3c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0C20.2,94.4,20,95,20,95.7c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC21.2,98,21.9,98.3,22.6,98.3z M28.6,100.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC26.2,96.3,26,97,26,97.7c0,0.7,0.3,1.4,0.8,1.8C27.2,100,27.9,100.3,28.6,100.3z M34.1,103.3c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC32.7,103,33.4,103.3,34.1,103.3z M26.2,87.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8C25.9,88.6,26.2,87.9,26.2,87.2z M33.2,89.7c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C28.2,88.4,28,89,28,89.7c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tC32.9,91.1,33.2,90.4,33.2,89.7z M38.9,89.9c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C39.6,91,39.4,90.4,38.9,89.9z M31.1,83.3\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tC29.7,83,30.4,83.3,31.1,83.3z M40.9,80.9c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C41.6,82,41.4,81.4,40.9,80.9z M43.1,74.2\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tC42.9,75.6,43.1,74.9,43.1,74.2z M48.1,80.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C47.9,81.6,48.1,80.9,48.1,80.2z M49.2,77.1c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8S48.7,76.6,49.2,77.1z\n\t\t\t M45.4,86.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C46.1,87.5,45.9,86.9,45.4,86.4z M52.4,90.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C53.1,91.5,52.8,90.9,52.4,90.4z\n\t\t\t M52.4,98.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C53.1,99.5,52.8,98.8,52.4,98.4z M40.7,94.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C43.4,93.9,41.7,93.9,40.7,94.9z\n\t\t\t M57.5,96.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C56.2,96.5,56.8,96.8,57.5,96.8z M57.2,77.9c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C59.9,76.9,58.2,76.9,57.2,77.9z\n\t\t\t M60.9,69.9c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C61.6,71.1,61.3,70.4,60.9,69.9z M55.1,68.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C54.8,69.6,55.1,68.9,55.1,68.2z\n\t\t\t M45.5,70.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C44.2,70.6,44.9,70.8,45.5,70.8z M58.5,63.9c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C57.2,63.6,57.8,63.9,58.5,63.9z\n\t\t\t M63.7,73.9c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C66.4,72.9,64.6,72.9,63.7,73.9z M64.9,83.2c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C65.2,81.9,64.9,82.5,64.9,83.2z M63.4,89.6\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C62.2,90.3,62.9,90,63.4,89.6z M69.8,88.9c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C70.6,90,70.3,89.4,69.8,88.9z M74,101.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C72.6,101.5,73.3,101.8,74,101.8z M66.6,97.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8C66.3,98.5,66.6,97.9,66.6,97.2z\n\t\t\t M75.5,93.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C74.2,93.5,74.8,93.8,75.5,93.8z M76.8,84.1c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C75.7,84.8,76.4,84.5,76.8,84.1z M73.5,77.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tC72.2,77.6,72.8,77.8,73.5,77.8z M62.7,68.6c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C61.9,67.4,62.2,68.1,62.7,68.6z M73.1,67.7\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tC72.8,69.1,73.1,68.4,73.1,67.7z M67.8,58.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C68.6,59.6,68.3,58.9,67.8,58.4z M66.8,54.1\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C65.7,54.9,66.4,54.6,66.8,54.1z M70.7,50.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C73.4,50,71.6,50,70.7,50.9z\n\t\t\t M72.2,59.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C74.9,59,73.1,58.9,72.2,59.9z M80.3,70.1c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tC79.2,70.8,79.8,70.6,80.3,70.1z M87.1,73.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C86.8,74.6,87.1,73.9,87.1,73.2z M81.6,78.9\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C84.4,77.9,82.6,77.9,81.6,78.9z M82,90.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C80.6,90.5,81.3,90.8,82,90.8z M86,97.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC84.6,97.5,85.3,97.8,86,97.8z M92,91.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C90.6,91.5,91.3,91.8,92,91.8z M92,100.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC90.6,100.5,91.3,100.8,92,100.8z M91.5,82.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C90.1,82,90.8,82.3,91.5,82.3z M96.6,73.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C96.3,75.1,96.6,74.4,96.6,73.7z\n\t\t\t M90.1,65.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.3-0.3,1.8-0.8C89.8,67.1,90.1,66.4,90.1,65.8z M80.1,60.5c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C82.9,59.5,81.1,59.5,80.1,60.5z\n\t\t\t M78.2,54.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C80.9,53.5,79.1,53.4,78.2,54.4z M84.6,50.4c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC87.4,49.5,85.6,49.5,84.6,50.4z M86.3,46.1c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C85.2,46.9,85.8,46.6,86.3,46.1z M95.8,47.9\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C96.6,49.1,96.3,48.4,95.8,47.9z M88.9,58.3c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0C89.2,56.9,88.9,57.6,88.9,58.3z M98.1,64.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C97.8,66.1,98.1,65.4,98.1,64.8z M102,72.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8C100.6,72.1,101.3,72.3,102,72.3z\n\t\t\t M104.1,77.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C103.8,79.1,104.1,78.4,104.1,77.7z M102.1,85.7c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C101.8,87.1,102.1,86.4,102.1,85.7z\n\t\t\t M108.8,82.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C109.5,83.5,109.3,82.9,108.8,82.4z M104.6,91.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C107.3,90.4,105.6,90.4,104.6,91.4z\n\t\t\t M111.9,101.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C110.6,101.5,111.3,101.8,111.9,101.8z M111.6,80.4c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C114.3,79.4,112.6,79.4,111.6,80.4z\n\t\t\t M111.4,76.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8C110.1,76.6,110.8,76.8,111.4,76.8z M55.6,84.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C55.3,85.6,55.6,84.9,55.6,84.2z M140.7,64.6\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C139.6,65.4,140.3,65.1,140.7,64.6z M143.5,54.3c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C143.2,55.6,143.5,54.9,143.5,54.3z\n\t\t\t M136.3,48.9c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C137,50.1,136.7,49.4,136.3,48.9z M136.8,67.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C137.5,68.6,137.2,67.9,136.8,67.4z\n\t\t\t M132.6,74.9c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C135.3,73.9,133.6,73.9,132.6,74.9z M139.6,72.4c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8v0c0-0.7-0.3-1.3-0.8-1.8C142.3,71.4,140.5,71.4,139.6,72.4\n\t\t\tz M142.5,82.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C142.2,83.6,142.5,82.9,142.5,82.2z M140.2,95.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C141,96.5,140.7,95.9,140.2,95.4z\n\t\t\t M138.2,92.1c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C137.1,92.8,137.8,92.5,138.2,92.1z M129.6,60.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C128.8,58.9,129.1,59.6,129.6,60.1z\n\t\t\t M121.8,58.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C122.1,57.4,121.8,58.1,121.8,58.8z M124.6,51.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C123.8,50,124.1,50.6,124.6,51.1z\n\t\t\t M121.3,50.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8C122,51.6,121.8,50.9,121.3,50.4z M110.1,48.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.1,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C112.8,47.5,111.1,47.5,110.1,48.4z\n\t\t\t M107.6,53.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C107.3,55.1,107.6,54.4,107.6,53.8z M100.8,57.6c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C99.6,58.4,100.3,58.1,100.8,57.6z\n\t\t\t M101.6,61.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C104.3,60.5,102.6,60.5,101.6,61.4z M113.8,60.1c0.5-0.5,0.8-1.1,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tS113.3,60.6,113.8,60.1z M116.1,66.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C115.3,64.9,115.6,65.6,116.1,66.1z M107.9,67.2c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tC108.1,65.9,107.9,66.6,107.9,67.2z M121,72.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C120.8,74.1,121,73.4,121,72.7z M127.4,68.3\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C126.1,68.1,126.7,68.3,127.4,68.3z M125.1,74.1c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C124.3,72.9,124.6,73.6,125.1,74.1z\n\t\t\t M121.4,83.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8C120.1,83,120.8,83.3,121.4,83.3z M123.9,91.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C122.6,91,123.3,91.3,123.9,91.3z\n\t\t\t M111.6,87.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C114.3,86.9,112.6,86.9,111.6,87.9z M120.8,96c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C119.6,96.8,120.3,96.5,120.8,96z\n\t\t\t M128.1,92.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C130.8,91.9,129.1,91.9,128.1,92.9z M127.6,81.4c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC130.3,80.4,128.6,80.4,127.6,81.4z M100.3,92.4c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C101.1,93.5,100.8,92.9,100.3,92.4z M123.8,103.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C122.6,104.3,123.3,104,123.8,103.5z M12.1,116.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C10.7,116,11.4,116.3,12.1,116.3z\n\t\t\t M16.7,104.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C16.4,106.1,16.7,105.4,16.7,104.7z M23.2,102.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8C22.9,103.6,23.2,102.9,23.2,102.2z\n\t\t\t M18.6,112.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C17.2,112.5,17.9,112.8,18.6,112.8z M27.4,112.3c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C28.2,113.5,27.9,112.8,27.4,112.3z\n\t\t\t M23.7,120.3c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C26.4,119.4,24.7,119.4,23.7,120.3z M17.6,121.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C16.2,121,16.9,121.3,17.6,121.3z M32.6,118.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC31.2,118.5,31.9,118.8,32.6,118.8z M33.1,124.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C31.7,124.5,32.4,124.8,33.1,124.8z M44.4,107c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tC43.2,107.8,43.9,107.5,44.4,107z M36.5,112.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C35.2,112,35.9,112.3,36.5,112.3z M43,115.3\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C41.7,115,42.4,115.3,43,115.3z M49,123.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C47.7,123.5,48.4,123.8,49,123.8z M40.9,121c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tC39.7,121.8,40.4,121.5,40.9,121z M50.5,117.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C49.2,117.5,49.8,117.8,50.5,117.8z M51.9,108\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C50.7,108.8,51.4,108.5,51.9,108z M58.5,105.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C57.2,105,57.8,105.3,58.5,105.3z\n\t\t\t M57,111.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C55.7,111,56.3,111.3,57,111.3z M61.4,114.3c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C62.1,115.5,61.8,114.8,61.4,114.3z\n\t\t\t M65.2,109.4c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C67.9,108.4,66.1,108.4,65.2,109.4z M66.5,124.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C65.1,124.5,65.8,124.8,66.5,124.8z M67.5,106.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C66.2,106.5,66.8,106.8,67.5,106.8z M74.5,110.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C73.2,110,73.8,110.3,74.5,110.3z\n\t\t\t M30.7,106.2c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C30.4,107.6,30.7,106.9,30.7,106.2z M74.3,117.5c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C73.2,118.3,73.9,118,74.3,117.5z\n\t\t\t M7.4,124.8c-1-1-2.7-1-3.7,0C3.3,125.3,3,126,3,126.7s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8S7.9,125.3,7.4,124.8z M1.8,132.8C1.3,133.3,1,134,1,134.7c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C4.5,131.9,2.7,131.9,1.8,132.8z M19.6,131.4\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.3-0.8-1.8C22.3,130.4,20.6,130.4,19.6,131.4z M19.1,128.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C17.7,128.5,18.4,128.8,19.1,128.8z M29.4,131.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tC28.3,132.3,28.9,132,29.4,131.5z M35,131.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C33.7,131,34.4,131.3,35,131.3z M43.5,129.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC42.2,129.5,42.9,129.8,43.5,129.8z M43.9,131.3c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8S44.4,131.8,43.9,131.3z M53.9,137.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C52.7,138.3,53.4,138,53.9,137.5z M52.5,131.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C51.2,131,51.8,131.3,52.5,131.3z M63.1,133.7\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tC62.8,135,63.1,134.3,63.1,133.7z M65.2,128.8c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8s1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C67.9,127.9,66.1,127.8,65.2,128.8z M13.1,133.3c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tC11.7,133,12.4,133.3,13.1,133.3z M84.1,100.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C83.8,102.1,84.1,101.4,84.1,100.7z M90.1,105.2\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C89.8,106.6,90.1,105.9,90.1,105.2z M98.8,105c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C97.7,105.8,98.3,105.5,98.8,105z\n\t\t\t M98.5,115.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C97.1,115,97.8,115.3,98.5,115.3z M90.6,116.3c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C93.4,115.4,91.6,115.4,90.6,116.3z\n\t\t\t M84.1,119.8c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C86.9,118.9,85.1,118.9,84.1,119.8z M88.3,111.3c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8C89.1,112.5,88.8,111.8,88.3,111.3z M80.1,126.3\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C82.9,125.4,81.1,125.4,80.1,126.3z M89.6,125.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C92.4,124.9,90.6,124.9,89.6,125.8z\n\t\t\t M96.6,128.3c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.3-0.8-1.8C99.3,127.4,97.6,127.3,96.6,128.3z M97.1,119.3c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C99.8,118.4,98.1,118.4,97.1,119.3z\n\t\t\t M2.5,118.2c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0C2.8,116.8,2.5,117.5,2.5,118.2z M4.3,110.5c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8C3.5,109.4,3.8,110.1,4.3,110.5z\n\t\t\t M136.6,132.3c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C139.3,131.4,137.5,131.4,136.6,132.3z M133.8,133c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C132.6,133.8,133.3,133.5,133.8,133z M141.3,129.2\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0,0,0.1,0,0.1,0v-5.1c-0.7,0-1.4,0.2-1.9,0.7C141.6,127.8,141.3,128.5,141.3,129.2z\n\t\t\t M136.9,116.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-0.9-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C135.6,116.5,136.2,116.8,136.9,116.8z M137.4,106.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C136.1,106,136.7,106.3,137.4,106.3z\n\t\t\t M140.4,124.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8C139,124,139.7,124.3,140.4,124.3z M75.2,124.5c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8S74.7,124,75.2,124.5z M72.2,126.8\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\ts-0.3-1.4-0.8-1.8C74.9,125.9,73.1,125.8,72.2,126.8z M105.5,128.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C104.1,128.5,104.8,128.8,105.5,128.8z M115.3,127.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tS114.8,128,115.3,127.5z M106.3,119c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8C105.2,119.8,105.8,119.5,106.3,119z M110.4,120.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tC109.1,120.5,109.8,120.8,110.4,120.8z M106,111.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C104.6,111.5,105.3,111.8,106,111.8z M115.8,114\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8S115.3,114.5,115.8,114z M118.4,121.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C117.1,121,117.8,121.3,118.4,121.3z M124.3,125\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tC123.1,125.8,123.8,125.5,124.3,125z M126,131.2c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8C125.7,132.5,126,131.8,126,131.2z M127.4,118.8c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC126.1,118.5,126.7,118.8,127.4,118.8z M123.9,113.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.3,0.8,1.8C122.6,113.5,123.3,113.8,123.9,113.8z M115.4,107.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C114.1,107.5,114.8,107.8,115.4,107.8z M131.4,111.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C130.1,111,130.7,111.3,131.4,111.3z\n\t\t\t M131.9,125.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8C130.6,125.5,131.2,125.8,131.9,125.8z M105.5,104.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C104.1,104.5,104.8,104.8,105.5,104.8z\n\t\t\t M117.5,132.7c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C117.3,134,117.5,133.3,117.5,132.7z M125.1,134.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C127.8,133.9,126,133.9,125.1,134.8z\n\t\t\t M128.9,104.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8C127.6,104,128.2,104.3,128.9,104.3z M15.7,46.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C18.5,46,16.7,46,15.7,46.9z\n\t\t\t M10.1,124.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.3-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8\n\t\t\ts0.3,1.4,0.8,1.8C8.7,124,9.4,124.3,10.1,124.3z M57.2,121.8c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8C59.9,120.9,58.1,120.9,57.2,121.8z M82.1,112.7\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8C81.8,114,82.1,113.4,82.1,112.7z M93,112.3c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8C91.6,112,92.3,112.3,93,112.3z\n\t\t\t M78.7,139.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.2,0.2,0.5,0.4,0.8,0.5h2.1c0.3-0.1,0.5-0.3,0.8-0.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C81.4,138.9,79.6,138.9,78.7,139.8z M20.7,144h2.6C22.5,143.6,21.5,143.6,20.7,144z\n\t\t\t M39.2,141.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.1,0,0.2,0,0.4h5.1c0-0.1,0-0.2,0-0.4c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC41.9,140.8,40.2,140.8,39.2,141.8z M30.7,143.3c-0.2,0.2-0.4,0.4-0.5,0.7h4.6c-0.1-0.3-0.3-0.5-0.5-0.7\n\t\t\tC33.4,142.3,31.7,142.3,30.7,143.3z M52.2,143.3c-0.2,0.2-0.4,0.4-0.5,0.7h4.6c-0.1-0.3-0.3-0.5-0.5-0.7\n\t\t\tC54.9,142.3,53.2,142.3,52.2,143.3z M12.2,142.3c-0.4,0.4-0.7,1.1-0.7,1.7h5.2c0-0.6-0.3-1.2-0.7-1.7\n\t\t\tC15,141.3,13.2,141.3,12.2,142.3z M106.6,141.3c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.3,0.1,0.6,0.2,0.9h4.9c0.1-0.3,0.2-0.6,0.2-0.9\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C109.3,140.3,107.6,140.3,106.6,141.3z M141.6,15c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.2,0,0.4,0,0.6-0.1v-5C143.1,14.1,142.2,14.3,141.6,15z M141.3,23.3c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0,0,0.1,0,0.1,0v-5.1c-0.7,0-1.4,0.2-1.9,0.7C141.6,21.9,141.3,22.6,141.3,23.3z M141.8,37.8\n\t\t\tc0,0.7,0.3,1.4,0.8,1.8c0.4,0.4,0.9,0.6,1.4,0.7v-5.1c-0.5,0.1-1,0.3-1.4,0.7C142.1,36.4,141.8,37.1,141.8,37.8z M141.1,42.4\n\t\t\tc-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0.4,0,0.8-0.1,1.1-0.3V42C143,41.5,141.8,41.7,141.1,42.4\n\t\t\tz M141.3,140.2c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8c0,0,0.1,0,0.1,0v-5.1c-0.7,0-1.4,0.2-1.9,0.7\n\t\t\tC141.6,138.8,141.3,139.5,141.3,140.2z M142.3,89.2c0,0.7,0.3,1.4,0.8,1.8c0.3,0.3,0.6,0.5,0.9,0.6v-4.8c-0.3,0.1-0.7,0.3-0.9,0.6\n\t\t\tC142.6,87.9,142.3,88.5,142.3,89.2z M141.1,108.9c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8\n\t\t\tc0.4,0,0.8-0.1,1.1-0.3v-4.7C143,107.9,141.8,108.1,141.1,108.9z M142.3,102.7c0,0.7,0.3,1.4,0.8,1.8c0.3,0.3,0.6,0.5,0.9,0.6v-4.8\n\t\t\tc-0.3,0.1-0.7,0.3-0.9,0.6C142.6,101.3,142.3,102,142.3,102.7z M89.1,137.8c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.3-0.8-1.8C91.8,136.9,90.1,136.9,89.1,137.8z\n\t\t\t M81.3,136.5c0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8c-1-1-2.7-1-3.7,0c-0.5,0.5-0.8,1.2-0.8,1.8c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tc0.5,0.5,1.2,0.8,1.8,0.8C80.2,137.3,80.8,137,81.3,136.5z M0,32.3L0,32.3C0,32.3,0,32.3,0,32.3C0,32.3,0,32.3,0,32.3z M0,74.2\n\t\t\tL0,74.2C0,74.3,0,74.2,0,74.2C0,74.2,0,74.2,0,74.2z M2.5,129.2c0-0.7-0.3-1.4-0.8-1.8c-0.5-0.5-1.1-0.7-1.7-0.7v5.1\n\t\t\tc0.6,0,1.3-0.3,1.7-0.7C2.2,130.5,2.5,129.8,2.5,129.2z M2,16.8c0-0.7-0.3-1.4-0.8-1.8c-0.3-0.3-0.8-0.6-1.2-0.7v5\n\t\t\tc0.5-0.1,0.9-0.3,1.2-0.7C1.7,18.2,2,17.5,2,16.8z M2.5,23.3c0-0.7-0.3-1.4-0.8-1.8C1.3,21,0.6,20.8,0,20.8v5.1\n\t\t\tc0.6,0,1.3-0.3,1.7-0.7C2.2,24.7,2.5,24,2.5,23.3z M2.2,39.6C2.7,39.1,3,38.5,3,37.8c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tc-0.6-0.6-1.4-0.8-2.2-0.7v5.1c0.1,0,0.3,0,0.4,0C1.1,40.4,1.8,40.1,2.2,39.6z M1.5,44.3c0-0.7-0.3-1.4-0.8-1.8\n\t\t\tC0.5,42.2,0.3,42.1,0,42v4.7c0.3-0.1,0.5-0.3,0.7-0.5C1.2,45.6,1.5,45,1.5,44.3z M0,137.6v5.1c0.6,0,1.3-0.3,1.7-0.7\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C1.3,137.8,0.6,137.6,0,137.6z M2.7,91.1c0.5-0.5,0.8-1.2,0.8-1.8\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8C2,86.7,0.9,86.5,0,86.8v4.8c0.3,0.1,0.6,0.2,0.9,0.2C1.6,91.8,2.3,91.5,2.7,91.1z M1.5,110.7\n\t\t\tc0-0.7-0.3-1.4-0.8-1.8c-0.2-0.2-0.5-0.4-0.7-0.5v4.7c0.3-0.1,0.5-0.3,0.7-0.5C1.2,112,1.5,111.4,1.5,110.7z M2.7,104.5\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0-0.7-0.3-1.4-0.8-1.8C2,100.2,0.9,100,0,100.3v4.8c0.3,0.1,0.6,0.2,0.9,0.2C1.6,105.3,2.3,105,2.7,104.5z\n\t\t\t M81.6,0h-2.1c0.3,0.2,0.7,0.2,1.1,0.2S81.2,0.2,81.6,0z M22,4.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8\n\t\t\tc-0.2-0.2-0.3-0.3-0.5-0.4h-2.6c-0.2,0.1-0.4,0.2-0.5,0.4c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8C20.6,4.5,21.3,4.8,22,4.8z\n\t\t\t M41,2.2c0.7,0,1.4-0.3,1.8-0.8c0.4-0.4,0.6-0.9,0.7-1.5h-5.1c0.1,0.6,0.3,1.1,0.7,1.5C39.7,2,40.4,2.2,41,2.2z M32.6,3.7\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.4-0.1-0.8-0.3-1.1h-4.6C30.1,0.4,30,0.7,30,1.1c0,0.7,0.3,1.4,0.8,1.8\n\t\t\tC31.2,3.5,31.9,3.7,32.6,3.7z M54,3.7c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8c0-0.4-0.1-0.8-0.3-1.1h-4.6\n\t\t\tc-0.2,0.4-0.3,0.7-0.3,1.1c0,0.7,0.3,1.4,0.8,1.8C52.7,3.5,53.3,3.7,54,3.7z M14.1,2.7c0.7,0,1.4-0.3,1.8-0.8\n\t\t\tc0.5-0.5,0.8-1.2,0.8-1.8c0,0,0-0.1,0-0.1h-5.2c0,0,0,0.1,0,0.1c0,0.7,0.3,1.4,0.8,1.8C12.7,2.5,13.4,2.7,14.1,2.7z M108.5,1.7\n\t\t\tc0.7,0,1.4-0.3,1.8-0.8c0.3-0.3,0.5-0.6,0.6-1H106c0.1,0.4,0.3,0.7,0.6,1C107.1,1.5,107.8,1.7,108.5,1.7z\"/>\n\t\t</pattern>\n\t</defs>\n</svg>";


class $129944502fcf86f8$export$2e2bcd8739ae039 extends (0, $boE4X.Component) {
    render() {
        return /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
            className: $bc18a1f895064cb1$export$e8e78c978b129247,
            children: [
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $64c8ff15758d9290$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $da55d66015a96d15$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $2e49560d8b40682c$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $356da75698e1cc20$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $6521a12f95522307$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $e53dca0634bbcc4b$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                    className: "visually-hidden",
                    children: [
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($d676c325218912f2$exports)))
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($2026db1aa7643d8b$exports)))
                        })
                    ]
                })
            ]
        });
    }
}



parcelRequire("boE4X");
var $f4dc199977ac4867$export$e8e78c978b129247;
$f4dc199977ac4867$export$e8e78c978b129247 = `cG87DG_root`;


function $cd21475d315d2010$export$2e2bcd8739ae039(props) {
    const Element = props.el;
    const className = `svg-container ${$f4dc199977ac4867$export$e8e78c978b129247}` + (props.className ? ` ${props.className}` : "");
    return /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)(Element, {
        style: props.style,
        className: className,
        dangerouslySetInnerHTML: {
            __html: props.svg
        }
    });
}
$cd21475d315d2010$export$2e2bcd8739ae039.defaultProps = {
    el: "span"
};




var $boE4X = parcelRequire("boE4X");


var $97298b71fd48c7ca$export$28ee4a8d3e114531;
var $97298b71fd48c7ca$export$9e8683ef47fbbcb9;
var $97298b71fd48c7ca$export$5913546000bd8f0d;
var $97298b71fd48c7ca$export$e8e78c978b129247;
var $97298b71fd48c7ca$export$c12064b3701ae903;
var $97298b71fd48c7ca$export$7617e27f7bdf4181;
var $97298b71fd48c7ca$export$4ed94178d58f2369;
var $97298b71fd48c7ca$export$a66c2d07ca5eabd8;
var $97298b71fd48c7ca$export$dd4f28cef696bc7d;
var $97298b71fd48c7ca$export$9eed783d03e0135c;
var $97298b71fd48c7ca$export$afb5242d61ffc89f;
var $97298b71fd48c7ca$export$4a534d40fa9eb046;
var $97298b71fd48c7ca$export$afd578b46d110f40;
var $97298b71fd48c7ca$export$e98eeeacc5b03201;
$97298b71fd48c7ca$export$28ee4a8d3e114531 = `IkNVAG_hemi`;
$97298b71fd48c7ca$export$9e8683ef47fbbcb9 = `IkNVAG_hemiLeft`;
$97298b71fd48c7ca$export$5913546000bd8f0d = `IkNVAG_hemiRight`;
$97298b71fd48c7ca$export$e8e78c978b129247 = `IkNVAG_root`;
$97298b71fd48c7ca$export$c12064b3701ae903 = `IkNVAG_shapeCluster01`;
$97298b71fd48c7ca$export$7617e27f7bdf4181 = `IkNVAG_shapeCluster02`;
$97298b71fd48c7ca$export$4ed94178d58f2369 = `IkNVAG_shapeCluster03`;
$97298b71fd48c7ca$export$a66c2d07ca5eabd8 = `IkNVAG_shapeCluster04`;
$97298b71fd48c7ca$export$dd4f28cef696bc7d = `IkNVAG_square`;
$97298b71fd48c7ca$export$9eed783d03e0135c = `IkNVAG_triangle`;
$97298b71fd48c7ca$export$afb5242d61ffc89f = `IkNVAG_triangleBig`;
$97298b71fd48c7ca$export$4a534d40fa9eb046 = `IkNVAG_triangleBottom`;
$97298b71fd48c7ca$export$afd578b46d110f40 = `IkNVAG_triangleSmall`;
$97298b71fd48c7ca$export$e98eeeacc5b03201 = `IkNVAG_triangleTop`;


var $9075825f9ae05832$exports = {};
$9075825f9ae05832$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 72 144\" xml:space=\"preserve\">\n\t<path fill=\"#FBFBFB\" d=\"M72,144c-39.8,0-72-32.2-72-72S32.2,0,72,0V144z\"/>\n</svg>";


var $cf2f69190e9a317b$exports = {};
$cf2f69190e9a317b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 72 144\" xml:space=\"preserve\">\n\t<path fill=\"#3D3547\" d=\"M0,0c39.8,0,72,32.2,72,72s-32.2,72-72,72V0z\"/>\n</svg>";


var $d1412ad09d7a256b$exports = {};
$d1412ad09d7a256b$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 150 228\" xml:space=\"preserve\">\n\t<rect fill=\"url(#noise-pattern)\" width=\"150\" height=\"228\"/>\n</svg>";


var $018734fbf248528e$exports = {};
$018734fbf248528e$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 91.8 183.7\" xml:space=\"preserve\">\n\t<path fill=\"#3D3547\" d=\"M0,0l0,183.7c50.7,0,91.8-41.1,91.8-91.8S50.7,0,0,0\"/>\n</svg>";


var $a941c2c685d83b94$exports = {};
$a941c2c685d83b94$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 176.8 274\" xml:space=\"preserve\">\n\t<polygon fill=\"url(#noise-pattern)\" points=\"176.8,274 0,0 176.8,0 \"/>\n</svg>";


var $1d45e86e75ea09dd$exports = {};
$1d45e86e75ea09dd$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 182.2 182.2\" xml:space=\"preserve\">\n\t<polygon fill=\"#FBFBFB\" points=\"182.2,182.2 0,182.2 182.2,0 \"/>\n</svg>";


var $5525c4aa1afce507$exports = {};
$5525c4aa1afce507$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 332 332\" xml:space=\"preserve\">\n\t<polygon fill=\"#3D3547\" points=\"0,332 0,0 332,0 \"/>\n</svg>";


var $f9e79f52eaa90cd6$exports = {};
$f9e79f52eaa90cd6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 332 332\" xml:space=\"preserve\">\n<polygon fill=\"#FBFBFB\" points=\"332,0 332,332 0,332 \"/>\n</svg>";


var $aba4aa1c450c463d$exports = {};
$aba4aa1c450c463d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 266.2 517.8\" xml:space=\"preserve\">\n<polygon fill=\"url(#noise-pattern)\" points=\"266.2,0 266.2,517.8 0,517.8 \"/>\n</svg>";


var $869eb231bbb49d8f$exports = {};
$869eb231bbb49d8f$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 221 342.4\" xml:space=\"preserve\">\n\t<polygon fill=\"url(#noise-pattern)\" points=\"221,342.4 0,0 221,0 \"/>\n</svg>";


var $cc97adda76a23239$exports = {};
$cc97adda76a23239$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 227.6 227.6\" xml:space=\"preserve\">\n\t<rect fill=\"#3D3547\" width=\"227.6\" height=\"227.6\"/>\n</svg>";


var $e5f99c8fc0654722$exports = {};
$e5f99c8fc0654722$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 113.8 227.6\" xml:space=\"preserve\">\n\t<path fill=\"#FBFBFB\" d=\"M0,0l0,227.6c62.9,0,113.8-51,113.8-113.8S62.9,0,0,0z\"/>\n</svg>";


class $2e49560d8b40682c$export$2e2bcd8739ae039 extends (0, $boE4X.Component) {
    render() {
        return /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
            className: $97298b71fd48c7ca$export$e8e78c978b129247,
            children: [
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                    className: $97298b71fd48c7ca$export$c12064b3701ae903,
                    children: [
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                100,
                                -100
                            ],
                            className: $97298b71fd48c7ca$export$9e8683ef47fbbcb9,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($9075825f9ae05832$exports)))
                            })
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($d1412ad09d7a256b$exports)))
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                -100,
                                100
                            ],
                            className: $97298b71fd48c7ca$export$5913546000bd8f0d,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($cf2f69190e9a317b$exports)))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                    className: $97298b71fd48c7ca$export$7617e27f7bdf4181,
                    children: [
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($018734fbf248528e$exports))),
                            className: $97298b71fd48c7ca$export$28ee4a8d3e114531
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                -30,
                                30
                            ],
                            className: $97298b71fd48c7ca$export$afb5242d61ffc89f,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($a941c2c685d83b94$exports)))
                            })
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                30,
                                -30
                            ],
                            className: $97298b71fd48c7ca$export$afd578b46d110f40,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($1d45e86e75ea09dd$exports)))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                    className: $97298b71fd48c7ca$export$4ed94178d58f2369,
                    children: [
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                60,
                                -20
                            ],
                            className: $97298b71fd48c7ca$export$e98eeeacc5b03201,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($5525c4aa1afce507$exports)))
                            })
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($f9e79f52eaa90cd6$exports))),
                            className: $97298b71fd48c7ca$export$e98eeeacc5b03201
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                -60,
                                60
                            ],
                            className: $97298b71fd48c7ca$export$afb5242d61ffc89f,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($aba4aa1c450c463d$exports)))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                    className: $97298b71fd48c7ca$export$a66c2d07ca5eabd8,
                    children: [
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($cc97adda76a23239$exports))),
                            className: $97298b71fd48c7ca$export$dd4f28cef696bc7d
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                -60,
                                60
                            ],
                            className: $97298b71fd48c7ca$export$9eed783d03e0135c,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($869eb231bbb49d8f$exports)))
                            })
                        }),
                        /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                            translateY: [
                                -30,
                                30
                            ],
                            className: $97298b71fd48c7ca$export$5913546000bd8f0d,
                            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                                svg: (0, (/*@__PURE__*/$parcel$interopDefault($e5f99c8fc0654722$exports)))
                            })
                        })
                    ]
                })
            ]
        });
    }
}



parcelRequire("boE4X");
var $ea8585ad9655b3ed$export$ebab4d356bf76af6;
var $ea8585ad9655b3ed$export$34e0f9847d4c02dd;
var $ea8585ad9655b3ed$export$e8e78c978b129247;
$ea8585ad9655b3ed$export$ebab4d356bf76af6 = `LmOxQa_circleRings`;
$ea8585ad9655b3ed$export$34e0f9847d4c02dd = `LmOxQa_container`;
$ea8585ad9655b3ed$export$e8e78c978b129247 = `LmOxQa_root`;




var $9e54418e4e538fb5$exports = {};
$9e54418e4e538fb5$exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 550 550\" enable-background=\"new 0 0 550 550\" xml:space=\"preserve\">\n\t<circle fill=\"url(#dot-pattern)\" cx=\"275\" cy=\"275\" r=\"250\"/>\n</svg>";


var $7a25a6d4e7a43471$exports = {};
$7a25a6d4e7a43471$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 550 550\" xml:space=\"preserve\">\n\t<path fill=\"#FBFCFC\" d=\"M276.1,25l-86.3,485.1c26.6,9.6,55.3,14.9,85.2,14.9c138.1,0,250-111.9,250-250C525,137.3,413.7,25.6,276.1,25\n\t\tz\"/>\n\t<g fill=\"#FFFFFF\">\n\t\t<path d=\"M73.3,273.5c0,81.3,50.1,155.1,125.4,186.1l0.7-4C126,424.9,77.3,352.9,77.3,273.5\n\t\t\tc0-106.2,84.4-193.1,189.7-197.2l0.7-4C159.9,76,73.3,164.8,73.3,273.5z\"/>\n\t\t<path d=\"M101.6,272.7c0-91.4,71.2-166.5,161.1-172.6l0.7-4C171,101.9,97.7,178.9,97.7,272.7\n\t\t\tc0,69.5,41.9,132.8,105.6,161.4l0.7-4C142.2,402,101.6,340.4,101.6,272.7z\"/>\n\t\t<path d=\"M249.6,173.6l0.8-4.3c-45.6,11.1-79.7,52.3-79.7,101.3c0,21.6,7.2,42.5,20.7,60.5\n\t\t\tc7.2,9.5,15.9,17.8,25.8,24.6l0.8-4.3c-8.9-6.3-16.8-14-23.4-22.7c-13-17.3-19.9-37.4-19.9-58.1\n\t\t\tC174.7,224,206.6,184.8,249.6,173.6z\"/>\n\t\t<path d=\"M126,272c0-76.5,58.1-139.7,132.4-147.9l0.7-4.1c-76.9,7.8-137.1,73-137.1,152c0,57.7,33.8,110.5,85.8,136.5\n\t\t\tl0.7-4.1C158.5,378.9,126,327.8,126,272z\"/>\n\t\t<path d=\"M190.5,506.1c-47-17.1-87.2-47.7-116.3-88.5c-29.8-41.8-45.6-91.1-45.6-142.7c0-65.7,25.6-127.4,72-173.9\n\t\t\tC147,54.6,208.8,29,274.5,29l0.9,0l0.2-1l0-3l-0.5,0c-0.2,0-0.4,0-0.6,0C207.7,25,145,51,97.8,98.2S24.6,208.2,24.6,274.9\n\t\t\tc0,52.4,16,102.5,46.3,145c29.7,41.6,70.6,72.7,118.4,90l1-2.8L190.5,506.1z\"/>\n\t\t<path d=\"M244.9,200.1l0.8-4.6c-29.6,11.7-50.6,40.6-50.6,74.3c0,21.7,10.4,42.7,27.1,57.8l0.8-4.6\n\t\t\tc-14.9-14.2-24-33.4-24-53.2C199.1,238.7,218,211.8,244.9,200.1z\"/>\n\t\t<path d=\"M48.9,274.2c0,47.2,14.5,92.5,42.1,130.9c26.1,36.4,61.7,63.9,103.2,79.8l0.7-4\n\t\t\tc-40.5-15.7-75.3-42.6-100.7-78.2c-27-37.7-41.3-82.2-41.3-128.6c0-59.2,23.1-114.9,64.9-156.7c41.1-41.1,95.4-64,153.3-64.9\n\t\t\tl0.7-4c-59.3,0.7-114.9,24.1-156.9,66C72.4,157.3,48.9,213.9,48.9,274.2z\"/>\n\t\t<path d=\"M174.6,343.5c-15.8-21.4-24.2-46.3-24.2-72.2c0-61.6,44.9-112.8,103.7-122.8l0.7-4.1\n\t\t\tc-61.4,9.6-108.4,62.9-108.4,126.9c0,26.7,8.6,52.5,25,74.6c11,14.8,25.1,27.3,41.1,36.5l0.7-4.1\n\t\t\tC198.2,369.3,184.9,357.5,174.6,343.5z\"/>\n\t</g>\n</svg>";


const $6521a12f95522307$var$Overlap = ()=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("div", {
        className: $ea8585ad9655b3ed$export$e8e78c978b129247,
        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
            className: $ea8585ad9655b3ed$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                    translateY: [
                        -50,
                        50
                    ],
                    translateX: [
                        -40,
                        20
                    ],
                    children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                        svg: (0, (/*@__PURE__*/$parcel$interopDefault($9e54418e4e538fb5$exports)))
                    })
                }),
                /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                    translateY: [
                        -50,
                        50
                    ],
                    translateX: [
                        40,
                        -20
                    ],
                    className: $ea8585ad9655b3ed$export$ebab4d356bf76af6,
                    children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                        svg: (0, (/*@__PURE__*/$parcel$interopDefault($7a25a6d4e7a43471$exports)))
                    })
                })
            ]
        })
    });
var $6521a12f95522307$export$2e2bcd8739ae039 = $6521a12f95522307$var$Overlap;



parcelRequire("boE4X");
var $9151848e1f1e9ac7$export$3b6591e92b7ddb5b;
var $9151848e1f1e9ac7$export$34e0f9847d4c02dd;
var $9151848e1f1e9ac7$export$784d13d8ee351f07;
var $9151848e1f1e9ac7$export$516dd90aeaaabcf0;
var $9151848e1f1e9ac7$export$e8e78c978b129247;
var $9151848e1f1e9ac7$export$20acd82365cff58b;
$9151848e1f1e9ac7$export$3b6591e92b7ddb5b = `_40Yq-W_angleTop`;
$9151848e1f1e9ac7$export$34e0f9847d4c02dd = `_40Yq-W_container`;
$9151848e1f1e9ac7$export$784d13d8ee351f07 = `_40Yq-W_copy`;
$9151848e1f1e9ac7$export$516dd90aeaaabcf0 = `_40Yq-W_headline`;
$9151848e1f1e9ac7$export$e8e78c978b129247 = `_40Yq-W_root`;
$9151848e1f1e9ac7$export$20acd82365cff58b = `_40Yq-W_trianglesPurple`;




var $6ff85a26c8a6cc28$exports = {};
$6ff85a26c8a6cc28$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 486 712\" style=\"enable-background:new 0 0 486 712\" xml:space=\"preserve\">\n\t<g fill=\"url(#noise-pattern)\">\n\t\t<polygon points=\"274.4,178.5 291.1,89.7 379.9,89.7 \t\"/>\n\t\t<polygon points=\"363.1,178.5 379.9,89.7 468.6,89.7 \t\"/>\n\t\t<polygon points=\"96.8,178.5 113.6,89.7 202.4,89.7 \t\"/>\n\t\t<polygon points=\"185.6,178.5 202.4,89.7 291.1,89.7 \t\"/>\n\t\t<polygon points=\"242.1,356 258.8,267.2 347.6,267.2 \t\"/>\n\t\t<polygon points=\"330.9,356 347.6,267.2 436.4,267.2 \t\"/>\n\t\t<polygon points=\"64.6,356 81.3,267.2 170.1,267.2 \t\"/>\n\t\t<polygon points=\"153.3,356 170.1,267.2 258.8,267.2 \t\"/>\n\t\t<polygon points=\"209.8,533.5 226.6,444.8 315.3,444.8 \t\"/>\n\t\t<polygon points=\"298.6,533.5 315.3,444.8 404.1,444.8 \t\"/>\n\t\t<polygon points=\"32.3,533.5 49,444.8 137.8,444.8 \t\"/>\n\t\t<polygon points=\"121,533.5 137.8,444.8 226.6,444.8 \t\"/>\n\t\t<polygon points=\"177.5,711 194.3,622.3 283,622.3 \t\"/>\n\t\t<polygon points=\"266.3,711 283,622.3 371.8,622.3 \t\"/>\n\t\t<polygon points=\"0,711 16.8,622.3 105.5,622.3 \t\"/>\n\t\t<polygon points=\"88.8,711 105.5,622.3 194.3,622.3 \t\"/>\n\t</g>\n</svg>";


var $cee06dff98f63d63$exports = {};
$cee06dff98f63d63$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 486 712\" enable-background=\"new 0 0 486 712\" xml:space=\"preserve\">\n\t\t<polygon fill=\"#EDEAEA\" points=\"308.2,0.9 291.4,89.7 202.7,89.7 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"218.2,0.9 201.4,89.7 112.7,89.7 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"396.9,0.9 380.2,89.7 291.4,89.7 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"485.7,0.9 468.9,89.7 380.2,89.7 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"275.9,178.5 259.1,267.2 170.4,267.2 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"185.9,178.5 169.2,267.2 80.4,267.2 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"364.7,178.5 347.9,267.2 259.1,267.2 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"453.4,178.5 436.7,267.2 347.9,267.2 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"242.4,356 225.6,444.8 136.9,444.8 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"153.6,356 136.9,444.8 48.1,444.8 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"332.4,356 315.6,444.8 226.9,444.8 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"421.1,356 404.4,444.8 315.6,444.8 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"210.1,533.5 193.4,622.3 104.6,622.3 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"121.3,533.5 104.6,622.3 15.8,622.3 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"300.1,533.5 283.3,622.3 194.6,622.3 \t\t\"/>\n\t\t<polygon fill=\"#EDEAEA\" points=\"388.9,533.5 372.1,622.3 283.3,622.3 \t\t\"/>\n</svg>";


var $23fa3ba978e19db3$exports = {};
$23fa3ba978e19db3$exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" version=\"1.1\" id=\"Layer_1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1439.5 229.5\" enable-background=\"new 0 0 1439.5 229.5\" xml:space=\"preserve\">\n<polygon fill=\"#3D3547\" points=\"1440.5,230 0,229.5 1440,-0.5 \"/>\n</svg>";


const $e53dca0634bbcc4b$var$TriangleGrid = ()=>/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("main", {
        className: $9151848e1f1e9ac7$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                svg: (0, (/*@__PURE__*/$parcel$interopDefault($23fa3ba978e19db3$exports))),
                className: $9151848e1f1e9ac7$export$3b6591e92b7ddb5b
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("article", {
                className: $9151848e1f1e9ac7$export$784d13d8ee351f07,
                children: [
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("h1", {
                        className: $9151848e1f1e9ac7$export$516dd90aeaaabcf0,
                        children: "React Scroll Parallax"
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("p", {
                        children: "React hooks and components to create parallax scroll effects for banners, images or any other DOM elements."
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("p", {
                        children: [
                            "Utilizes",
                            " ",
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("a", {
                                href: "https://parallax-controller.damnthat.tv/",
                                children: "Parallax Controller"
                            }),
                            " ",
                            "to add vertical or horizontal scrolling based effects to elements.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("a", {
                                href: "https://parallax-controller.damnthat.tv/docs/performance",
                                children: "Optimized"
                            }),
                            " ",
                            "to reduce jank on scroll and works with SSR and SSG rendered React apps."
                        ]
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("code", {
                                children: "yarn add react-scroll-parallax"
                            }),
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("code", {
                                children: "npm i react-scroll-parallax"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("a", {
                                className: "btn",
                                href: "https://react-scroll-parallax.damnthat.tv/",
                                children: "Documentation"
                            }),
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("a", {
                                className: "btn",
                                href: "https://github.com/jscottsmith/react-scroll-parallax",
                                children: "GitHub"
                            }),
                            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)("a", {
                                className: "btn",
                                href: "https://www.npmjs.com/package/react-scroll-parallax",
                                children: "View on NPM"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsxs)("div", {
                className: $9151848e1f1e9ac7$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        translateY: [
                            -25,
                            25
                        ],
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($6ff85a26c8a6cc28$exports))),
                            className: $9151848e1f1e9ac7$export$20acd82365cff58b
                        })
                    }),
                    /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$1bc430945f060dd1), {
                        translateX: [
                            -13,
                            13
                        ],
                        translateY: [
                            -50,
                            50
                        ],
                        children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $cd21475d315d2010$export$2e2bcd8739ae039), {
                            svg: (0, (/*@__PURE__*/$parcel$interopDefault($cee06dff98f63d63$exports)))
                        })
                    })
                ]
            })
        ]
    });
var $e53dca0634bbcc4b$export$2e2bcd8739ae039 = $e53dca0634bbcc4b$var$TriangleGrid;





class $4eef09164ef8f3da$export$2e2bcd8739ae039 extends (0, $boE4X.Component) {
    render() {
        return /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $18460a4df4d3d541$export$df63e15c6fb592aa), {
            children: /*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $129944502fcf86f8$export$2e2bcd8739ae039), {})
        });
    }
}


const $a11a9c6e8b9ec4bb$var$root = document.getElementById("root");
(0, (/*@__PURE__*/$parcel$interopDefault($49f04caac7e99876$exports))).render(/*#__PURE__*/ (0, $2b9e21b4a13fb787$exports.jsx)((0, $4eef09164ef8f3da$export$2e2bcd8739ae039), {}), $a11a9c6e8b9ec4bb$var$root);


//# sourceMappingURL=original.2050e953.js.map
